import UnifiedMessagesModule from "../components/UnifiedMessagesModule";
import TikTokAnalyticsSuite from "../components/TikTokAnalyticsSuite";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

const ADMIN_THEME_STYLES = `
  .wm-admin-theme {
    --admin-gold: #d6a800;
    --admin-gold-dark: #9b7600;
    --admin-gold-soft: #fff8df;
    --admin-page: #f4f6f8;
    --admin-surface: #ffffff;
    --admin-surface-soft: #f8fafc;
    --admin-text: #182230;
    --admin-text-soft: #475467;
    --admin-muted: #667085;
    --admin-border: #d9dee7;
  }

  /* Tema anahtarı */
  .wm-admin-theme-switch {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px;
    border: 1px solid rgba(255,255,255,.10);
    border-radius: 12px;
    background: rgba(255,255,255,.035);
  }

  .wm-admin-theme-button {
    min-height: 32px;
    padding: 0 11px;
    border: 1px solid transparent;
    border-radius: 9px;
    font-size: 11px;
    font-weight: 700;
    transition: background-color .15s ease, color .15s ease, border-color .15s ease;
  }

  .wm-admin-dark .wm-admin-theme-button {
    color: rgba(255,255,255,.55);
  }

  .wm-admin-dark .wm-admin-theme-button.is-active {
    background: #eab308;
    border-color: rgba(250,204,21,.55);
    color: #080808;
  }

  /* ================================================================
     AÇIK TEMA
     Mevcut JSX, API, state ve işlem fonksiyonlarına dokunmaz.
     ================================================================ */
  .wm-admin-light {
    background: var(--admin-page) !important;
    color: var(--admin-text) !important;
    color-scheme: light;
  }

  /* Koyu temanın dekoratif sabit arka planlarını açık modda gizle.
     z-50 modal overlay'leri etkilenmez. */
  .wm-admin-light > .fixed.inset-0:not(.z-50) {
    display: none !important;
  }

  .wm-admin-light main {
    background: var(--admin-page) !important;
    color: var(--admin-text) !important;
  }

  .wm-admin-light aside {
    background: #ffffff !important;
    border-color: var(--admin-border) !important;
    box-shadow: 1px 0 0 rgba(16,24,40,.03);
  }

  /* Ana yüzeyler */
  .wm-admin-light [class*="bg-white/"] {
    background-color: var(--admin-surface) !important;
  }

  .wm-admin-light [class*="bg-black/"]:not([class*="fixed"]) {
    background-color: var(--admin-surface-soft) !important;
  }

  .wm-admin-light [class*="bg-[#070707]"],
  .wm-admin-light [class*="bg-[#080808]"],
  .wm-admin-light [class*="bg-[#090909]"],
  .wm-admin-light [class*="bg-[#0a0a0a]"],
  .wm-admin-light [class*="bg-[#0b0b0b]"],
  .wm-admin-light [class*="bg-[#101010]"] {
    background-color: #ffffff !important;
  }

  /* Modal overlay koyu kalır, modal kartı açık olur */
  .wm-admin-light [class*="fixed"][class*="inset-0"][class*="bg-black"] {
    background-color: rgba(15,23,42,.48) !important;
  }

  .wm-admin-light [class*="fixed"][class*="inset-0"] > [class*="bg-[#0b0b0b]"] {
    background-color: #ffffff !important;
  }

  /* Yazılar */
  .wm-admin-light [class~="text-white"] {
    color: var(--admin-text) !important;
  }

  .wm-admin-light [class*="text-white/"] {
    color: var(--admin-muted) !important;
  }

  .wm-admin-light [class*="text-yellow-"] {
    color: var(--admin-gold-dark) !important;
  }

  .wm-admin-light [class*="fill-white"] {
    fill: #667085 !important;
  }

  .wm-admin-light [class*="fill-yellow"] {
    fill: #9b7600 !important;
  }

  /* Border'lar */
  .wm-admin-light [class*="border-white"] {
    border-color: var(--admin-border) !important;
  }

  .wm-admin-light [class*="border-yellow-"] {
    border-color: rgba(183,137,0,.34) !important;
  }

  /* Gold soft alanlar */
  .wm-admin-light [class*="bg-yellow-500/"],
  .wm-admin-light [class*="bg-yellow-400/"] {
    background-color: var(--admin-gold-soft) !important;
  }

  /* Ana gold butonlar orijinal karakterini korur */
  .wm-admin-light [class~="bg-yellow-500"] {
    background-color: #eab308 !important;
    color: #111111 !important;
    border-color: #d6a800 !important;
  }

  .wm-admin-light [class~="hover:bg-yellow-500"]:hover,
  .wm-admin-light [class~="hover:bg-yellow-400"]:hover {
    background-color: #facc15 !important;
    color: #111111 !important;
  }

  /* Semantik renkler açık zeminde okunaklı */
  .wm-admin-light [class*="text-green-"],
  .wm-admin-light [class*="text-emerald-"] {
    color: #067647 !important;
  }

  .wm-admin-light [class*="bg-green-"],
  .wm-admin-light [class*="bg-emerald-"] {
    background-color: #ecfdf3 !important;
  }

  .wm-admin-light [class*="border-green-"],
  .wm-admin-light [class*="border-emerald-"] {
    border-color: #abefc6 !important;
  }

  .wm-admin-light [class*="text-red-"] {
    color: #b42318 !important;
  }

  .wm-admin-light [class*="bg-red-"] {
    background-color: #fef3f2 !important;
  }

  .wm-admin-light [class*="border-red-"] {
    border-color: #fecdca !important;
  }

  .wm-admin-light [class*="text-fuchsia-"] {
    color: #8b3fa4 !important;
  }

  .wm-admin-light [class*="bg-fuchsia-"] {
    background-color: #fdf4ff !important;
  }

  .wm-admin-light [class*="border-fuchsia-"] {
    border-color: #f0abfc !important;
  }

  .wm-admin-light [class*="text-cyan-"] {
    color: #0e7490 !important;
  }

  .wm-admin-light [class*="bg-cyan-"] {
    background-color: #ecfeff !important;
  }

  .wm-admin-light [class*="border-cyan-"] {
    border-color: #a5f3fc !important;
  }

  /* Form alanları */
  .wm-admin-light input,
  .wm-admin-light select,
  .wm-admin-light textarea,
  .wm-admin-light .form-input,
  .wm-admin-light .form-textarea {
    background: #ffffff !important;
    color: var(--admin-text) !important;
    border-color: #cfd6df !important;
    color-scheme: light !important;
  }

  .wm-admin-light input::placeholder,
  .wm-admin-light textarea::placeholder {
    color: #98a2b3 !important;
  }

  .wm-admin-light input:focus,
  .wm-admin-light select:focus,
  .wm-admin-light textarea:focus,
  .wm-admin-light .form-input:focus,
  .wm-admin-light .form-textarea:focus {
    border-color: #c99a12 !important;
    box-shadow: 0 0 0 3px rgba(201,154,18,.10) !important;
  }

  .wm-admin-light option {
    background: #ffffff !important;
    color: #182230 !important;
  }

  /* Kart ve tablo hiyerarşisi */
  .wm-admin-light [class*="shadow-[0_18px"],
  .wm-admin-light [class*="shadow-[0_20px"] {
    box-shadow:
      0 1px 2px rgba(16,24,40,.03),
      0 8px 24px rgba(16,24,40,.055) !important;
  }

  .wm-admin-light [class*="uppercase"][class*="bg-white/"] {
    background-color: #f7f8fa !important;
  }

  .wm-admin-light [class*="hover:bg-white"]:hover {
    background-color: #f8fafc !important;
  }

  .wm-admin-light [class*="hover:bg-yellow"]:hover {
    background-color: #fff9e8 !important;
  }

  /* Accordion / aktif menü */
  .wm-admin-light aside button {
    color: #344054;
  }

  .wm-admin-light aside button:hover {
    background-color: #f8fafc !important;
  }

  .wm-admin-light aside [class*="bg-yellow-500/"] {
    background-color: #fff8df !important;
    color: #8a6800 !important;
    border-color: rgba(183,137,0,.32) !important;
  }

  /* Grafik ve koyu özel yüzeyleri açık moda taşı */
  .wm-admin-light [class*="bg-[radial-gradient"] {
    background:
      radial-gradient(circle at top right, rgba(234,179,8,.10), transparent 30%),
      linear-gradient(180deg,#ffffff 0%,#f4f6f8 100%) !important;
  }

  .wm-admin-light svg > rect[fill="rgba(0,0,0,0.18)"] {
    fill: rgba(255,255,255,.72) !important;
  }

  /* Tema anahtarı açık mod */
  .wm-admin-light .wm-admin-theme-switch {
    background: #eef1f5;
    border-color: #d9dee7;
  }

  .wm-admin-light .wm-admin-theme-button {
    color: #667085;
  }

  .wm-admin-light .wm-admin-theme-button.is-active {
    background: #ffffff;
    border-color: #d7b64a;
    color: #9b7600;
    box-shadow: 0 1px 3px rgba(16,24,40,.08);
  }

  /* Scrollbar */
  .wm-admin-light * {
    scrollbar-color: rgba(183,137,0,.50) #eef1f4;
  }

  /* ================================================================
     AÇIK TEMA V3
     Sadece görsel katman:
     - Yazılar daha net ve koyu
     - Kart/kutu yüzeyleri yumuşak geçişli gri
     - Mevcut işlev, API, state ve JSX akışı değiştirilmez
     ================================================================ */

  .wm-admin-light {
    --admin-page: #eef2f6;
    --admin-surface: #f6f8fa;
    --admin-surface-soft: #e9eef3;
    --admin-text: #101828;
    --admin-text-soft: #1d2939;
    --admin-muted: #475467;
    --admin-border: #cbd5df;
  }

  /* Genel zemin */
  .wm-admin-light,
  .wm-admin-light main {
    background:
      linear-gradient(
        180deg,
        #f4f6f8 0%,
        #eef2f5 45%,
        #e8edf2 100%
      ) !important;
  }

  /* Başlıklar ve ana metinler daha net */
  .wm-admin-light h1,
  .wm-admin-light h2,
  .wm-admin-light h3,
  .wm-admin-light h4,
  .wm-admin-light [class~="text-white"] {
    color: #101828 !important;
  }

  .wm-admin-light [class*="text-white/82"],
  .wm-admin-light [class*="text-white/80"],
  .wm-admin-light [class*="text-white/78"],
  .wm-admin-light [class*="text-white/68"],
  .wm-admin-light [class*="text-white/65"] {
    color: #1d2939 !important;
  }

  .wm-admin-light [class*="text-white/55"],
  .wm-admin-light [class*="text-white/48"],
  .wm-admin-light [class*="text-white/46"],
  .wm-admin-light [class*="text-white/45"],
  .wm-admin-light [class*="text-white/40"],
  .wm-admin-light [class*="text-white/35"],
  .wm-admin-light [class*="text-white/30"],
  .wm-admin-light [class*="text-white/25"] {
    color: #475467 !important;
  }

  /* Ana kartlar ve çerçeveli kutular:
     küçük badge/buton/uyarı renklerini bozmamak için yalnızca div yüzeyleri */
  .wm-admin-light div[class*="rounded-"][class*="border"]
    :not(button) {
  }

  .wm-admin-light div[class*="rounded-"][class*="border"]
    {
    background:
      linear-gradient(
        180deg,
        #f7f9fb 0%,
        #edf1f5 48%,
        #e3e8ee 100%
      ) !important;
    border-color: #cbd4de !important;
    box-shadow:
      0 1px 2px rgba(16,24,40,.035),
      0 8px 24px rgba(16,24,40,.06) !important;
  }

  /* Semantik / durum kutuları kendi renklerini korusun */
  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-red-"] {
    background: #fef3f2 !important;
    border-color: #fecdca !important;
  }

  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-green-"],
  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-emerald-"] {
    background: #ecfdf3 !important;
    border-color: #abefc6 !important;
  }

  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-yellow-"] {
    background:
      linear-gradient(
        180deg,
        #fff9e9 0%,
        #f7edc8 100%
      ) !important;
    border-color: rgba(183,137,0,.32) !important;
  }

  /* Header ve büyük ana paneller biraz daha belirgin */
  .wm-admin-light header[class*="rounded-"],
  .wm-admin-light main > div > div[class*="rounded-"][class*="border"] {
    background:
      linear-gradient(
        180deg,
        #f8fafc 0%,
        #edf1f5 50%,
        #e1e7ed 100%
      ) !important;
    border-color: #c7d0da !important;
  }

  /* Stat kartlar */
  .wm-admin-light .grid > div[class*="rounded-"][class*="border"] {
    background:
      linear-gradient(
        180deg,
        #f7f9fb 0%,
        #edf1f5 52%,
        #e2e7ed 100%
      ) !important;
  }

  /* Form alanları daha okunaklı */
  .wm-admin-light input,
  .wm-admin-light select,
  .wm-admin-light textarea,
  .wm-admin-light .form-input,
  .wm-admin-light .form-textarea {
    background:
      linear-gradient(
        180deg,
        #ffffff 0%,
        #f4f7fa 100%
      ) !important;
    color: #101828 !important;
    border-color: #c7d0da !important;
  }

  .wm-admin-light input::placeholder,
  .wm-admin-light textarea::placeholder {
    color: #7d8999 !important;
  }

  /* Tablolar */
  .wm-admin-light thead {
    background:
      linear-gradient(
        180deg,
        #f5f7fa 0%,
        #e9eef3 100%
      ) !important;
  }

  .wm-admin-light tbody tr {
    background: rgba(247,249,251,.78) !important;
  }

  .wm-admin-light tbody tr:nth-child(even) {
    background: rgba(238,242,246,.92) !important;
  }

  .wm-admin-light tbody tr:hover {
    background: rgba(255,248,222,.70) !important;
  }

  /* Performans / grafik gibi radial-gradient kullanan büyük kutular */
  .wm-admin-light [class*="bg-[radial-gradient"] {
    background:
      radial-gradient(
        circle at top right,
        rgba(234,179,8,.10),
        transparent 26%
      ),
      linear-gradient(
        180deg,
        #edf1f5 0%,
        #e2e7ed 52%,
        #d8dee5 100%
      ) !important;
    border-color: #c5ced8 !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,.72),
      0 10px 28px rgba(16,24,40,.07) !important;
  }

  /* Grafik iç yüzeyi */
  .wm-admin-light svg > rect[fill="rgba(0,0,0,0.18)"] {
    fill: rgba(255,255,255,.78) !important;
  }

  .wm-admin-light svg [class*="fill-yellow-"] {
    fill: #8f6a00 !important;
  }

  /* Sol menü metinleri net */
  .wm-admin-light aside button,
  .wm-admin-light aside span {
    color: #253247;
  }

  /* Gold vurgular açık temada koyu ve belirgin */
  .wm-admin-light [class*="text-yellow-"] {
    color: #8f6a00 !important;
  }

  /* Butonlar arka plan gradyanlarından etkilenmesin */
  .wm-admin-light button[class*="bg-yellow-500"] {
    background: #eab308 !important;
    color: #101010 !important;
    border-color: #d6a800 !important;
    box-shadow: none !important;
  }

  .wm-admin-light button[class*="bg-white"],
  .wm-admin-light button[class*="bg-black"],
  .wm-admin-light button[class*="bg-[#"] {
    background: #f8fafc !important;
    color: #1d2939 !important;
    border-color: #cbd5df !important;
  }

  /* Tema seçici */
  .wm-admin-light .wm-admin-theme-switch {
    background:
      linear-gradient(180deg,#f3f6f9 0%,#e5eaf0 100%) !important;
    border-color: #cbd5df !important;
  }

  .wm-admin-light .wm-admin-theme-button {
    background: transparent !important;
    color: #667085 !important;
    box-shadow: none !important;
  }

  .wm-admin-light .wm-admin-theme-button.is-active {
    background: #ffffff !important;
    color: #8f6a00 !important;
    border-color: #d7b64a !important;
    box-shadow: 0 1px 3px rgba(16,24,40,.08) !important;
  }

`;

function usePublisherThemeStyles(theme) {
  useEffect(() => {
    const styleId = "wm-publisher-admin-theme-style";
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement("style");
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = ADMIN_THEME_STYLES + `
      .wm-admin-light svg text {
        fill: #0f172a !important;
        font-weight: 700 !important;
      }
      .wm-admin-light svg line[stroke*="255,255,255"] {
        stroke: rgba(0, 0, 0, 0.12) !important;
      }
      .wm-admin-light .publisher-card,
      .wm-admin-light .publisher-panel,
      .wm-admin-light .publisher-stat-card {
        background: #ffffff !important;
        border-color: #cbd5e1 !important;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
        color: #000000 !important;
      }

      .wm-admin-light main {
        background-color: #f4f6f8 !important;
      }

      .wm-admin-light header,
      .wm-admin-light .publisher-topbar {
        background-color: #ffffff !important;
        border-color: #e2e8f0 !important;
        color: #000000 !important;
      }
    `;

    if (typeof document !== "undefined") {
      if (theme === "light") {
        document.body.style.backgroundColor = "#f4f6f8";
        document.body.style.color = "#111827";
        document.documentElement.classList.remove("dark");
      } else {
        document.body.style.backgroundColor = "#0b0b0e";
        document.body.style.color = "#ffffff";
        document.documentElement.classList.add("dark");
      }
    }
  }, [theme]);
}

function getInitialPublisherTheme() {
  try {
    if (typeof window === "undefined") return "dark";
    const saved = localStorage.getItem("wm_publisher_theme");
    if (saved === "light" || saved === "dark") return saved;
    return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
  } catch {
    return "dark";
  }
}


// Yalnızca telefon ve tablet görünümünü sıkılaştırır.
// Masaüstü stilleri, veri akışı ve işlem fonksiyonları değiştirilmez.
function useMobileOnlyResponsiveLayout(scopeClass, enabled = true) {
  useEffect(() => {
    if (!enabled || typeof document === "undefined") return undefined;

    const bodyClass = `${scopeClass}-active`;
    const styleId = `${scopeClass}-style`;
    document.body.classList.add(bodyClass);

    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      const scope = `body.${bodyClass}`;

      style.textContent = `
        @media (max-width: 1023px) {
          ${scope},
          ${scope} #root {
            width: 100%;
            max-width: 100%;
            overflow-x: hidden;
          }

          ${scope} main {
            width: 100%;
            min-width: 0;
            max-width: 100vw;
          }

          ${scope} table {
            display: block;
            width: 100%;
            max-width: 100%;
            overflow-x: auto;
            overscroll-behavior-inline: contain;
            -webkit-overflow-scrolling: touch;
          }

          ${scope} iframe,
          ${scope} video,
          ${scope} canvas {
            max-width: 100%;
          }

          ${scope} [class*="fixed"][class*="inset-0"] {
            overflow-y: auto;
            overscroll-behavior: contain;
          }
        }

        @media (max-width: 767px) {
          ${scope} {
            font-size: 13px;
            -webkit-text-size-adjust: 100%;
            text-size-adjust: 100%;
          }

          ${scope} *,
          ${scope} *::before,
          ${scope} *::after {
            box-sizing: border-box;
          }

          ${scope} h1,
          ${scope} [class~="text-5xl"],
          ${scope} [class~="text-4xl"] {
            font-size: clamp(1.7rem, 7.5vw, 2rem) !important;
            line-height: 1.12 !important;
            letter-spacing: -0.025em !important;
          }

          ${scope} h2,
          ${scope} [class~="text-3xl"] {
            font-size: clamp(1.35rem, 5.8vw, 1.6rem) !important;
            line-height: 1.18 !important;
          }

          ${scope} h3,
          ${scope} [class~="text-2xl"] {
            font-size: 1.15rem !important;
            line-height: 1.25 !important;
          }

          ${scope} [class~="text-xl"] {
            font-size: 1rem !important;
            line-height: 1.35 !important;
          }

          ${scope} p,
          ${scope} li {
            line-height: 1.55;
          }

          ${scope} [class~="p-10"],
          ${scope} [class~="p-9"],
          ${scope} [class~="p-8"],
          ${scope} [class~="p-7"],
          ${scope} [class~="p-6"],
          ${scope} [class~="p-5"] {
            padding: 1rem !important;
          }

          ${scope} [class~="px-10"],
          ${scope} [class~="px-9"],
          ${scope} [class~="px-8"],
          ${scope} [class~="px-7"],
          ${scope} [class~="px-6"],
          ${scope} [class~="px-5"] {
            padding-left: 1rem !important;
            padding-right: 1rem !important;
          }

          ${scope} [class~="py-10"],
          ${scope} [class~="py-9"],
          ${scope} [class~="py-8"],
          ${scope} [class~="py-7"],
          ${scope} [class~="py-6"] {
            padding-top: 1rem !important;
            padding-bottom: 1rem !important;
          }

          ${scope} [class~="gap-10"],
          ${scope} [class~="gap-9"],
          ${scope} [class~="gap-8"],
          ${scope} [class~="gap-7"],
          ${scope} [class~="gap-6"],
          ${scope} [class~="gap-5"] {
            gap: 0.8rem !important;
          }

          ${scope} [class~="mt-10"],
          ${scope} [class~="mt-9"],
          ${scope} [class~="mt-8"],
          ${scope} [class~="mt-7"],
          ${scope} [class~="mt-6"] {
            margin-top: 1rem !important;
          }

          ${scope} [class~="mb-10"],
          ${scope} [class~="mb-9"],
          ${scope} [class~="mb-8"],
          ${scope} [class~="mb-7"],
          ${scope} [class~="mb-6"] {
            margin-bottom: 1rem !important;
          }

          ${scope} [class*="grid-cols-2"],
          ${scope} [class*="grid-cols-3"],
          ${scope} [class*="grid-cols-4"],
          ${scope} [class*="grid-cols-5"],
          ${scope} [class*="grid-cols-6"],
          ${scope} [class*="grid-cols-["] {
            grid-template-columns: minmax(0, 1fr) !important;
          }

          ${scope} form [class~="flex"] {
            flex-wrap: wrap;
          }

          ${scope} button,
          ${scope} [role="button"] {
            max-width: 100%;
            min-height: 38px;
            white-space: normal;
            touch-action: manipulation;
          }

          ${scope} input,
          ${scope} select,
          ${scope} textarea {
            width: 100%;
            max-width: 100%;
            min-height: 42px;
            font-size: 16px !important;
          }

          ${scope} textarea {
            min-height: 96px;
          }

          ${scope} table {
            font-size: 11px;
          }

          ${scope} th,
          ${scope} td {
            padding: 0.55rem 0.65rem !important;
            white-space: nowrap;
          }

          ${scope} svg[class*="h-["],
          ${scope} canvas[class*="h-["] {
            height: 230px !important;
            max-height: 42vh;
          }

          ${scope} iframe {
            min-height: 230px !important;
            height: 48vh !important;
          }

          ${scope} video {
            max-height: 52vh;
          }

          ${scope} img {
            max-width: 100%;
          }

          ${scope} [class*="fixed"][class*="inset-0"] {
            align-items: flex-start !important;
            padding: max(0.75rem, env(safe-area-inset-top)) 0.75rem max(0.75rem, env(safe-area-inset-bottom)) !important;
          }

          ${scope} [class*="fixed"][class*="inset-0"] > [class*="max-w-"] {
            width: 100% !important;
            max-width: 100% !important;
            max-height: calc(100dvh - 1.5rem) !important;
            margin: auto !important;
            overflow-y: auto !important;
          }

          ${scope} [class*="rounded-[2"],
          ${scope} [class*="rounded-[3"] {
            border-radius: 1.1rem !important;
          }

          ${scope} [class*="tracking-[0.3"],
          ${scope} [class*="tracking-[0.4"] {
            letter-spacing: 0.16em !important;
          }

          ${scope} [class*="max-w-7xl"],
          ${scope} [class*="max-w-6xl"],
          ${scope} [class*="max-w-5xl"],
          ${scope} [class*="max-w-4xl"],
          ${scope} [class*="max-w-3xl"] {
            max-width: 100% !important;
          }
        }

        @media (max-width: 380px) {
          ${scope} h1,
          ${scope} [class~="text-5xl"],
          ${scope} [class~="text-4xl"] {
            font-size: 1.55rem !important;
          }

          ${scope} h2,
          ${scope} [class~="text-3xl"] {
            font-size: 1.25rem !important;
          }

          ${scope} button,
          ${scope} [role="button"] {
            font-size: 11px !important;
          }
        }
      `;

      document.head.appendChild(style);
    }

    return () => {
      document.body.classList.remove(bodyClass);
    };
  }, [scopeClass, enabled]);
}
const IS_LOCAL =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const API_BASE = IS_LOCAL ? "https://www.wolfmediaajans.com" : "";

const API_PERFORMANCE_SUMMARY = `${API_BASE}/api/performance-summary.php`;
const API_MESSAGE_SEND = `${API_BASE}/api/message-send.php`;
const API_MESSAGES_LIST = `${API_BASE}/api/messages-list.php`;
const API_TRAINING_LIST = `${API_BASE}/api/training-list.php`;
const API_TRAINING_VIEW = `${API_BASE}/api/training-view.php`;
const API_REWARD_LIST = `${API_BASE}/api/reward-list.php`;
const API_FAQ_LIST = `${API_BASE}/api/faq-list.php`;
const API_NOTIFICATION_READS_LIST = `${API_BASE}/api/notification-reads-list.php`;
const API_NOTIFICATION_READ_SAVE = `${API_BASE}/api/notification-read-save.php`;
const API_TIER_REWARD_LIST = `${API_BASE}/api/tier-reward-list.php`;
const API_GIFT_WINNERS_LIST = `${API_BASE}/api/gift-winners-list.php`;
const API_GIFT_AWARD_LIST = `${API_BASE}/api/gift-award-list.php`;
const API_GIFT_WINNER_PLAN_SAVE = `${API_BASE}/api/gift-winner-plan-save.php`;
const API_AGENCY_TRACKING_GET = `${API_BASE}/api/agency-tracking-get.php`;
const API_AGENCY_TRACKING_SAVE = `${API_BASE}/api/agency-tracking-save.php`;

const Icon = ({ children }) => (
  <span className="inline-flex h-5 w-5 items-center justify-center text-base leading-none">
    {children}
  </span>
);

const NoTranslate = ({ children, className = "" }) => (
  <span translate="no" className={`notranslate ${className}`}>
    {children}
  </span>
);

function safeNumber(value) {
  return Number(value) || 0;
}

function formatNumber(value) {
  return safeNumber(value).toLocaleString("tr-TR");
}

function normalizeAgencyTrackingStatus(value) {
  const text = String(value || "Aktif").toLowerCase().trim();
  return text.includes("pasif") || text.includes("passive") || text.includes("inactive") ? "Pasif" : "Aktif";
}

function formatDateForDisplay(value) {
  if (!value) return "-";
  const [year, month, day] = String(value).split("-");
  if (!year || !month || !day) return value;
  return `${day}.${month}.${year}`;
}

const GIFT_MONTH_NAMES_TR = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık",
];

function formatGiftPeriodLabel(value) {
  const match = String(value || "").match(/^(\d{4})-(\d{2})$/);
  if (!match) return value || "-";
  return `${GIFT_MONTH_NAMES_TR[Number(match[2]) - 1] || match[2]} ${match[1]}`;
}

function formatPublisherElmas(coins) {
  const num = Math.round(Number(coins) || 0);
  if (num <= 0) return "0 Elmas";
  if (num < 1000) return `${num} Elmas`;

  const flooredTenth = Math.floor(num / 100) / 10;
  const formatted = (flooredTenth % 1 === 0)
    ? `${flooredTenth} K`
    : `${flooredTenth.toFixed(1).replace(".", ",")} K`;

  return `${formatted} Elmas`;
}

function formatJetonKStyle(coins) {
  return formatPublisherElmas(coins);
}

function dollarsToJeton(dollars, rate = 0.02) {
  const d = Number(dollars) || 0;
  const r = Number(rate) > 0 ? Number(rate) : 0.02;
  return Math.round(d / r);
}

function formatDollarsAsJeton(dollars, rate = 0.02) {
  const coins = dollarsToJeton(dollars, rate);
  return formatPublisherElmas(coins);
}

function cleanRewardItemText(raw) {
  if (!raw) return "";
  let str = String(raw).trim();

  // Strip any mojibake characters and clean encoding artifacts
  str = str
    .replace(/â€¢/g, " ")
    .replace(/\uFFFD/g, " ")
    .replace(/Ã¼/g, "ü")
    .replace(/Ãœ/g, "Ü")
    .replace(/Ã¶/g, "ö")
    .replace(/Ã–/g, "Ö")
    .replace(/Ã§/g, "ç")
    .replace(/Ã‡/g, "Ç")
    .replace(/Ä±/g, "ı")
    .replace(/Ä°/g, "İ")
    .replace(/ÅŸ/g, "ş")
    .replace(/Åž/g, "Ş")
    .replace(/ÄŸ/g, "ğ")
    .replace(/Äž/g, "Ğ");

  // Strip bullet and trailing period/hakediş info like " • Eylül 2026 Hakedişi"
  str = str.replace(/\s*[•\-\–\—\u2022\uFFFD]\s*[^•\-\–\—]+$/i, "").trim();
  str = str.replace(/\s*(?:Eylül|Ekim|Kasım|Aralık|Ocak|Şubat|Mart|Nisan|Mayıs|Haziran|Temmuz|Ağustos)\s*\d{4}.*$/i, "").trim();
  str = str.replace(/\s*Hakedi[sşşŸyY].*$/i, "").trim();

  // Direct diamond pattern extraction: e.g. "29,7 K Elmas"
  const directDiamond = str.match(/(\d+(?:[.,]\d+)?\s*K\s*Elmas)/i);
  if (directDiamond) {
    return directDiamond[1].replace(".", ",");
  }

  // Strip parentheses containing currency, numbers, %, seviye, kademe, tier, level etc. (e.g. "(327.32 $)", "(24.46 $)", "(%50 - 5. Seviye)")
  str = str.replace(/\s*\([^)]*(?:\$|₺|€|USD|EUR|TL|%|seviye|kademe|tier|level|\d)[^)]*\)/gi, "").trim();
  str = str.replace(/\s*\(\s*\)/g, "").trim();

  // Strip standalone dollar or currency amounts if present (e.g. "$327.32", "327.32 $") when already paired with diamonds
  if (/elmas|jeton/i.test(str)) {
    str = str.replace(/(?:[\$₺€]|USD|EUR|TL)\s*\d+(?:[.,]\d+)?/gi, "").replace(/\d+(?:[.,]\d+)?\s*(?:[\$₺€]|USD|EUR|TL)/gi, "").trim();
  }

  // Normalize any dot-decimal K to comma-decimal K: "16.3 K" -> "16,3 K"
  str = str.replace(/(\d+)\.(\d+)\s*K/gi, "$1,$2 K");

  // Normalize any older "1K 223 Elmas" or raw "1223 Elmas" patterns to floored K format (e.g. "1,2 K Elmas")
  str = str.replace(/(\d+)\s*K\s*(\d{1,3})\s*Elmas/gi, (match, kVal, rVal) => {
    const total = Number(kVal) * 1000 + Number(rVal);
    return formatPublisherElmas(total);
  });
  str = str.replace(/(\d{1,3}(?:\.\d{3})+|\d{4,})\s*Elmas/gi, (match, numVal) => {
    const cleanNum = Number(String(numVal).replace(/\./g, ""));
    return formatPublisherElmas(cleanNum);
  });
  str = str.replace(/(\d+(?:[.,]\d+)?)\s*K\s*Elmas/gi, "$1 K Elmas");

  // Strip trailing "Ödülünüz", "Ödülü", "Bonus Katkısı", "Bonus", "Prim", "Hediye"
  str = str.replace(/\s*(?:Ödülünüz|Ödülü|Ödül|Bonus\s*Katkısı|Bonus|Prim|Hediye)\b/gi, "").trim();

  // If text already has Elmas / Jeton (e.g. "16,3 K Elmas" or "100 Elmas")
  if (/elmas|jeton/i.test(str)) {
    return str.replace(/\s+/g, " ").trim();
  }

  // If text only has currency/dollar (e.g. "327.32 $" or "$327.32"), convert to diamonds
  let rate = 0.02;
  try {
    const storedRate = parseFloat(localStorage.getItem("WOLF_JETON_DOLLAR_RATE"));
    if (storedRate > 0) rate = storedRate;
  } catch {}

  const amountCurMatch = str.match(/^([\d.,]+)\s*(\$|₺|€|USD|EUR|TL)?$/i);
  if (amountCurMatch) {
    const val = parseFloat(amountCurMatch[1].replace(",", "."));
    return formatDollarsAsJeton(val, rate);
  }

  const curAmountMatch = str.match(/^(\$|₺|€|USD|EUR|TL)\s*([\d.,]+)$/i);
  if (curAmountMatch) {
    const val = parseFloat(curAmountMatch[2].replace(",", "."));
    return formatDollarsAsJeton(val, rate);
  }

  return str || raw;
}

function cleanRewardDisplayText(rawText) {
  if (!rawText) return "Ödülünüz yayınlandı";
  const items = String(rawText)
    .split(" / ")
    .map((s) => cleanRewardItemText(s))
    .filter(Boolean);
  return items.join(" / ") || "Ödülünüz yayınlandı";
}

function extractAwardDiamonds(item = {}) {
  let val = safeNumber(item.awardDiamonds ?? item.award_diamonds ?? item.diamonds);
  if (val > 0) return val;

  const gText = String(item.giftDetail || item.gift_detail || "");
  const aText = String(item.adminNote || item.admin_note || "");

  const mAdmin = aText.match(/Admin:\s*([\d.]+)\s*Elmas/i);
  if (mAdmin) {
    const parsed = safeNumber(mAdmin[1].replace(/\./g, ""));
    if (parsed > 0) return parsed;
  }

  const mK = gText.match(/(\d+(?:[.,]\d+)?)\s*K\s*Elmas/i);
  if (mK) {
    const parsed = Math.round(parseFloat(mK[1].replace(",", ".")) * 1000);
    if (parsed > 0) return parsed;
  }

  const mNorm = gText.match(/(\d[\d.]*)\s*Elmas/i);
  if (mNorm) {
    const parsed = safeNumber(mNorm[1].replace(/\./g, ""));
    if (parsed > 0) return parsed;
  }

  return 0;
}

function normalizePublishedGiftAward(item = {}) {
  const awardDia = extractAwardDiamonds(item);
  const totalDisp = safeNumber(item.totalDispatched ?? item.total_dispatched ?? item.dispatchedDiamonds ?? 0);
  const delStatus = item.deliveryStatus || item.delivery_status || "Bekliyor";
  const pubStatus = item.publishStatus || item.publish_status || "Yayınlandı";

  return {
    ...item,
    id: item.id,
    periodMonth: item.periodMonth || item.period_month || "",
    publisherUsername: item.publisherUsername || item.publisher_username || "",
    hiddenId: item.hiddenId || item.hidden_id || "",
    publisherName: item.publisherName || item.publisher_name || "",
    giftDetail: item.giftDetail || item.gift_detail || "",
    adminNote: item.adminNote || item.admin_note || "",
    previousTier: safeNumber(item.previousTier || item.previous_tier) || 1,
    currentTier: safeNumber(item.currentTier || item.current_tier) || 1,
    tierChange: item.tierChange || item.tier_change || "Kademe Korundu",
    activeDays: safeNumber(item.activeDays || item.active_days),
    liveCount: safeNumber(item.liveCount || item.live_count),
    liveSeconds: safeNumber(item.liveSeconds || item.live_seconds),
    diamonds: safeNumber(item.diamonds),
    awardDiamonds: awardDia,
    totalDispatched: totalDisp,
    publishStatus: pubStatus,
    deliveryStatus: delStatus,
    isCancelled: Boolean(item.isCancelled ?? item.is_cancelled),
    isDelivered: Boolean(item.isDelivered ?? item.is_delivered),
  };
}

function toInputDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getMonthStartAndToday() {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);

  return {
    start: toInputDate(start),
    end: toInputDate(today),
  };
}

function getPreviousMonthRange() {
  const today = new Date();

  const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const end = new Date(today.getFullYear(), today.getMonth(), 0);

  return {
    start: toInputDate(start),
    end: toInputDate(end),
  };
}

function formatDurationFromSeconds(seconds) {
  const total = safeNumber(seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  return `${hours} sa ${minutes} dk`;
}

function parseInputDate(value) {
  const [year, month, day] = String(value || "").split("-").map(Number);
  return new Date(year, (month || 1) - 1, day || 1);
}

function addDaysInputDate(value, amount) {
  const date = parseInputDate(value);
  date.setDate(date.getDate() + amount);
  return toInputDate(date);
}

function getDateRangeDayCount(startDate, endDate) {
  const start = parseInputDate(startDate);
  const end = parseInputDate(endDate);
  const diff = end.getTime() - start.getTime();

  return Math.max(1, Math.floor(diff / (1000 * 60 * 60 * 24)) + 1);
}

function getPreviousEqualDateRange(startDate, endDate) {
  const dayCount = getDateRangeDayCount(startDate, endDate);

  return {
    start: addDaysInputDate(startDate, -dayCount),
    end: addDaysInputDate(startDate, -1),
  };
}

function getTrendPercent(current, previous) {
  const currentValue = safeNumber(current);
  const previousValue = safeNumber(previous);

  if (previousValue === 0 && currentValue === 0) return 0;
  if (previousValue === 0 && currentValue > 0) return 100;

  return Math.round(((currentValue - previousValue) / previousValue) * 100);
}

function CompareNote({
  current,
  previous,
  formatter = formatNumber,
  prefix = "",
  suffix = "",
}) {
  const currentValue = safeNumber(current);
  const previousValue = safeNumber(previous);
  const diff = currentValue - previousValue;
  const percent = getTrendPercent(currentValue, previousValue);

  const colorClass =
    diff > 0
      ? "text-green-400"
      : diff < 0
        ? "text-red-400"
        : "text-white/40";

  const icon = diff > 0 ? "▲" : diff < 0 ? "▼" : "■";

  return (
    <div className={`mt-1 text-[11px] font-bold ${colorClass}`}>
      {icon} %{Math.abs(percent)}{" "}
      <span className="text-white/35">
        Önceki: {prefix}
        {formatter(previousValue)}
        {suffix}
      </span>
    </div>
  );
}



function SvgDiamondTooltip({ point, chartWidth = 1000 }) {
  if (!point) return null;

  const boxWidth = 210;
  const boxHeight = 48;
  const x = Math.min(Math.max(point.x - boxWidth / 2, 8), chartWidth - boxWidth - 8);
  const y = Math.max(point.y - boxHeight - 14, 8);

  return (
    <g pointerEvents="none">
      <rect
        x={x}
        y={y}
        width={boxWidth}
        height={boxHeight}
        rx="14"
        fill="rgba(5,5,5,0.94)"
        stroke="rgba(250,204,21,0.46)"
      />
      <text x={x + 14} y={y + 19} className="fill-white/55 text-[11px] font-semibold">
        {point.dateText}
      </text>
      <text x={x + 14} y={y + 36} className="fill-yellow-300 text-[13px] font-black">
        Elmas: {formatNumber(point.value)}
      </text>
    </g>
  );
}

const TARGET_GROUP_OPTIONS = [
  { value: "all", label: "Tüm Yayıncılar", badgeClass: "border-yellow-400/45 bg-yellow-500/12 text-yellow-200" },
  { value: "top", label: "Top", badgeClass: "border-yellow-300/60 bg-yellow-400/15 text-yellow-200" },
  { value: "pre_top", label: "Pre-Top", badgeClass: "border-fuchsia-400/50 bg-fuchsia-500/12 text-fuchsia-200" },
  { value: "mature", label: "Mature", badgeClass: "border-cyan-400/45 bg-cyan-500/12 text-cyan-200" },
  { value: "g4", label: "G4", badgeClass: "border-emerald-400/45 bg-emerald-500/12 text-emerald-200" },
  { value: "g0_g3", label: "G0-G3", badgeClass: "border-white/20 bg-white/[0.045] text-white/65" },
];

function normalizeTargetGroup(value) {
  const text = String(value || "all").trim();
  const normalized = text.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_");

  if (["all", "tum_yayincilar", "tüm_yayıncılar", "tüm_yayincilar", "tum_yayıncılar"].includes(normalized)) return "all";
  if (["top", "tier_9_plus", "tier_10", "tier_9"].includes(normalized)) return "top";
  if (["pre_top", "pretop", "tier_6_8", "tier_6_plus"].includes(normalized)) return "pre_top";
  if (["mature", "tier_3_5", "tier_5_plus", "kademe_5_ve_üzeri", "kademe_5_ve_uzeri"].includes(normalized)) return "mature";
  if (["g4", "tier_2", "kademe_2"].includes(normalized)) return "g4";
  if (["g0_g3", "g0-g3", "tier_1", "kademe_1"].includes(normalized)) return "g0_g3";

  const byLabel = TARGET_GROUP_OPTIONS.find(
    (item) => item.label.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_") === normalized
  );

  return byLabel?.value || "all";
}

function getTargetGroupInfo(value) {
  const normalized = normalizeTargetGroup(value);
  return TARGET_GROUP_OPTIONS.find((item) => item.value === normalized) || TARGET_GROUP_OPTIONS[0];
}

function TargetGroupBadge({ value, compact = false }) {
  const info = getTargetGroupInfo(value);

  return (
    <span className={`inline-flex shrink-0 items-center rounded-full border font-semibold leading-none ${compact ? "px-2 py-0.5 text-[9px]" : "px-3 py-1 text-[11px]"} ${info.badgeClass}`}>
      {info.label}
    </span>
  );
}

function getTargetGroupFromTierName(tierName) {
  const no = Number(String(tierName || "").replace(/\D/g, "")) || 1;

  if (no >= 9) return "top";
  if (no >= 6) return "pre_top";
  if (no >= 3) return "mature";
  if (no === 2) return "g4";
  return "g0_g3";
}

function targetGroupMatchesTier(targetGroup, tierName) {
  const target = normalizeTargetGroup(targetGroup);
  if (target === "all") return true;
  return target === getTargetGroupFromTierName(tierName);
}

function secondsToHours(seconds) {
  return Math.round((safeNumber(seconds) / 3600) * 10) / 10;
}

function getQuickRange(label) {
  const today = new Date();
  const start = new Date(today);
  const end = new Date(today);

  if (label === "Dün") {
    start.setDate(today.getDate() - 1);
    end.setDate(today.getDate() - 1);
  } else if (label === "Son 7 Gün") {
    start.setDate(today.getDate() - 6);
  } else if (label === "Son Ay") {
    start.setMonth(today.getMonth() - 1);
  } else if (label === "Bu Ay (Hediye/Prim)" || label === "Bu Ay" || label === "Hediye/Prim Ayı") {
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return { start: toInputDate(startOfMonth), end: toInputDate(endOfMonth) };
  }

  return { start: toInputDate(start), end: toInputDate(end) };
}

function calculateDashboardMetrics(target) {
  const liveHours = safeNumber(target.liveHours);
  const currentHours = safeNumber(target.currentHours);
  const diamonds = safeNumber(target.diamonds);
  const currentDiamonds = safeNumber(target.currentDiamonds);
  const targetPublishCount = safeNumber(target.publishCount);
  const currentPublishCount = safeNumber(target.currentPublishCount);
  const remainingDays = safeNumber(target.remainingDays);

  const remainingHours = Math.max(liveHours - currentHours, 0);
  const remainingDiamonds = Math.max(diamonds - currentDiamonds, 0);
  const remainingPublishCount = Math.max(targetPublishCount - currentPublishCount, 0);

  return {
    remainingHours,
    remainingDiamonds,
    remainingPublishCount,
    dailyHourPlan: remainingDays > 0 ? (remainingHours / remainingDays).toFixed(1) : "0",
    dailyDiamondPlan: remainingDays > 0 ? Math.ceil(remainingDiamonds / remainingDays) : 0,
    dailyPublishPlan: remainingDays > 0 ? Math.ceil(remainingPublishCount / remainingDays) : 0,
    hourPercent: liveHours > 0 ? Math.min(Math.round((currentHours / liveHours) * 100), 100) : 0,
    diamondPercent: diamonds > 0 ? Math.min(Math.round((currentDiamonds / diamonds) * 100), 100) : 0,
    publishPercent:
      targetPublishCount > 0
        ? Math.min(Math.round((currentPublishCount / targetPublishCount) * 100), 100)
        : 0,
  };
}

function buildSystemTargetFromPowerBi(user) {
  const previousMonthHours = safeNumber(
    user?.previousMonthHours || user?.lastMonthHours || user?.powerBiPreviousHours || 0
  );
  const previousMonthDiamonds = safeNumber(
    user?.previousMonthDiamonds || user?.lastMonthDiamonds || user?.powerBiPreviousDiamonds || 0
  );
  const previousMonthPublishCount = safeNumber(
    user?.previousMonthPublishCount || user?.lastMonthPublishCount || user?.powerBiPreviousPublishCount || 0
  );

  return {
    liveHours: previousMonthHours,
    diamonds: previousMonthDiamonds,
    publishCount: previousMonthPublishCount,
    previousMonthHours,
    previousMonthDiamonds,
    previousMonthPublishCount,
  };
}

function getPublisherTier(diamonds, tiers) {
  const value = safeNumber(diamonds);
  return [...tiers]
    .sort((a, b) => b.minDiamonds - a.minDiamonds)
    .find((tier) => value >= tier.minDiamonds) || tiers[0];
}

function isSameUser(sourceUser, candidate) {
  const sourceHiddenId = sourceUser?.hiddenId || sourceUser?.hiddenid || sourceUser?.hidden_id;
  const candidateHiddenId = candidate?.hiddenId || candidate?.hiddenid || candidate?.hidden_id;

  const sourceSys = String(sourceUser?.system_username || sourceUser?.systemUsername || '').replace(/[@\s]+/g, '').toLowerCase();
  const candidateSys = String(candidate?.system_username || candidate?.systemUsername || '').replace(/[@\s]+/g, '').toLowerCase();

  const sourceUserClean = String(sourceUser?.username || '').replace(/[@\s]+/g, '').toLowerCase();
  const candidateUserClean = String(candidate?.username || '').replace(/[@\s]+/g, '').toLowerCase();

  return Boolean(
    (sourceHiddenId && candidateHiddenId && String(candidateHiddenId) === String(sourceHiddenId)) ||
    (sourceUser?.id && candidate?.id && String(candidate?.id) === String(sourceUser.id)) ||
    (sourceSys && candidateSys && sourceSys === candidateSys) ||
    (sourceUserClean && candidateUserClean && sourceUserClean === candidateUserClean)
  );
}

function findPublisherRecord(currentUser, users) {
  if (!Array.isArray(users)) return null;
  return users.find((user) => user.role === "publisher" && isSameUser(currentUser, user)) || null;
}

function resolveManagerInfo(currentUser, users) {
  const publisher = findPublisherRecord(currentUser, users) || currentUser || {};

  const representativeValue =
    publisher?.assignedEmployeeUsername ||
    publisher?.employeeUsername ||
    publisher?.representative ||
    currentUser?.assignedEmployeeUsername ||
    currentUser?.employeeUsername ||
    currentUser?.representative ||
    "";

  const manager = Array.isArray(users)
    ? users.find((user) => {
        const sameUsername = user.username && user.username === representativeValue;
        const sameId = user.id && String(user.id) === String(representativeValue);
        const sameName = user.fullName && user.fullName === representativeValue;
        return (user.role === "employee" || user.role === "admin") && (sameUsername || sameId || sameName);
      })
    : null;

  return {
    name: manager?.fullName || publisher?.representativeName || representativeValue || "Yönetici atanmadı",
    phone: manager?.phone || publisher?.representativePhone || currentUser?.representativePhone || "-",
    username: manager?.username || representativeValue || "-",
  };
}

const tierRules = [
  { name: "Kademe 1", minDiamonds: 0, targetDays: 22, targetHours: 80, groupLabel: "G0-G3-G4", color: "border-white/20 bg-white/[0.045] text-white/65", rowClass: "border-white/10 bg-white/[0.025]", baseRate: "%5", advancedRate: "%6", protectRate: "%0" },
  { name: "Kademe 2", minDiamonds: 40000, targetDays: 22, targetHours: 80, groupLabel: "G0-G3-G4", color: "border-emerald-400/45 bg-emerald-500/12 text-emerald-200", rowClass: "border-emerald-400/20 bg-emerald-500/[0.045]", baseRate: "%5", advancedRate: "%6", protectRate: "%0" },
  { name: "Kademe 3", minDiamonds: 80000, targetDays: 22, targetHours: 80, groupLabel: "Mature", color: "border-cyan-400/45 bg-cyan-500/12 text-cyan-200", rowClass: "border-cyan-400/20 bg-cyan-500/[0.045]", baseRate: "%5", advancedRate: "%6", protectRate: "%3" },
  { name: "Kademe 4", minDiamonds: 150000, targetDays: 22, targetHours: 80, groupLabel: "Mature", color: "border-cyan-400/45 bg-cyan-500/12 text-cyan-200", rowClass: "border-cyan-400/20 bg-cyan-500/[0.045]", baseRate: "%5", advancedRate: "%6", protectRate: "%3" },
  { name: "Kademe 5", minDiamonds: 300000, targetDays: 22, targetHours: 80, groupLabel: "Mature", color: "border-cyan-400/45 bg-cyan-500/12 text-cyan-200", rowClass: "border-cyan-400/20 bg-cyan-500/[0.045]", baseRate: "%5", advancedRate: "%6", protectRate: "%3" },
  { name: "Kademe 6", minDiamonds: 500000, targetDays: 22, targetHours: 80, groupLabel: "Pre-Top", color: "border-fuchsia-400/50 bg-fuchsia-500/12 text-fuchsia-200", rowClass: "border-fuchsia-400/20 bg-fuchsia-500/[0.045]", baseRate: "%5", advancedRate: "%6", protectRate: "%3" },
  { name: "Kademe 7", minDiamonds: 800000, targetDays: 22, targetHours: 80, groupLabel: "Pre-Top", color: "border-fuchsia-400/50 bg-fuchsia-500/12 text-fuchsia-200", rowClass: "border-fuchsia-400/20 bg-fuchsia-500/[0.045]", baseRate: "%4", advancedRate: "%5", protectRate: "%2,5" },
  { name: "Kademe 8", minDiamonds: 1200000, targetDays: 22, targetHours: 80, groupLabel: "Pre-Top", color: "border-fuchsia-400/50 bg-fuchsia-500/12 text-fuchsia-200", rowClass: "border-fuchsia-400/20 bg-fuchsia-500/[0.045]", baseRate: "%4", advancedRate: "%5", protectRate: "%2,5" },
  { name: "Kademe 9", minDiamonds: 1600000, targetDays: 22, targetHours: 80, groupLabel: "Top", color: "border-yellow-300/60 bg-yellow-400/15 text-yellow-200 shadow-[0_0_18px_rgba(250,204,21,.18)]", rowClass: "border-yellow-400/25 bg-yellow-500/[0.055]", baseRate: "%3", advancedRate: "%4", protectRate: "%2" },
  { name: "Kademe 10", minDiamonds: 3000000, targetDays: 22, targetHours: 80, groupLabel: "Top", color: "border-yellow-300/60 bg-yellow-400/15 text-yellow-200 shadow-[0_0_18px_rgba(250,204,21,.18)]", rowClass: "border-yellow-400/25 bg-yellow-500/[0.055]", baseRate: "-", advancedRate: "-", protectRate: "%2" },
];

function getTierTheme(tier) {
  const tierNo = getTierNumber(tier);
  const matched = tierRules.find((item) => getTierNumber(item) === tierNo) || tierRules[0];

  return {
    ...matched,
    tierLabel: `Tier ${tierNo}`,
    groupLabel: matched.groupLabel || "G0-G3",
    badgeClass: matched.color,
    rowClass: matched.rowClass || "border-white/10 bg-white/[0.025]",
  };
}

function TierGroupPills({ tier, compact = false }) {
  const info = getTierTheme(tier);
  const sizeClass = compact ? "px-3 py-1 text-[10px]" : "px-3.5 py-1.5 text-xs";
  const label = `${tier?.name || "Kademe 1"} • ${info.groupLabel}`;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className={`inline-flex shrink-0 items-center rounded-full border font-semibold leading-none ${sizeClass} ${info.badgeClass}`}>
        {label}
      </span>
    </div>
  );
}

function getTierNumber(tier) {
  return Number(String(tier?.name || "").replace(/\D/g, "")) || 1;
}

function getTierRewardMode(currentTier, previousTier) {
  const currentNo = getTierNumber(currentTier);
  const previousNo = getTierNumber(previousTier || currentTier);

  if (currentNo > previousNo) return "upgrade";
  if (currentNo === previousNo) return "protect";
  return "drop";
}

function getTierRewardModeLabel(mode) {
  if (mode === "upgrade") return "Kademe Yükselme Ödülü";
  if (mode === "protect") return "Kademe Koruma Ödülü";
  return "Kademe Düşüş Bilgilendirmesi";
}

function findTierRewardContent(rows, currentTier, previousTier) {
  const currentNo = getTierNumber(currentTier);
  const mode = getTierRewardMode(currentTier, previousTier);

  return (rows || []).find((item) => {
    const rewardType = item.rewardType || item.reward_type;
    const tierNo = Number(item.tierNo || item.tier_no || 0);
    const status = item.status || "Aktif";

    if (status !== "Aktif") return false;
    if (rewardType !== mode) return false;

    if (mode === "drop") {
      return tierNo === 0 || tierNo === currentNo;
    }

    return tierNo === currentNo;
  });
}

function runDashboardTests() {
  const result = calculateDashboardMetrics({
    liveHours: 60,
    currentHours: 36,
    diamonds: 500000,
    currentDiamonds: 326490,
    publishCount: 20,
    currentPublishCount: 12,
    remainingDays: 11,
  });

  console.assert(result.remainingHours === 24, "Kalan saat hesabı hatalı");
  console.assert(result.remainingDiamonds === 173510, "Kalan elmas hesabı hatalı");
  console.assert(result.remainingPublishCount === 8, "Kalan yayın adeti hesabı hatalı");
  console.assert(result.hourPercent === 60, "Saat yüzde hesabı hatalı");
  console.assert(result.diamondPercent === 65, "Elmas yüzde hesabı hatalı");
  console.assert(result.publishPercent === 60, "Yayın adeti yüzde hesabı hatalı");
  console.assert(getPublisherTier(326490, tierRules).name === "Kademe 5", "Kademe hesabı hatalı");
}

runDashboardTests();

export default function PublisherDashboard({
  overridePublisher = null,
  isImpersonated = false
} = {}) {
  const [theme, setTheme] = useState(getInitialPublisherTheme);
  const [tiktokProfile, setTiktokProfile] = useState(null);
  const [tiktokProfileLoading, setTiktokProfileLoading] = useState(false);

  const currentUser = useMemo(() => {
    if (overridePublisher) return overridePublisher;
    try {
      if (typeof localStorage === "undefined") return {};
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  }, [overridePublisher]);

  const [customAvatar, setCustomAvatar] = useState(() => {
    try {
      return localStorage.getItem("wm_custom_avatar_" + (currentUser?.username || "")) || currentUser?.avatar || "";
    } catch {
      return "";
    }
  });

  useEffect(() => {
    if (currentUser?.username) {
      try {
        const saved = localStorage.getItem("wm_custom_avatar_" + currentUser.username) || currentUser.avatar || "";
        setCustomAvatar(saved);
      } catch {}
    }
  }, [currentUser]);

  const [noticeModal, setNoticeModal] = useState({
    isOpen: false,
    title: "Wolf Media Bilgilendirme",
    message: "",
    icon: "🐺",
    buttonText: "Tamam",
    onConfirm: null
  });

  const showNotice = useCallback((message, title = "Wolf Media Bilgilendirme", buttonText = "Tamam", onConfirm = null) => {
    setNoticeModal({
      isOpen: true,
      title,
      message,
      icon: "🐺",
      buttonText,
      onConfirm
    });
  }, []);

  useEffect(() => {
    window.wolfNotice = showNotice;
    return () => {
      delete window.wolfNotice;
    };
  }, [showNotice]);
  usePublisherThemeStyles(theme);

  useEffect(() => {
    try {
      localStorage.setItem("wm_publisher_theme", theme);
    } catch {}
  }, [theme]);

  useMobileOnlyResponsiveLayout("wm-publisher-dashboard-mobile");

  const initialRange = getQuickRange("Son 7 Gün");

  const [activeSection, setActiveSection] = useState("dashboard");
  const [publisherRecord, setPublisherRecord] = useState(null);
  const [managerInfo, setManagerInfo] = useState({ name: "Yönetici yükleniyor", phone: "-", username: "-" });
  const [messageSubject, setMessageSubject] = useState("");
  const [messageText, setMessageText] = useState("");
  const [faqSearch, setFaqSearch] = useState("");
  const [faqRows, setFaqRows] = useState([]);
  const [faqLoading, setFaqLoading] = useState(false);
  const [faqError, setFaqError] = useState("");
  const [showAllFaq, setShowAllFaq] = useState(false);
  
  const [managerMessages, setManagerMessages] = useState([]);
  const [giftWinner, setGiftWinner] = useState(null);
  const [giftWinnerLoading, setGiftWinnerLoading] = useState(false);
  const [giftWinnerError, setGiftWinnerError] = useState("");
  const [publishedGiftAwards, setPublishedGiftAwards] = useState([]);
  const [publishedGiftAwardsLoading, setPublishedGiftAwardsLoading] = useState(false);
  const [publishedGiftAwardsError, setPublishedGiftAwardsError] = useState("");
  const [activeGiftWinnerId, setActiveGiftWinnerId] = useState(null);
  const [giftPlanDay, setGiftPlanDay] = useState("");
  const [giftPlanTime, setGiftPlanTime] = useState("");
  const [giftPlanNote, setGiftPlanNote] = useState("");

  const [performanceData, setPerformanceData] = useState({
  
    summary: {
      totalLiveCount: 0,
      totalLiveSeconds: 0,
      totalDiamonds: 0,
      tier: 0,
    },
    daily: [],
  });
  const [currentMonthPerformance, setCurrentMonthPerformance] = useState({
    summary: {},
    daily: [],
  });

  const [previousMonthPerformance, setPreviousMonthPerformance] = useState({
    summary: {},
    daily: [],
  });

  const [previousPerformanceData, setPreviousPerformanceData] = useState({
    summary: {},
    daily: [],
  });

  const [tierPerformanceLoading, setTierPerformanceLoading] = useState(false);
  const [tierPerformanceError, setTierPerformanceError] = useState("");
  const [performanceLoading, setPerformanceLoading] = useState(false);
  const [performanceError, setPerformanceError] = useState("");
  const [selectedQuickRange, setSelectedQuickRange] = useState("Son 7 Gün");
  const [customStartDate, setCustomStartDate] = useState(initialRange.start);
  const [customEndDate, setCustomEndDate] = useState(initialRange.end);
  const [selectedAcademy, setSelectedAcademy] = useState(null);
  const [academyComment, setAcademyComment] = useState("");
  const [academyRating, setAcademyRating] = useState(5);
  const [academyFeedbackSaving, setAcademyFeedbackSaving] = useState(false);
  const [academyRows, setAcademyRows] = useState([]);
  const [academyLoading, setAcademyLoading] = useState(false);
  const [academyError, setAcademyError] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [rewardRows, setRewardRows] = useState([]);
  const [tierRewardRows, setTierRewardRows] = useState([]);
  const [tierRewardLoading, setTierRewardLoading] = useState(false);
  const [agencyTrackingStatus, setAgencyTrackingStatus] = useState(() => {
    try {
      const u = JSON.parse(localStorage.getItem("user") || "{}");
      return u.agencyTrackingStatus || u.agency_tracking_status || "Aktif";
    } catch {
      return "Aktif";
    }
  });
  const [agencyPreferences, setAgencyPreferences] = useState(() => {
    try {
      const u = JSON.parse(localStorage.getItem("user") || "{}");
      const cleanUser = String(u?.username || "").replace(/^@+/, "").trim();
      const cached = localStorage.getItem("wm_agency_prefs_" + cleanUser) || localStorage.getItem("wm_agency_prefs");
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed && typeof parsed === "object") return parsed;
      }
      if (u?.agency_preferences) {
        const parsed = typeof u.agency_preferences === "string" ? JSON.parse(u.agency_preferences) : u.agency_preferences;
        if (parsed && typeof parsed === "object") return parsed;
      }
    } catch {}
    return {
      phone: true,
      whatsapp: true,
      live_review: true,
      pk_events: true,
      growth_advice: true,
      reports: true
    };
  });
  const [agencyTrackingPopupOpen, setAgencyTrackingPopupOpen] = useState(false);
  const [agencyTrackingSaving, setAgencyTrackingSaving] = useState(false);
  const [agencyTrackingMessage, setAgencyTrackingMessage] = useState("");
  const [rewardLoading, setRewardLoading] = useState(false);
  const [rewardError, setRewardError] = useState("");
  const [notificationReadKeys, setNotificationReadKeys] = useState([]);
  const [notificationPanelOpen, setNotificationPanelOpen] = useState(false);
  const [customTargets, setCustomTargets] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("publisherCustomTargets") || "null");
    } catch {
      return null;
    }
  });

  const loadManagerMessages = useCallback(async () => {
    if (!publisherRecord?.id) return;

    try {
      const response = await fetch(
        `${API_MESSAGES_LIST}?user_id=${publisherRecord.id}&role=publisher`,
        { cache: "no-store" }
      );

      const data = await response.json();

      if (data.success) {
        setManagerMessages(data.messages || []);
      }
    } catch (err) {
      console.error("Yönetici mesajları alınamadı:", err);
    }
  }, [publisherRecord?.id]);

  useEffect(() => {
    loadManagerMessages();
  }, [loadManagerMessages]);

  useEffect(() => {
    let ignore = false;

    async function loadPublisherAndManager() {
      try {
        const response = await fetch("/api/users-list.php");
        const data = await response.json();
        const users = Array.isArray(data?.users) ? data.users : [];
        const publisher = findPublisherRecord(currentUser, users);

        if (!ignore) {
          setPublisherRecord(publisher);
          setManagerInfo(resolveManagerInfo(publisher || currentUser, users));
        }
      } catch {
        if (!ignore) {
          setPublisherRecord(null);
          setManagerInfo({
            name:
              currentUser?.representativeName ||
              currentUser?.representative ||
              currentUser?.employeeUsername ||
              "Yönetici atanmadı",
            phone: currentUser?.representativePhone || "-",
            username: currentUser?.representative || currentUser?.employeeUsername || "-",
          });
        }
      }
    }

    loadPublisherAndManager();
    return () => {
      ignore = true;
    };
  }, [currentUser]);

  const publisherSource = publisherRecord || currentUser || {};
  const currentPublisher = {
    id: publisherSource?.id || currentUser?.id,
    fullName: publisherSource?.fullName || publisherSource?.fullname || "Demo Yayıncı",
    username: publisherSource?.username || "-",
    hiddenId: publisherSource?.hiddenId || publisherSource?.hidden_id || publisherSource?.hiddenid || currentUser?.hiddenId || currentUser?.hidden_id || "",
    status: publisherSource?.status || "Aktif",
    powerBIRole: publisherSource?.powerBIRole || "Aktif",
    agencyTrackingStatus,
  };

    // 🌟 TIKTOK CANLI PROFİL ÇEKİCİ (OTOMATİK & ÇOKLU KAYNAKLI)
  useEffect(() => {
    let ignore = false;
    const rawUser = currentPublisher?.username || currentUser?.username || "";
    const cleanUser = String(rawUser).replace(/^@+/, "").trim();
    if (!cleanUser || cleanUser === "-" || cleanUser === "undefined") return;

    // 1. Önce yerel önbellekten hızlıca getir
    try {
      const cached = localStorage.getItem("wm_tt_prof_" + cleanUser);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed?.avatar) {
          setTiktokProfile(parsed);
        }
      }
    } catch {}

    async function fetchPublisherTikTokProfile() {
      setTiktokProfileLoading(true);

      // Deneme 1: PHP scraper API
      try {
        const hId = currentPublisher?.hiddenId || "";
        const res = await fetch("/api/tiktok-profile-fetch.php?username=" + encodeURIComponent(cleanUser) + "&hiddenId=" + encodeURIComponent(hId), { cache: "no-store" });
        const json = await res.json();
        if (!ignore && json && json.success && json.data) {
          setTiktokProfile(json.data);
          try {
            localStorage.setItem("wm_tt_prof_" + cleanUser, JSON.stringify(json.data));
            if (json.data.username) {
              localStorage.setItem("wm_tt_prof_" + json.data.username.replace(/^@+/, ""), JSON.stringify(json.data));
            }
          } catch {}
          if (json.data.avatar) return;
        }
      } catch (err) {
        console.warn("tiktok-profile-fetch API hatası, yedek servise geçiliyor:", err);
      }

      // Deneme 2: Countik Public API
      try {
        const countikRes = await fetch("https://countik.com/api/user/username/" + encodeURIComponent(cleanUser));
        const countikData = await countikRes.json();
        if (!ignore && countikData && countikData.avatar) {
          const profileData = {
            username: cleanUser,
            nickname: countikData.nickname || currentPublisher?.fullName || cleanUser,
            fullName: countikData.nickname || currentPublisher?.fullName || cleanUser,
            avatar: countikData.avatar,
            followerCount: countikData.followers || 0,
            tiktokUrl: "https://www.tiktok.com/@" + cleanUser,
          };
          setTiktokProfile(profileData);
          try {
            localStorage.setItem("wm_tt_prof_" + cleanUser, JSON.stringify(profileData));
          } catch {}
          return;
        }
      } catch (e) {}

      // Deneme 3: TikTok oEmbed
      try {
        const oembedRes = await fetch("https://www.tiktok.com/oembed?url=https://www.tiktok.com/@" + encodeURIComponent(cleanUser));
        const oembedData = await oembedRes.json();
        if (!ignore && oembedData && oembedData.thumbnail_url) {
          const profileData = {
            username: cleanUser,
            nickname: oembedData.author_name || currentPublisher?.fullName || cleanUser,
            fullName: oembedData.author_name || currentPublisher?.fullName || cleanUser,
            avatar: oembedData.thumbnail_url,
            tiktokUrl: "https://www.tiktok.com/@" + cleanUser,
          };
          setTiktokProfile(profileData);
          try {
            localStorage.setItem("wm_tt_prof_" + cleanUser, JSON.stringify(profileData));
          } catch {}
          return;
        }
      } catch (e) {}
    }

    fetchPublisherTikTokProfile().finally(() => {
      if (!ignore) setTiktokProfileLoading(false);
    });

    return () => {
      ignore = true;
    };
  }, [currentPublisher?.username, currentUser?.username]);


  async function handleToggleSinglePreference(channelKey) {
    const nextPrefs = {
      ...agencyPreferences,
      [channelKey]: !agencyPreferences[channelKey]
    };
    const anyActive = Object.values(nextPrefs).some(Boolean);
    const nextStatus = anyActive ? "Aktif" : "Pasif";

    setAgencyPreferences(nextPrefs);
    setAgencyTrackingStatus(nextStatus);

    try {
      await fetch(API_AGENCY_TRACKING_SAVE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: currentPublisher?.id,
          username: currentPublisher?.username,
          hiddenId: currentPublisher?.hiddenId,
          status: nextStatus,
          preferences: nextPrefs,
        }),
      });
    } catch (e) {
      console.error("Tercih kaydedilemedi:", e);
    }
  }


const loadAgencyTracking = useCallback(async () => {
    if (!currentPublisher?.id && !currentPublisher?.hiddenId && !currentPublisher?.username) return;

    try {
      const response = await fetch(
        `${API_AGENCY_TRACKING_GET}?user_id=${encodeURIComponent(currentPublisher.id || "")}&hidden_id=${encodeURIComponent(currentPublisher.hiddenId || "")}&username=${encodeURIComponent(currentPublisher.username || "")}`,
        { cache: "no-store" }
      );
      const data = await response.json();
      if (data.success) {
        setAgencyTrackingStatus(normalizeAgencyTrackingStatus(data.agencyTrackingStatus || data.agency_tracking_status || data.status));
        if (data.preferences && typeof data.preferences === "object") {
          setAgencyPreferences((prev) => ({ ...prev, ...data.preferences }));
        }
      }
    } catch {
      // Ajans takip servisi erişilemezse varsayılan aktif kalır.
    }
  }, [currentPublisher?.id, currentPublisher?.hiddenId, currentPublisher?.username]);

  useEffect(() => {
    loadAgencyTracking();
  }, [loadAgencyTracking]);

  async function handleAgencyTrackingChange(nextStatus) {
    if (!currentPublisher?.id && !currentPublisher?.username && !currentPublisher?.hiddenId) {
      setAgencyTrackingMessage("Kullanıcı bilgisi bulunamadı.");
      return;
    }

    try {
      setAgencyTrackingSaving(true);
      setAgencyTrackingMessage("");
      const response = await fetch(API_AGENCY_TRACKING_SAVE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: currentPublisher.id,
          username: currentPublisher.username,
          hiddenId: currentPublisher.hiddenId,
          status: nextStatus,
          source: "publisher_dashboard",
        }),
      });
      const data = await response.json();
      if (!data.success) {
        setAgencyTrackingMessage(data.message || "Ajans takip tercihi güncellenemedi.");
        return;
      }
      const normalized = normalizeAgencyTrackingStatus(nextStatus);
      setAgencyTrackingStatus(normalized);
      try {
        const stored = JSON.parse(localStorage.getItem("user") || "{}");
        localStorage.setItem("user", JSON.stringify({
          ...stored,
          agencyTrackingStatus: normalized,
          agency_tracking_status: normalized,
          agencyTrackingChoiceAt: data.updatedAt || new Date().toISOString(),
          agency_tracking_choice_at: data.updatedAt || new Date().toISOString(),
        }));
      } catch {
        // localStorage kapalı olabilir.
      }
      setAgencyTrackingPopupOpen(false);
      showNotice(normalized === "Aktif" ? "Ajans takibi aktif hale getirildi." : "Ajans takibi pasif hale getirildi.", "Ajans Takip Durumu");
    } catch {
      setAgencyTrackingMessage("Sunucu bağlantı hatası.");
    } finally {
      setAgencyTrackingSaving(false);
    }
  }
  

  const loadGiftWinner = useCallback(async () => {
    if (!currentPublisher?.id && !currentPublisher?.hiddenId) return;

    try {
      setGiftWinnerLoading(true);
      setGiftWinnerError("");
      const response = await fetch(
        `${API_GIFT_WINNERS_LIST}?publisher_id=${encodeURIComponent(currentPublisher.id || "")}&hidden_id=${encodeURIComponent(currentPublisher.hiddenId || "")}&publisher_username=${encodeURIComponent(currentPublisher.username || "")}`,
        { cache: "no-store" }
      );
      const data = await response.json();
      if (!data.success) throw new Error(data.message || "Hediye kazanımı alınamadı.");
      const winner = (data.winners || [])[0] || null;
      setGiftWinner(winner);
      if (winner) {
        setGiftPlanDay(winner.preferredDay || winner.preferred_day || "");
        setGiftPlanTime(winner.preferredTime || winner.preferred_time || "");
        setGiftPlanNote(winner.publisherNote || winner.publisher_note || "");
      }
    } catch (err) {
      setGiftWinner(null);
      setGiftWinnerError(err.message || "Hediye kazanımı alınamadı.");
    } finally {
      setGiftWinnerLoading(false);
    }
  }, [currentPublisher?.id, currentPublisher?.hiddenId, currentPublisher?.username]);

  useEffect(() => {
    loadGiftWinner();
  }, [loadGiftWinner]);

  const loadPublishedGiftAwards = useCallback(async () => {
    if (!currentPublisher?.id && !currentPublisher?.hiddenId && !currentPublisher?.username) return;

    try {
      setPublishedGiftAwardsLoading(true);
      setPublishedGiftAwardsError("");
      const response = await fetch(
        `${API_GIFT_AWARD_LIST}?viewer=publisher&publisher_id=${encodeURIComponent(currentPublisher.id || "")}&hidden_id=${encodeURIComponent(currentPublisher.hiddenId || "")}&username=${encodeURIComponent(currentPublisher.username || "")}`,
        { cache: "no-store" }
      );
      const raw = await response.text();
      let data;
      try {
        data = JSON.parse(raw);
      } catch {
        throw new Error("Aylık kazanım servisi geçerli yanıt vermedi.");
      }
      if (!response.ok || !data.success) throw new Error(data.message || "Aylık kazanımlar alınamadı.");
      setPublishedGiftAwards((data.awards || []).map(normalizePublishedGiftAward));
    } catch (err) {
      setPublishedGiftAwards([]);
      setPublishedGiftAwardsError(err.message || "Aylık kazanımlar alınamadı.");
    } finally {
      setPublishedGiftAwardsLoading(false);
    }
  }, [currentPublisher?.id, currentPublisher?.hiddenId, currentPublisher?.username]);

  useEffect(() => {
    loadPublishedGiftAwards();
    const timer = window.setInterval(loadPublishedGiftAwards, 30000);
    return () => window.clearInterval(timer);
  }, [loadPublishedGiftAwards]);

  function handleGiftMessageRequest(winner) {
    if (!winner) return;

    const giftDetail = String(winner.giftDetail || winner.gift_detail || "").trim();
    const cleanDetail = cleanRewardDisplayText(giftDetail);
    if (giftDetail) {
      setActiveGiftWinnerId(null);
      setGiftPlanDay("");
      setGiftPlanTime("");
      setGiftPlanNote("");
      setMessageSubject(`${formatGiftPeriodLabel(winner.periodMonth || winner.period_month)} Kazanımı`);
      setMessageText(
        `Merhaba, ${formatGiftPeriodLabel(winner.periodMonth || winner.period_month)} dönemine ait kazanımım için destek rica ederim.\n\nKazanımım: ${cleanDetail || giftDetail}`
      );
      setActiveSection("messages");
      return;
    }

    setActiveGiftWinnerId(winner.id);
    setGiftPlanDay(winner.preferredDay || winner.preferred_day || "");
    setGiftPlanTime(winner.preferredTime || winner.preferred_time || "");
    setGiftPlanNote(winner.publisherNote || winner.publisher_note || "");
    setMessageSubject("Hediye Kazanımı Planlama");
    setMessageText(
      `Merhaba, bu ay hediye kazanımım oluştu. Hediye gönderim planlaması için destek rica ederim.\n\nHediye kazanımım: ${formatNumber(winner.finalGiftAmount || winner.final_gift_amount || winner.giftAmount || winner.gift_amount)} elmas`
    );
    setActiveSection("messages");
  }

  const loadNotificationReads = useCallback(async () => {
      if (!currentPublisher?.id) return;

      try {
        const response = await fetch(
          `${API_NOTIFICATION_READS_LIST}?user_id=${currentPublisher.id}`,
          { cache: "no-store" }
        );

        const data = await response.json();

        if (data.success) {
          const keys = Array.isArray(data.keys)
            ? data.keys
            : (data.reads || []).map(
                (item) => `${item.notification_type}:${item.source_id}`
              );

          setNotificationReadKeys(keys);
        }
      } catch (err) {
        console.error("Bildirim okuma kayıtları alınamadı:", err);
      }
    }, [currentPublisher?.id]);

    useEffect(() => {
      loadNotificationReads();
    }, [loadNotificationReads]);

  const currentMonthRange = useMemo(() => getMonthStartAndToday(), []);
  const previousMonthRange = useMemo(() => getPreviousMonthRange(), []);

  const fetchPublisherPerformanceData = useCallback(
    async (startDate, endDate) => {
      const hid = currentPublisher?.hiddenId || currentUser?.hiddenId || "";
      const uName = currentPublisher?.username || currentUser?.username || "";
      const sysName = currentPublisher?.system_username || currentPublisher?.systemUsername || currentUser?.system_username || currentUser?.systemUsername || "";
      const uId = currentPublisher?.id || currentUser?.id || "";

      if (!hid && !uName && !uId && !sysName) {
        return { summary: {}, daily: [] };
      }

      try {
        const response = await fetch(
          `${API_PERFORMANCE_SUMMARY}?hiddenId=${encodeURIComponent(
            hid
          )}&username=${encodeURIComponent(uName || sysName)}&userId=${encodeURIComponent(uId)}&startDate=${startDate}&endDate=${endDate}`,
          { cache: "no-store" }
        );

        if (!response.ok) {
          return { summary: {}, daily: [] };
        }

        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch {
          return { summary: {}, daily: [] };
        }

        if (!data?.success) {
          return { summary: {}, daily: [] };
        }

        return {
          summary: data.summary || {},
          daily: data.daily || [],
        };
      } catch (err) {
        return { summary: {}, daily: [] };
      }
    },
    [currentPublisher?.hiddenId, currentPublisher?.username, currentPublisher?.id]
  );

  const loadRewardRows = useCallback(async () => {
    try {
      setRewardLoading(true);
      setRewardError("");

      const response = await fetch(`${API_REWARD_LIST}?viewer=publisher`, {
        cache: "no-store",
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Etkinlikler alınamadı.");
      }

      setRewardRows(data.rewards || []);
    } catch (err) {
      setRewardRows([]);
      setRewardError(err.message || "Etkinlikler alınamadı.");
    } finally {
      setRewardLoading(false);
    }
  }, []);

  useEffect(() => {
    loadRewardRows();
  }, [loadRewardRows]);

  const loadTierRewardRows = useCallback(async () => {
    try {
      setTierRewardLoading(true);

      const response = await fetch(`${API_TIER_REWARD_LIST}?viewer=publisher`, {
        cache: "no-store",
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Kademe ödülleri alınamadı.");
      }

      setTierRewardRows(data.items || []);
    } catch (err) {
      console.error("Kademe ödülleri alınamadı:", err);
      setTierRewardRows([]);
    } finally {
      setTierRewardLoading(false);
    }
  }, []);

  useEffect(() => {
    loadTierRewardRows();
  }, [loadTierRewardRows]);

  const loadFaqRows = useCallback(async () => {
    try {
      setFaqLoading(true);
      setFaqError("");

      const response = await fetch(`${API_FAQ_LIST}?viewer=publisher`, {
        cache: "no-store",
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "SS arşivi alınamadı.");
      }

      setFaqRows(data.faqs || []);
    } catch (err) {
      setFaqRows([]);
      setFaqError(err.message || "SS arşivi alınamadı.");
    } finally {
      setFaqLoading(false);
    }
  }, []);

  useEffect(() => {
    loadFaqRows();
  }, [loadFaqRows]);

  const loadAcademyRows = useCallback(async () => {
    if (!currentPublisher?.id) return;

    try {
      setAcademyLoading(true);
      setAcademyError("");

      const response = await fetch(
        `${API_TRAINING_LIST}?viewer=publisher&viewer_id=${currentPublisher.id}`
      );

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Eğitim listesi alınamadı.");
      }

      setAcademyRows(data.trainings || []);
    } catch (err) {
      setAcademyRows([]);
      setAcademyError(err.message || "Eğitim listesi alınamadı.");
    } finally {
      setAcademyLoading(false);
    }
  }, [currentPublisher?.id]);

  useEffect(() => {
    loadAcademyRows();
  }, [loadAcademyRows]);

  async function handleAcademyView(item) {
    setSelectedAcademy(item);
    setAcademyComment(item.comment || "");
    setAcademyRating(safeNumber(item.rating) || 5);

    if (!item?.id || !currentPublisher?.id) return;

    try {
      await fetch(API_TRAINING_VIEW, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          trainingId: item.id,
          userId: currentPublisher.id,
        }),
      });

      setAcademyRows((prev) =>
        prev.map((row) =>
          String(row.id) === String(item.id)
            ? { ...row, status: "İzlendi", progress: 100 }
            : row
        )
      );
      setSelectedAcademy((prev) =>
        prev
          ? {
              ...prev,
              status: "İzlendi",
              progress: 100,
            }
          : prev
      );
    } catch (err) {
      console.error("Eğitim izleme kaydı atılamadı:", err);
    }
  }

  async function handleAcademyFeedbackSave() {
    if (!selectedAcademy?.id || !currentPublisher?.id) {
      showNotice("Eğitim veya kullanıcı bilgisi bulunamadı.", "Akademi Uyarısı");
      return;
    }

    try {
      setAcademyFeedbackSaving(true);

      const response = await fetch(API_TRAINING_VIEW, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          trainingId: selectedAcademy.id,
          userId: currentPublisher.id,
          comment: academyComment.trim(),
          rating: academyRating,
        }),
      });

      const data = await response.json();

      if (!data.success) {
        showNotice(data.message || "Yorum kaydedilemedi.", "Yorum Hatası");
        return;
      }

      setAcademyRows((prev) =>
        prev.map((row) =>
          String(row.id) === String(selectedAcademy.id)
            ? {
                ...row,
                status: "İzlendi",
                progress: 100,
                comment: academyComment.trim(),
                rating: academyRating,
              }
            : row
        )
      );

      setSelectedAcademy((prev) =>
        prev
          ? {
              ...prev,
              status: "İzlendi",
              progress: 100,
              comment: academyComment.trim(),
              rating: academyRating,
            }
          : prev
      );

      showNotice("Eğitim yorumunuz başarıyla kaydedildi.", "Wolf Akademi");
    } catch (err) {
      console.error("Eğitim yorumu kaydedilemedi:", err);
      showNotice("Yorum kaydedilirken bağlantı hatası oluştu.", "Bağlantı Hatası");
    } finally {
      setAcademyFeedbackSaving(false);
    }
  }

        useEffect(() => {
          let ignore = false;

          async function loadPerformance() {
            if (!currentPublisher?.hiddenId && !currentPublisher?.username && !currentPublisher?.id) return;

            try {
              setPerformanceLoading(true);
              setPerformanceError("");

              const previousRange = getPreviousEqualDateRange(
                customStartDate,
                customEndDate
              );

              const [currentResult, previousResult] = await Promise.all([
                fetchPublisherPerformanceData(customStartDate, customEndDate),
                fetchPublisherPerformanceData(previousRange.start, previousRange.end),
              ]);

              if (!ignore) {
                setPerformanceData(currentResult);
                setPreviousPerformanceData(previousResult);
                if (currentResult?.range?.start && currentResult.range.start !== customStartDate && currentResult?.range?.maxAvailableDate) {
                  setCustomStartDate(currentResult.range.start);
                  setCustomEndDate(currentResult.range.end);
                }
              }
            } catch (err) {
              if (!ignore) {
                setPerformanceError(err.message || "Performans verisi alınamadı.");
                setPreviousPerformanceData({ summary: {}, daily: [] });
              }
            } finally {
              if (!ignore) {
                setPerformanceLoading(false);
              }
            }
          }

          loadPerformance();

          return () => {
            ignore = true;
          };
        }, [
          currentPublisher?.hiddenId,
          currentPublisher?.username,
          currentPublisher?.id,
          customStartDate,
          customEndDate,
          fetchPublisherPerformanceData,
        ]);
        useEffect(() => {
          let ignore = false;

          async function loadTierPerformance() {
            if (!currentPublisher?.hiddenId && !currentPublisher?.username && !currentPublisher?.id) return;

            try {
              setTierPerformanceLoading(true);
              setTierPerformanceError("");

              const [currentMonthData, previousMonthData] = await Promise.all([
                fetchPublisherPerformanceData(currentMonthRange.start, currentMonthRange.end),
                fetchPublisherPerformanceData(previousMonthRange.start, previousMonthRange.end),
              ]);

              if (!ignore) {
                setCurrentMonthPerformance(currentMonthData);
                setPreviousMonthPerformance(previousMonthData);
              }
            } catch (err) {
              if (!ignore) {
                setCurrentMonthPerformance({ summary: {}, daily: [] });
                setPreviousMonthPerformance({ summary: {}, daily: [] });
                setTierPerformanceError(err.message || "Kademe verisi alınamadı.");
              }
            } finally {
              if (!ignore) {
                setTierPerformanceLoading(false);
              }
            }
          }

          loadTierPerformance();

          return () => {
            ignore = true;
          };
        }, [
          currentPublisher?.hiddenId,
          currentPublisher?.username,
          currentPublisher?.id,
          currentMonthRange.start,
          currentMonthRange.end,
          previousMonthRange.start,
          previousMonthRange.end,
          fetchPublisherPerformanceData,
        ]);

  const selectedRangeText = `${formatDateForDisplay(customStartDate)} - ${formatDateForDisplay(customEndDate)}`;
  const apiSummary = performanceData?.summary || {};
  const currentLiveHoursFromApi = secondsToHours(apiSummary.totalLiveSeconds);
  const currentDiamondsFromApi = safeNumber(apiSummary.totalDiamonds);
  const currentPublishCountFromApi = safeNumber(apiSummary.totalLiveCount);
  const fallbackSystemTarget = buildSystemTargetFromPowerBi(publisherSource);

  const hasPerformanceData =
    currentLiveHoursFromApi > 0 ||
    currentDiamondsFromApi > 0 ||
    currentPublishCountFromApi > 0;

  const targetBaseTier = getPublisherTier(currentDiamondsFromApi, tierRules);
  const targetNextTier =
    tierRules.find((tier) => tier.minDiamonds > targetBaseTier.minDiamonds) || null;

  const starterTarget = {
    liveHours: 0,
    diamonds: 0,
    publishCount: 0,
  };

  const systemTarget = {
    liveHours: hasPerformanceData ? currentLiveHoursFromApi : 0,
    diamonds: hasPerformanceData ? currentDiamondsFromApi : 0,
    publishCount: hasPerformanceData ? currentPublishCountFromApi : 0,
    previousMonthHours: hasPerformanceData ? currentLiveHoursFromApi : 0,
    previousMonthDiamonds: hasPerformanceData ? currentDiamondsFromApi : 0,
    previousMonthPublishCount: hasPerformanceData ? currentPublishCountFromApi : 0,
  };
  const monthlyTarget = {
    liveHours: safeNumber(customTargets?.liveHours ?? systemTarget.liveHours),
    currentHours: currentLiveHoursFromApi,

    diamonds: safeNumber(customTargets?.diamonds ?? systemTarget.diamonds),
    currentDiamonds: currentDiamondsFromApi,

    publishCount: safeNumber(customTargets?.publishCount ?? systemTarget.publishCount),
    currentPublishCount: currentPublishCountFromApi,
    remainingDays: safeNumber(
      publisherSource?.remainingDays ??
      Math.max(0, new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate() - new Date().getDate())
    ),
    previousMonthHours: systemTarget.previousMonthHours,
    previousMonthDiamonds: systemTarget.previousMonthDiamonds,
    previousMonthPublishCount: systemTarget.previousMonthPublishCount,
    isCustomTarget: Boolean(customTargets),
  };

  const metrics = calculateDashboardMetrics(monthlyTarget);

  const currentMonthDiamonds = safeNumber(
    currentMonthPerformance?.summary?.totalDiamonds
  );

  const previousMonthDiamonds = safeNumber(
    previousMonthPerformance?.summary?.totalDiamonds
  );

  const currentTier = getPublisherTier(currentMonthDiamonds, tierRules);
  const previousTier = getPublisherTier(previousMonthDiamonds, tierRules);

  const nextTier =
    tierRules.find((tier) => tier.minDiamonds > currentTier.minDiamonds) || null;

  const nextTierNeed = nextTier
    ? Math.max(nextTier.minDiamonds - currentMonthDiamonds, 0)
    : 0;

  const currentMonthRangeText = `${formatDateForDisplay(
    currentMonthRange.start
  )} - ${formatDateForDisplay(currentMonthRange.end)}`;

  const previousMonthRangeText = `${formatDateForDisplay(
    previousMonthRange.start
  )} - ${formatDateForDisplay(previousMonthRange.end)}`;

  const filteredFaqs = faqRows.filter((item) =>
    `${item.q || item.question} ${item.a || item.answer}`
      .toLowerCase()
      .includes(faqSearch.toLowerCase())
  );

  const publisherTargetGroup = getTargetGroupFromTierName(currentTier?.name);

  const visibleAcademyRows = useMemo(
    () =>
      academyRows.filter((item) =>
        targetGroupMatchesTier(item.targetGroup || item.target_group || item.month || item.category, currentTier?.name)
      ),
    [academyRows, currentTier?.name]
  );

  const visibleRewardRows = useMemo(
    () =>
      rewardRows.filter((item) =>
        targetGroupMatchesTier(item.targetGroup || item.target_group || item.targetText, currentTier?.name)
      ),
    [rewardRows, currentTier?.name]
  );
  const allMessages = useMemo(() => {
    const normalizedManagerMessages = managerMessages.map((message) => ({
      ...message,
      from:
        Number(message.sender_id) === Number(currentPublisher?.id)
          ? "Sen"
          : message.senderName || message.senderUsername || "Yönetici",
      date: message.created_at || message.date || "-",
      subject: message.subject || "Yönetici Mesajı",
      message: message.message || "",
    }));

    return normalizedManagerMessages.sort(
      (a, b) => new Date(b.date || 0) - new Date(a.date || 0)
    );
  }, [managerMessages, currentPublisher?.id]);

  function getNotificationSourceId(item, fallback) {
    return String(
      item?.id ||
        item?.trainingId ||
        item?.rewardId ||
        item?.faqId ||
        item?.created_at ||
        item?.createdAt ||
        fallback
    );
  }

  function isNotificationRead(type, sourceId) {
    return notificationReadKeys.includes(`${type}:${sourceId}`);
  }

  const notificationSources = useMemo(() => {
    const messages = managerMessages
      .filter(
        (item) =>
          item.status === "unread" &&
          Number(item.receiver_id) === Number(currentPublisher?.id)
      )
      .map((item, index) => ({
        type: "message",
        sourceId: getNotificationSourceId(item, `message-${index}`),
      }))
      .filter((item) => !isNotificationRead(item.type, item.sourceId));

    const academy = visibleAcademyRows
      .filter((item) => item.status !== "İzlendi")
      .map((item, index) => ({
        type: "academy",
        sourceId: getNotificationSourceId(item, `academy-${index}`),
      }))
      .filter((item) => !isNotificationRead(item.type, item.sourceId));

    const events = visibleRewardRows
      .filter((item) => item.status !== "Pasif" && item.status !== "Silindi")
      .map((item, index) => ({
        type: "event",
        sourceId: getNotificationSourceId(item, `event-${index}`),
      }))
      .filter((item) => !isNotificationRead(item.type, item.sourceId));

    const faqs = faqRows
      .filter((item) => item.status !== "Pasif" && item.status !== "Silindi")
      .map((item, index) => ({
        type: "faq",
        sourceId: getNotificationSourceId(item, `faq-${index}`),
      }))
      .filter((item) => !isNotificationRead(item.type, item.sourceId));

    return { messages, academy, events, faqs };
  }, [
    managerMessages,
    visibleAcademyRows,
    visibleRewardRows,
    faqRows,
    currentPublisher?.id,
    notificationReadKeys,
  ]);

  const notificationCounts = useMemo(
    () => ({
      messages: notificationSources.messages.length,
      academy: notificationSources.academy.length,
      events: notificationSources.events.length,
      faq: notificationSources.faqs.length,
    }),
    [notificationSources]
  );

  const notificationItems = useMemo(() => {
    const items = [];

    if (notificationCounts.messages > 0) {
      items.push({
        type: "message",
        section: "messages",
        title: `${notificationCounts.messages} yeni yönetici mesajı`,
        sources: notificationSources.messages,
      });
    }

    if (notificationCounts.academy > 0) {
      items.push({
        type: "academy",
        section: "academy",
        title: `${notificationCounts.academy} yeni akademi içeriği`,
        sources: notificationSources.academy,
      });
    }

    if (notificationCounts.events > 0) {
      items.push({
        type: "event",
        section: "events",
        title: `${notificationCounts.events} yeni etkinlik`,
        sources: notificationSources.events,
      });
    }

    if (notificationCounts.faq > 0) {
      items.push({
        type: "faq",
        section: "faq",
        title: `${notificationCounts.faq} yeni sık sorulan soru`,
        sources: notificationSources.faqs,
      });
    }

    return items;
  }, [notificationCounts, notificationSources]);

  const notificationTotal = notificationItems.reduce(
    (sum, item) => sum + item.sources.length,
    0
  );

  async function handleNotificationClick(item) {
    if (!currentPublisher?.id || !item?.sources?.length) {
      setNotificationPanelOpen(false);
      if (item?.section) setActiveSection(item.section);
      return;
    }

    const nextKeys = item.sources.map(
      (source) => `${source.type}:${source.sourceId}`
    );

    setNotificationReadKeys((prev) => [
      ...new Set([...prev, ...nextKeys]),
    ]);

    setNotificationPanelOpen(false);
    setActiveSection(item.section);

    try {
      await fetch(API_NOTIFICATION_READ_SAVE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: currentPublisher.id,
          reads: item.sources.map((source) => ({
            type: source.type,
            sourceId: source.sourceId,
          })),
        }),
      });
    } catch (err) {
      console.error("Bildirim okundu kaydedilemedi:", err);
    }
  }

  function handleSectionOpen(section) {
    setActiveSection(section);

    const matchedItem = notificationItems.find((item) => item.section === section);

    if (matchedItem) {
      handleNotificationClick(matchedItem);
    }
  }

  function handleQuickRangeClick(label) {
    const range = getQuickRange(label);
    setSelectedQuickRange(label);
    setCustomStartDate(range.start);
    setCustomEndDate(range.end);
  }

  function handleSaveTargets(nextTargets) {
    setCustomTargets(nextTargets);
    try {
      localStorage.setItem("publisherCustomTargets", JSON.stringify(nextTargets));
    } catch {
      // localStorage kapalı olabilir.
    }
  }

  function handleResetTargets() {
    setCustomTargets(null);
    try {
      localStorage.removeItem("publisherCustomTargets");
    } catch {
      // localStorage kapalı olabilir.
    }
  }

  function handleLogout() {
    try {
      localStorage.removeItem("user");
    } catch {
      // localStorage kapalı olabilir.
    }
    if (typeof window !== "undefined") window.location.href = "/login";
  }

  async function handleSendMessage() {
    if (!messageSubject.trim() || !messageText.trim()) {
      showNotice("Lütfen konu başlığı ve mesaj alanını doldurunuz.", "Mesaj Uyarısı");
      return;
    }

    if (!currentPublisher?.id) {
      showNotice("Kullanıcı bilgisi bulunamadı. Lütfen tekrar giriş yapın.", "Oturum Uyarısı");
      return;
    }

    try {
      const response = await fetch(API_MESSAGE_SEND, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sender_id: currentPublisher.id,
          sender_role: "publisher",
          subject: messageSubject.trim(),
          message: messageText.trim(),
        }),
      });

      const data = await response.json();

      if (!data.success) {
        showNotice(data.message || "Mesaj gönderilemedi.", "Mesaj Gönderim Hatası");
        return;
      }

      if (activeGiftWinnerId) {
        try {
          await fetch(API_GIFT_WINNER_PLAN_SAVE, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              winnerId: activeGiftWinnerId,
              preferredDay: giftPlanDay,
              preferredTime: giftPlanTime,
              publisherNote: giftPlanNote,
            }),
          });
          await loadGiftWinner();
        } catch (planErr) {
          console.error("Hediye planı kaydedilemedi:", planErr);
        }
      }

      setMessageSubject("");
      setMessageText("");
      setActiveGiftWinnerId(null);

      await loadManagerMessages();

      showNotice("Mesajınız yöneticinize başarıyla iletildi.", "Mesaj İletildi");
    } catch (err) {
      console.error(err);
      showNotice("Mesaj gönderilirken bağlantı hatası oluştu.", "Bağlantı Hatası");
    }
  }

  return (
    <div
      className={`min-h-screen transition-colors duration-200 ${
        theme === "dark" ? "wm-admin-dark dark bg-[#0b0b0e] text-white" : "wm-admin-light bg-[#f4f6f8] text-[#111827]"
      }`}
      style={{
        backgroundColor: theme === "dark" ? "#0b0b0e" : "#f4f6f8",
        color: theme === "dark" ? "#ffffff" : "#111827",
        colorScheme: theme,
      }}
    >
      {theme === "dark" && <div className="fixed inset-0 bg-[radial-gradient(circle_at_top,rgba(212,175,55,0.10),transparent_34%),linear-gradient(180deg,#050505_0%,#090909_45%,#000_100%)]" />}
      {theme === "dark" && <div className="fixed inset-0 opacity-[0.03] [background-image:linear-gradient(rgba(255,255,255,.12)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.12)_1px,transparent_1px)] [background-size:42px_42px]" />}

      <div className="relative z-10 flex min-h-screen">
        <Sidebar
          activeSection={activeSection}
          setActiveSection={handleSectionOpen}
          notificationCounts={notificationCounts}
          currentPublisher={currentPublisher}
          tiktokProfile={tiktokProfile}
          tiktokProfileLoading={tiktokProfileLoading}
          customAvatar={customAvatar}
          setCustomAvatar={setCustomAvatar}
          onAvatarUpdated={(newAvatar) => {
            setCustomAvatar(newAvatar);
            try {
              localStorage.setItem("wm_custom_avatar_" + (currentPublisher?.username || ""), newAvatar);
            } catch {}
          }}
        />

        <main className="min-w-0 flex-1 overflow-x-hidden pt-16 sm:pt-20 p-3.5 pb-10 sm:p-6 sm:pb-12 lg:p-8 xl:p-10 xl:pb-12 xl:pt-10 max-w-[1920px] mx-auto">
          <MobilePublisherMenu
            activeSection={activeSection}
            setActiveSection={handleSectionOpen}
            notificationCounts={notificationCounts}
          />

          {/* 🌟 MOBİL YAYINCI CANLI KİMLİK & AVATAR KARTI (TELEFONLARDA EN ÜSTTE ŞIK GÖRÜNÜM) */}
          <div className="mb-4 overflow-hidden rounded-2xl border border-amber-500/30 bg-gradient-to-r from-amber-500/10 via-black/90 to-[#121215] p-3 sm:p-4 shadow-lg xl:hidden">
            <div className="flex items-center gap-3.5">
              <div
                className="relative shrink-0 overflow-hidden rounded-2xl border-2 border-yellow-400 bg-slate-900 shadow-md"
                style={{ width: "68px", height: "68px", minWidth: "68px", minHeight: "68px", maxWidth: "68px", maxHeight: "68px" }}
              >
                {customAvatar || tiktokProfile?.avatar || currentPublisher?.avatar ? (
                  <img
                    src={customAvatar || tiktokProfile?.avatar || currentPublisher?.avatar}
                    alt={currentPublisher?.fullName || currentPublisher?.username}
                    referrerPolicy="no-referrer"
                    crossOrigin="anonymous"
                    className="h-full w-full object-cover object-top"
                    style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }}
                    onError={(e) => {
                      const cleanUser = String(currentPublisher?.username || "").replace(/^@+/, "");
                      if (!e.target.dataset.triedLocal && cleanUser) {
                        e.target.dataset.triedLocal = "true";
                        e.target.src = "/uploads/publishers/avatar_" + cleanUser.toLowerCase() + ".jpg";
                      } else {
                        e.target.onerror = null;
                        e.target.src = "/wolf-head.png";
                      }
                    }}
                  />
                ) : (
                  <div className="flex h-full w-full items-center justify-center bg-black">
                    <img src="/wolf-head.png" alt="Wolf" className="h-9 w-9 object-contain opacity-80" />
                  </div>
                )}
                <span className="absolute bottom-1 right-1 h-3 w-3 rounded-full bg-emerald-500 ring-2 ring-black" />
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-1">
                  <div className="text-sm sm:text-base font-black text-white truncate">
                    {tiktokProfile?.nickname || tiktokProfile?.fullName || currentPublisher?.fullName || currentPublisher?.username || "Yayıncı"}
                  </div>
                  <label
                    className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-xl border border-white/20 bg-black/60 text-xs text-white backdrop-blur-md transition hover:bg-yellow-500 hover:text-black shadow-md"
                    title="Fotoğraf Yükle"
                  >
                    <span>📷</span>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={async (e) => {
                        if (e.target.files && e.target.files[0]) {
                          const file = e.target.files[0];
                          const formData = new FormData();
                          formData.append("avatar", file);
                          formData.append("username", currentPublisher?.username || "");
                          formData.append("userId", currentPublisher?.id || "");
                          try {
                            const res = await fetch("/api/publisher-avatar-update.php", {
                              method: "POST",
                              body: formData
                            });
                            const data = await res.json();
                            if (data.success && data.avatar) {
                              setCustomAvatar(data.avatar);
                            }
                          } catch (err) {}
                        }
                      }}
                    />
                  </label>
                </div>
                <div className="text-xs font-bold text-yellow-400 truncate">
                  @{String(currentPublisher?.username || "").replace(/^@+/, "")}
                </div>
                <a
                  href={tiktokProfile?.tiktokUrl || `https://www.tiktok.com/@${String(currentPublisher?.username || "").replace(/^@+/, "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-1.5 inline-flex items-center gap-1 rounded-lg bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-500 px-2.5 py-1 text-[10.5px] font-black text-black shadow-md hover:brightness-110 active:scale-95"
                >
                  <span>PROFİL / YAYINI AÇ</span>
                  <span className="text-[10px]">▸</span>
                </a>
              </div>
            </div>
          </div>

          <Header
            currentPublisher={currentPublisher}
            currentTier={currentTier}
            onLogout={handleLogout}
            notificationItems={notificationItems}
            notificationTotal={notificationTotal}
            notificationPanelOpen={notificationPanelOpen}
            setNotificationPanelOpen={setNotificationPanelOpen}
            onNotificationClick={handleNotificationClick}
            agencyTrackingStatus={agencyTrackingStatus}
            agencyPreferences={agencyPreferences}
            onAgencyTrackingClick={() => setAgencyTrackingPopupOpen(true)}
            onToggleSinglePreference={handleToggleSinglePreference}
            theme={theme}
            setTheme={setTheme}
          />

          <AgencyTrackingPreferenceModal
            open={agencyTrackingPopupOpen}
            status={agencyTrackingStatus}
            preferences={agencyPreferences}
            saving={agencyTrackingSaving}
            message={agencyTrackingMessage}
            onClose={() => setAgencyTrackingPopupOpen(false)}
            onChange={handleAgencyTrackingChange}
          />

          {activeSection === "dashboard" && (
            <DashboardSection
              tiktokProfile={tiktokProfile}
              monthlyTarget={monthlyTarget}
              metrics={metrics}
              selectedRangeText={selectedRangeText}
              selectedQuickRange={selectedQuickRange}
              previousPerformanceData={previousPerformanceData}
              customStartDate={customStartDate}
              customEndDate={customEndDate}
              setCustomStartDate={setCustomStartDate}
              setCustomEndDate={setCustomEndDate}
              setSelectedQuickRange={setSelectedQuickRange}
              handleQuickRangeClick={handleQuickRangeClick}
              onSaveTargets={handleSaveTargets}
              onResetTargets={handleResetTargets}
              currentTier={currentTier}
              previousTier={previousTier}
              nextTier={nextTier}
              nextTierNeed={nextTierNeed}
              currentMonthDiamonds={currentMonthDiamonds}
              previousMonthDiamonds={previousMonthDiamonds}
              currentMonthPerformance={currentMonthPerformance}
              previousMonthPerformance={previousMonthPerformance}
              currentMonthRangeText={currentMonthRangeText}
              previousMonthRangeText={previousMonthRangeText}
              tierPerformanceLoading={tierPerformanceLoading}
              tierPerformanceError={tierPerformanceError}
              performanceData={performanceData}
              performanceLoading={performanceLoading}
              performanceError={performanceError}
              tierRewardRows={tierRewardRows}
              tierRewardLoading={tierRewardLoading}
              currentPublisher={currentPublisher}
              giftWinner={giftWinner}
              giftWinnerLoading={giftWinnerLoading}
              giftWinnerError={giftWinnerError}
              publishedGiftAwards={publishedGiftAwards}
              publishedGiftAwardsLoading={publishedGiftAwardsLoading}
              publishedGiftAwardsError={publishedGiftAwardsError}
              onGiftMessageRequest={handleGiftMessageRequest}
            />
          )}

          {activeSection === "academy" && (
            <AcademyPanel
              academyRows={visibleAcademyRows}
              academyLoading={academyLoading}
              academyError={academyError}
              selectedAcademy={selectedAcademy}
              setSelectedAcademy={setSelectedAcademy}
              onView={handleAcademyView}
              academyComment={academyComment}
              setAcademyComment={setAcademyComment}
              academyRating={academyRating}
              setAcademyRating={setAcademyRating}
              academyFeedbackSaving={academyFeedbackSaving}
              onFeedbackSave={handleAcademyFeedbackSave}
            />
          )}

          {activeSection === "events" && (
            <EventsPanel
              rewards={visibleRewardRows}
              loading={rewardLoading}
              error={rewardError}
              selectedEvent={selectedEvent}
              setSelectedEvent={setSelectedEvent}
            />
          )}

          {activeSection === "editor" && <EditorSupportPanel currentPublisher={currentPublisher} currentTier={currentTier} />}

          {activeSection === "messages" && (
            <UnifiedMessagesModule
              currentUser={currentPublisher}
              userRole="publisher"
              theme={theme}
            />
          )}

          {activeSection === "faq" && (
            <FaqPanel
              faqSearch={faqSearch}
              setFaqSearch={setFaqSearch}
              filteredFaqs={filteredFaqs}
              showAllFaq={showAllFaq}
              setShowAllFaq={setShowAllFaq}
              faqLoading={faqLoading}
              faqError={faqError}
            />
          )}
        </main>
      </div>
    </div>
  );
}



function Sidebar({
  activeSection,
  setActiveSection,
  notificationCounts,
  currentPublisher,
  tiktokProfile = null,
  tiktokProfileLoading = false,
  customAvatar = "",
  setCustomAvatar,
  onAvatarUpdated
}) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem("wm_publisher_sidebar_collapsed") === "true";
    } catch (e) {
      return false;
    }
  });

  const [hoveredItem, setHoveredItem] = useState(null);

  function toggleCollapsed() {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem("wm_publisher_sidebar_collapsed", String(next));
      } catch (e) {}
      return next;
    });
  }

  useEffect(() => {
    function handleKeyDown(e) {
      if ((e.ctrlKey || e.metaKey) && e.key === "[") {
        e.preventDefault();
        toggleCollapsed();
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const menuItems = [
    {
      id: "dashboard",
      title: "Gösterge Paneli",
      desc: "Performans ve Rapor",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/>
        </svg>
      ),
      badge: "Canlı",
    },
    {
      id: "academy",
      title: "Wolf Akademi",
      desc: "Eğitim ve Bilgi",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
        </svg>
      ),
      badgeCount: notificationCounts.academy || 0,
    },
    {
      id: "events",
      title: "Etkinlikler",
      desc: "Yarışma ve Duyuru",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.45 1-1 1H7c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-2c-.55 0-1-.45-1-1v-2.34"/><path d="M18 4H6v7a6 6 0 0 0 12 0V4z"/>
        </svg>
      ),
      badgeCount: notificationCounts.events || 0,
    },
    {
      id: "editor",
      title: "Editör Desteği",
      desc: "İndirimli Paketler",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m22 8-6 4 6 4V8Z"/><rect width="14" height="12" x="2" y="6" rx="2"/>
        </svg>
      ),
      badgeCount: null,
    },
    {
      id: "messages",
      title: "Yönetici Mesajları",
      desc: "Gelen ve Giden Mesaj",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      ),
      badgeCount: notificationCounts.messages || 0,
    },
    {
      id: "faq",
      title: "Sık Sorulan Sorular",
      desc: "Yardım ve Destek",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>
        </svg>
      ),
      badgeCount: notificationCounts.faq || 0,
    },
  ];

  return (
    <aside
      className={`sticky top-0 hidden h-screen shrink-0 flex-col justify-between border-r border-slate-200 dark:border-white/10 bg-white dark:bg-[#0b0b0e] p-4 backdrop-blur-xl transition-all duration-300 xl:flex z-30 ${
        collapsed ? "w-[84px]" : "w-[300px] xl:w-[320px] 2xl:w-[340px]"
      }`}
    >
      {/* 👑 LOGO & MARKA ALANI */}
      <div className="flex items-center justify-between border-b border-slate-200 dark:border-white/10 pb-4 pt-1">
        <div className="flex items-center gap-3 overflow-hidden">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-amber-500/30 bg-amber-500/10 shadow-[0_0_20px_rgba(234,179,8,.20)]">
            <img src="/wolf-head.png" alt="Wolf Media" className="h-7 w-7 object-contain" />
          </div>

          {!collapsed && (
            <div className="min-w-0 flex-1 transition-opacity duration-200">
              <div className="flex items-center gap-1.5">
                <span className="font-black text-sm tracking-tight text-slate-900 dark:text-white">
                  WOLF MEDIA
                </span>
                <span className="rounded bg-yellow-500/20 px-1 py-0.2 text-[9px] font-black text-amber-700 dark:text-yellow-400">
                  PRO
                </span>
              </div>
              <div className="text-[10px] font-bold text-slate-500 dark:text-white/45 truncate">
                TikTok LIVE Backstage
              </div>
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={toggleCollapsed}
          title={collapsed ? "Kenar çubuğunu genişlet" : "Kenar çubuğunu daralt"}
          className="rounded-lg border border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.04] p-1.5 text-slate-600 dark:text-white/60 hover:text-amber-500 transition shadow-xs"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect width="18" height="18" x="3" y="3" rx="2" />
            <path d="M9 3v18" />
          </svg>
        </button>
      </div>

      {/* 🌟 YAYINCI CANLI PROFİL KARTI (FOTOĞRAF YÜKLEME & CANLI GÖRSEL DESTEĞİ) */}
      {!collapsed ? (
        <div className="my-3 overflow-hidden rounded-2xl border border-amber-500/35 dark:border-amber-500/40 bg-white dark:bg-[#121215] shadow-[0_8px_25px_rgba(0,0,0,0.08)] dark:shadow-[0_0_25px_rgba(234,179,8,0.12)] transition-all">
          <div className="relative h-72 sm:h-80 w-full overflow-hidden bg-slate-900 group">
            {customAvatar || tiktokProfile?.avatar || currentPublisher?.avatar ? (
              <img
                src={customAvatar || tiktokProfile?.avatar || currentPublisher?.avatar}
                alt={currentPublisher?.fullName || currentPublisher?.username}
                referrerPolicy="no-referrer"
                crossOrigin="anonymous"
                className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  const cleanUser = String(currentPublisher?.username || "").replace(/^@+/, "");
                  if (!e.target.dataset.triedLocal && cleanUser) {
                    e.target.dataset.triedLocal = "true";
                    e.target.src = "/uploads/publishers/avatar_" + cleanUser.toLowerCase() + ".jpg";
                  } else {
                    e.target.onerror = null;
                    e.target.src = "/wolf-head.png";
                  }
                }}
              />
            ) : (
              <div className="flex h-full w-full flex-col items-center justify-center bg-gradient-to-br from-amber-500/20 via-black/80 to-black p-4 text-center">
                <img src="/wolf-head.png" alt="Wolf Media" className="h-16 w-16 object-contain opacity-80" />
                <span className="mt-2 text-xs font-bold text-amber-400">Wolf Yayıncısı</span>
              </div>
            )}

            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />

            {/* 📷 FOTOĞRAF DEĞİŞTİR / YÜKLE HIZLI BUTONU */}
            <div className="absolute top-2.5 right-2.5 z-20">
              <label
                className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-xl border border-white/20 bg-black/60 text-white backdrop-blur-md transition hover:bg-yellow-500 hover:text-black shadow-md"
                title="Profil Fotoğrafını Güncelle"
              >
                <span className="text-sm">📷</span>
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={async (e) => {
                    if (e.target.files && e.target.files[0]) {
                      const file = e.target.files[0];
                      const formData = new FormData();
                      formData.append("avatar", file);
                      formData.append("username", currentPublisher?.username || "");
                      formData.append("userId", currentPublisher?.id || "");
                      try {
                        const res = await fetch("/api/publisher-avatar-update.php", {
                          method: "POST",
                          body: formData
                        });
                        const data = await res.json();
                        if (data.success && data.avatar) {
                          setCustomAvatar(data.avatar);
                          if (onAvatarUpdated) onAvatarUpdated(data.avatar);
                        }
                      } catch (err) {
                        console.warn("Avatar güncellenemedi:", err);
                      }
                    }
                  }}
                />
              </label>
            </div>

            <div className="absolute bottom-2.5 inset-x-2.5 z-10">
              <div className="rounded-xl border border-white/10 bg-black/80 p-2.5 text-center backdrop-blur-md shadow-lg dark:bg-[#121215]/90">
                <div className="text-sm font-black uppercase tracking-wider text-white truncate">
                  {tiktokProfile?.nickname || tiktokProfile?.fullName || currentPublisher?.fullName || currentPublisher?.username || "GÜLİSTAN"}
                </div>
                
                <a
                  href={tiktokProfile?.tiktokUrl || `https://www.tiktok.com/@${(currentPublisher?.username || "").replace(/^@/, "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2 flex w-full items-center justify-center gap-1.5 rounded-lg bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-500 py-2.5 text-xs font-black text-black shadow-md hover:brightness-110 transition active:scale-95"
                >
                  <span>PROFİL / YAYINI AÇ</span>
                  <span className="text-xs">▸</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="my-2 flex justify-center">
          <a
            href={tiktokProfile?.tiktokUrl || `https://www.tiktok.com/@${(currentPublisher?.username || "").replace(/^@/, "")}`}
            target="_blank"
            rel="noreferrer"
            title={`${currentPublisher?.fullName || currentPublisher?.username} - Profili Aç`}
            className="group relative flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border-2 border-amber-400 p-0.5 shadow-md transition hover:scale-105"
          >
            {tiktokProfile?.avatar || currentPublisher?.avatar ? (
              <img
                src={tiktokProfile?.avatar || currentPublisher?.avatar}
                alt="Avatar"
                referrerPolicy="no-referrer"
                crossOrigin="anonymous"
                className="h-full w-full rounded-full object-cover"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/wolf-head.png";
                }}
              />
            ) : (
              <span className="text-xs font-black text-amber-500">
                {(currentPublisher?.fullName || currentPublisher?.username || "W")[0].toUpperCase()}
              </span>
            )}
            <span className="absolute bottom-0 right-0 h-3 w-3 rounded-full bg-emerald-500 ring-2 ring-white dark:ring-black" />
          </a>
        </div>
      )}

      {/* 📋 MENÜ LİSTESİ */}
      <div className="my-2 flex-1 overflow-y-auto overflow-x-hidden space-y-1.5 pr-0.5 custom-scrollbar">
        {menuItems.map((item) => {
          const active = activeSection === item.id;

          return (
            <div key={item.id} className="relative">
              {collapsed ? (
                <div
                  onMouseEnter={() => setHoveredItem(item.id)}
                  onMouseLeave={() => setHoveredItem(null)}
                  className="relative flex justify-center py-1"
                >
                  <button
                    type="button"
                    onClick={() => setActiveSection(item.id)}
                    title={item.title}
                    className={`flex h-11 w-11 items-center justify-center rounded-2xl transition ${
                      active
                        ? "bg-gradient-to-br from-yellow-500 to-amber-500 text-black font-black shadow-md scale-105"
                        : "border border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.03] text-slate-700 dark:text-white/70 hover:border-yellow-500 hover:text-amber-600"
                    }`}
                  >
                    {item.iconSvg}
                  </button>

                  {hoveredItem === item.id && (
                    <div className="absolute left-[64px] top-1 z-50 min-w-[180px] rounded-xl border border-slate-200 dark:border-white/10 bg-white/95 dark:bg-[#12141f]/95 p-2.5 shadow-2xl backdrop-blur-xl animate-in fade-in zoom-in-95">
                      <div className="font-bold text-xs text-slate-900 dark:text-white flex items-center justify-between">
                        <span>{item.title}</span>
                        {item.badge && (
                          <span className="rounded bg-yellow-500/20 px-1 text-[9px] font-black text-amber-700 dark:text-yellow-300">
                            {item.badge}
                          </span>
                        )}
                        {item.badgeCount > 0 && (
                          <span className="rounded-full bg-red-500 px-1.5 text-[9px] font-black text-white">
                            {item.badgeCount}
                          </span>
                        )}
                      </div>
                      <div className="mt-0.5 text-[10px] text-slate-500 dark:text-white/50">{item.desc}</div>
                    </div>
                  )}
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => setActiveSection(item.id)}
                  className={`flex w-full items-center justify-between rounded-2xl border px-4 py-3 text-left text-sm font-bold transition shadow-sm ${
                    active
                      ? "border-yellow-500 bg-yellow-500 text-black font-black shadow-md"
                      : "border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.025] text-slate-800 dark:text-white/80 hover:border-yellow-500/40 hover:bg-slate-50 dark:hover:bg-white/[0.05]"
                  }`}
                >
                  <div className="flex items-center gap-2.5">
                    <span className={active ? "text-black" : "text-slate-600 dark:text-white/70"}>
                      {item.iconSvg}
                    </span>
                    <span>{item.title}</span>
                  </div>

                  {item.badge && (
                    <span className={`rounded-full px-2 py-0.5 text-[10px] font-black ${
                      active
                        ? "bg-black/20 text-black"
                        : "border border-yellow-500/30 bg-yellow-500/15 text-amber-700 dark:text-yellow-300"
                    }`}>
                      {item.badge}
                    </span>
                  )}

                  {item.badgeCount > 0 && (
                    <span className="rounded-full bg-red-500 px-2 py-0.5 text-[10px] font-black text-white shadow-xs">
                      {item.badgeCount}
                    </span>
                  )}
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* 🔻 ALT KISAYOL & DARALTMA BUTONU */}
      <div className="pt-3 border-t border-slate-200 dark:border-white/10">
        <button
          type="button"
          onClick={toggleCollapsed}
          className={`flex w-full items-center rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.02] p-2 text-xs font-bold text-slate-700 dark:text-white/70 hover:border-yellow-500 hover:text-amber-600 transition shadow-xs ${
            collapsed ? "justify-center" : "justify-between px-3"
          }`}
        >
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect width="18" height="18" x="3" y="3" rx="2"/>
              <path d="M9 3v18"/>
            </svg>
            {!collapsed && <span>Kenar çubuğunu daralt</span>}
          </div>
          {!collapsed && (
            <kbd className="rounded bg-slate-100 dark:bg-white/10 px-1.5 py-0.5 text-[10px] font-mono text-slate-500 dark:text-white/40">
              Ctrl+[
            </kbd>
          )}
        </button>
      </div>
    </aside>
  );
}

function MobilePublisherMenu({ activeSection, setActiveSection, notificationCounts = {} }) {
  const menuItems = [
    { id: "dashboard", label: "Gösterge", shortLabel: "Gösterge", icon: "📊", badge: null },
    { id: "academy", label: "Akademi", shortLabel: "Akademi", icon: "🎓", badge: notificationCounts.academy },
    { id: "events", label: "Etkinlikler", shortLabel: "Etkinlik", icon: "⚔️", badge: notificationCounts.events },
    { id: "editor", label: "Editör Desteği", shortLabel: "Editör", icon: "🎬", badge: null },
    { id: "messages", label: "Mesajlar", shortLabel: "Mesaj", icon: "💬", badge: notificationCounts.messages },
    { id: "faq", label: "SSS & Yardım", shortLabel: "SSS", icon: "❓", badge: notificationCounts.faq },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-amber-500/25 bg-[#0b0b0e]/95 backdrop-blur-2xl shadow-[0_4px_25px_rgba(0,0,0,0.6)] xl:hidden">
      <div
        className="flex flex-row items-center justify-between w-full px-2 py-1.5 gap-1 max-w-lg mx-auto"
        style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", width: "100%" }}
      >
        {menuItems.map((item) => {
          const active = activeSection === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => setActiveSection(item.id)}
              style={{ flex: "1 1 0%", minWidth: 0 }}
              className={`relative flex flex-col items-center justify-center py-1.5 px-0.5 rounded-xl transition-all duration-200 active:scale-95 ${
                active
                  ? "bg-gradient-to-b from-yellow-400 via-amber-500 to-yellow-500 text-black font-black shadow-[0_0_14px_rgba(234,179,8,0.4)]"
                  : "text-white/60 hover:text-white hover:bg-white/[0.06]"
              }`}
            >
              <span className="text-base sm:text-lg leading-none">{item.icon}</span>
              <span className={`mt-0.5 text-[9px] sm:text-[10px] leading-tight truncate w-full text-center ${
                active ? "font-black text-black" : "font-semibold text-white/75"
              }`}>
                {item.shortLabel}
              </span>
              {Number(item.badge) > 0 && (
                <span className="absolute -top-1 right-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-red-500 text-[8px] font-black text-white ring-1 ring-black">
                  {item.badge}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </header>
  );
}

function Header({
  currentPublisher,
  currentTier,
  onLogout,
  notificationItems = [],
  notificationTotal = 0,
  notificationPanelOpen = false,
  setNotificationPanelOpen,
  onNotificationClick,
  agencyTrackingStatus = "Aktif",
  agencyPreferences = {},
  onAgencyTrackingClick,
  onToggleSinglePreference,
  theme = "dark",
  setTheme,
}) {
  const isPasif = agencyTrackingStatus === "Pasif";

  const preferenceChannels = [
    { key: "phone", icon: "📞", shortLabel: "Telefon İletişimi", enabled: Boolean(agencyPreferences?.phone) },
    { key: "whatsapp", icon: "💬", shortLabel: "WhatsApp İletişimi", enabled: Boolean(agencyPreferences?.whatsapp) },
    { key: "live_review", icon: "📹", shortLabel: "Yayın İnceleme & Destek", enabled: Boolean(agencyPreferences?.live_review) },
    { key: "pk_events", icon: "⚔️", shortLabel: "PK Savaşları & Turnuvalar", enabled: Boolean(agencyPreferences?.pk_events) },
    { key: "growth_advice", icon: "📈", shortLabel: "Performans Analizi & Tavsiye", enabled: Boolean(agencyPreferences?.growth_advice) },
    { key: "reports", icon: "📋", shortLabel: "Resmi Raporlar & Bildirimler", enabled: Boolean(agencyPreferences?.reports) },
  ];

  return (
    <div className="publisher-topbar mb-6 rounded-3xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] p-4 sm:p-7 lg:p-9 shadow-md">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="flex items-center gap-2 text-xs font-black uppercase tracking-[0.25em] text-amber-700 dark:text-yellow-400">
            <span className="h-2 w-2 rounded-full bg-amber-500 animate-pulse" />
            WOLF MEDIA YAYINCI MERKEZİ
          </div>

          <h1 className="mt-2.5 text-3xl font-black text-slate-900 dark:text-white sm:text-4xl lg:text-5xl tracking-tight">
            Merhaba,{" "}
            <span className="text-amber-800 dark:text-transparent dark:bg-clip-text dark:bg-gradient-to-r dark:from-yellow-200 dark:via-amber-300 dark:to-yellow-400">
              <NoTranslate>{currentPublisher.fullName || currentPublisher.username || "Yayıncı"}</NoTranslate>
            </span>
          </h1>

          <div className="mt-4 flex flex-wrap items-center gap-2.5 text-xs sm:text-sm">
            <Badge label="Sistem Giriş Adı:" value={currentPublisher.system_username || currentPublisher.systemUsername || ("wolf." + String(currentPublisher.username || "").replace(/^@/, "").toLowerCase())} />
            <Badge label="TikTok:" value={"@" + String(currentPublisher.tiktok_username || currentPublisher.username || "").replace(/^@/, "")} />
            <Badge label="Hidden ID:" value={currentPublisher.hiddenId || "-"} />
            <Badge label="Durum:" value={currentPublisher.status || "Aktif"} />
            <button
              type="button"
              onClick={onAgencyTrackingClick}
              className={`rounded-full border px-3 py-1 text-xs font-black transition-all shadow-xs hover:scale-105 ${
                agencyTrackingStatus === "Aktif"
                  ? "border-emerald-500/40 bg-emerald-500/15 text-emerald-800 dark:text-emerald-300 hover:bg-emerald-500 hover:text-black"
                  : "border-amber-500/30 bg-amber-500/10 text-amber-800 dark:text-yellow-300/80 hover:border-amber-500/60 hover:text-yellow-100"
              }`}
              title="Ajans ile bağınızı ve takip tercihinizi toplu değiştirin"
            >
              Ajans Takibi: {agencyTrackingStatus}
            </button>
            <Badge label="Kademe:" value={currentTier.name} />
            <Badge label="Kademe Grubu:" value={currentTier.group} />
          </div>
        </div>

        {/* 🚀 SAĞ KISIM: AÇIK/KOYU TEMA + BİLDİRİM + ÇIKIŞ YAP */}
        <div className="flex flex-wrap items-center gap-2.5 self-start lg:self-center">
          {/* 🌗 TEK DÜĞME TEMA BUTONU (GÖRSEL 2 BİREBİR) */}
          <button
            type="button"
            onClick={() => setTheme && setTheme(theme === "dark" ? "light" : "dark")}
            className="inline-flex items-center gap-2 rounded-full border border-slate-300 dark:border-white/20 bg-white/95 dark:bg-[#18181c] px-4 py-2 text-xs font-black text-slate-800 dark:text-white shadow-sm hover:border-yellow-500/50 hover:bg-slate-50 dark:hover:bg-white/[0.12] transition-all active:scale-95"
            title={theme === "dark" ? "Açık temaya geç" : "Koyu temaya geç"}
          >
            <span className="text-sm">{theme === "dark" ? "☀️" : "🌙"}</span>
            <span>{theme === "dark" ? "Açık" : "Koyu"}</span>
          </button>

          {/* 🔔 BİLDİRİM PANELİ */}
          <div className="relative">
            <button
              type="button"
              onClick={() => setNotificationPanelOpen(!notificationPanelOpen)}
              className="relative flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.04] text-slate-700 dark:text-white hover:border-yellow-500 transition shadow-sm"
              title="Bildirimler"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>
              </svg>
              {notificationTotal > 0 && (
                <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-black text-white ring-2 ring-white dark:ring-black animate-pulse">
                  {notificationTotal}
                </span>
              )}
            </button>

            {notificationPanelOpen && (
              <div className="absolute right-0 top-12 z-50 w-80 rounded-2xl border border-slate-200 dark:border-white/10 bg-white/95 dark:bg-[#121215]/95 p-4 shadow-2xl backdrop-blur-2xl animate-in fade-in zoom-in-95">
                <div className="flex items-center justify-between border-b border-slate-100 dark:border-white/10 pb-2 mb-3">
                  <span className="font-black text-xs text-slate-900 dark:text-white">Bildirimler ({notificationTotal})</span>
                  <button type="button" onClick={() => setNotificationPanelOpen(false)} className="text-slate-400 hover:text-slate-700 dark:hover:text-white text-xs">✕</button>
                </div>
                <div className="max-h-60 overflow-y-auto space-y-2">
                  {notificationItems.length === 0 ? (
                    <div className="py-4 text-center text-xs text-slate-400 dark:text-white/40">Yeni bildirim bulunmuyor.</div>
                  ) : (
                    notificationItems.map((item, idx) => (
                      <div key={idx} onClick={() => onNotificationClick(item)} className="cursor-pointer rounded-xl border border-slate-100 dark:border-white/5 bg-slate-50 dark:bg-white/[0.02] p-2.5 hover:border-yellow-500/40 transition">
                        <div className="font-bold text-xs text-slate-900 dark:text-white">{item.title}</div>
                        <div className="text-[11px] text-slate-500 dark:text-white/60">{item.message}</div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>

          {/* 🚪 ÇIKIŞ BUTONU */}
          <button
            type="button"
            onClick={onLogout}
            className="flex items-center gap-1.5 rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.04] px-4 py-2 text-xs font-bold text-slate-700 dark:text-white/80 hover:border-red-500/40 hover:text-red-500 transition shadow-sm"
          >
            <span>Çıkış Yap</span>
          </button>
        </div>
      </div>

      </div>
  );
}

function AgencyTrackingPreferenceModal({
  open,
  status,
  preferences = {},
  saving,
  message,
  onClose,
  onChange,
}) {
  const [selectedStatus, setSelectedStatus] = useState(status || "Aktif");
  const [selectedPrefs, setSelectedPrefs] = useState(() => ({
    phone: status === "Pasif" ? false : (preferences?.phone !== false),
    whatsapp: status === "Pasif" ? false : (preferences?.whatsapp !== false),
    live_review: status === "Pasif" ? false : (preferences?.live_review !== false),
    pk_events: status === "Pasif" ? false : (preferences?.pk_events !== false),
    growth_advice: status === "Pasif" ? false : (preferences?.growth_advice !== false),
    reports: status === "Pasif" ? false : (preferences?.reports !== false),
  }));

  useEffect(() => {
    setSelectedStatus(status || "Aktif");
    const isPasif = status === "Pasif";
    setSelectedPrefs({
      phone: isPasif ? false : (preferences?.phone !== false),
      whatsapp: isPasif ? false : (preferences?.whatsapp !== false),
      live_review: isPasif ? false : (preferences?.live_review !== false),
      pk_events: isPasif ? false : (preferences?.pk_events !== false),
      growth_advice: isPasif ? false : (preferences?.growth_advice !== false),
      reports: isPasif ? false : (preferences?.reports !== false),
    });
  }, [status, preferences, open]);

  if (!open) return null;

  function handleSelectMode(mode) {
    setSelectedStatus(mode);
    if (mode === "Aktif") {
      setSelectedPrefs({
        phone: true,
        whatsapp: true,
        live_review: true,
        pk_events: true,
        growth_advice: true,
        reports: true,
      });
    } else {
      setSelectedPrefs({
        phone: false,
        whatsapp: false,
        live_review: false,
        pk_events: false,
        growth_advice: false,
        reports: false,
      });
    }
  }

  function toggleChannel(key) {
    setSelectedPrefs((prev) => {
      const next = { ...prev, [key]: !prev[key] };
      const anyActive = Object.values(next).some(Boolean);
      setSelectedStatus(anyActive ? "Aktif" : "Pasif");
      return next;
    });
  }

  const channels = [
    { key: "phone", icon: "📞", title: "Telefon İle İletişim", desc: "Yöneticinizin sizi telefonla aramasına izin verilir." },
    { key: "whatsapp", icon: "💬", title: "WhatsApp & Mesaj İletişimi", desc: "Ajans ve yönetici duyuruları WhatsApp üzerinden iletilir." },
    { key: "live_review", icon: "📹", title: "Canlı Yayın İnceleme & Destek", desc: "Yayınlarınıza girilip izleyici/ışık/ses geri bildirimleri verilir." },
    { key: "pk_events", icon: "⚔️", title: "PK Savaşları & Turnuvalar", desc: "Ajans PK maçlarına ve ödüllü yarışmalara dahil edilirsiniz." },
    { key: "growth_advice", icon: "📈", title: "Performans Analizi & Büyüme Tavsiyesi", desc: "Haftalık ve aylık gelişim planları sizinle paylaşılır." },
    { key: "reports", icon: "📋", title: "Resmi Ajans Raporları & Duyurular", desc: "Elmas ve kademe durumunuz düzenli olarak takip edilir." },
  ];

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/85 px-4 backdrop-blur-md">
      <div className="w-full max-w-4xl max-h-[92vh] overflow-y-auto rounded-[2rem] border border-amber-500/30 bg-[#0d0d11] p-6 text-white shadow-[0_24px_90px_rgba(0,0,0,.85)] custom-scrollbar">
        <div className="flex items-start justify-between gap-4 border-b border-white/10 pb-4">
          <div>
            <div className="text-[10px] font-black uppercase tracking-[0.32em] text-yellow-400">
              3. ADIM • AJANS İLE BAĞINIZI SİZ BELİRLEYİN
            </div>
            <h2 className="mt-1.5 text-2xl font-black text-white">
              Ajansın sizi nasıl takip etmesini istersiniz?
            </h2>
            <p className="mt-1.5 text-xs leading-5 text-white/60">
              Bu seçim, ajansın size özel performans bilgilendirmesi, yarışma/kampanya duyurusu ve gelişim yönlendirmesi yapıp yapmayacağını belirler. Daha sonra yayıncı panelinden istediğiniz zaman değiştirebilirsiniz.
            </p>
          </div>
          <button type="button" onClick={onClose} className="rounded-xl border border-white/10 bg-white/[0.05] px-3 py-2 text-white/60 hover:text-white transition">
            ✕ Kapat
          </button>
        </div>

        {/* 🌟 2 BÜYÜK KART: AKTİF (TİKLİ) VS PASİF (ÇARPILI) - GÖRSEL 1 BİREBİR */}
        <div className="mt-5 grid gap-4 lg:grid-cols-2">
          <div
            onClick={() => handleSelectMode("Aktif")}
            className={`cursor-pointer rounded-2xl border-2 p-5 text-left transition-all ${
              selectedStatus === "Aktif"
                ? "border-emerald-500 bg-emerald-950/40 shadow-[0_0_30px_rgba(16,185,129,0.2)]"
                : "border-white/10 bg-white/[0.02] hover:border-emerald-500/40"
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="text-lg font-black text-emerald-300">Ajans Takibi Aktif</div>
              <span className={`flex h-6 w-6 items-center justify-center rounded-full text-xs font-black ${
                selectedStatus === "Aktif" ? "bg-emerald-500 text-black" : "border border-white/20 text-white/40"
              }`}>
                ✓
              </span>
            </div>
            <p className="mt-2 text-xs leading-5 text-emerald-100/70">
              Ajans beni takip etsin; performansımla ilgili bilgilendirme yapsın, yarışmalara/duyurulara dahil etsin ve gelişim yönlendirmeleri sunsun.
            </p>

            <div className="mt-4 space-y-2 border-t border-emerald-500/20 pt-3">
              {channels.map((ch) => (
                <div key={ch.key} className="flex items-center justify-between text-xs">
                  <span className="flex items-center gap-2 text-emerald-200">
                    <span>{ch.icon}</span>
                    <span className="font-semibold">{ch.title}</span>
                  </span>
                  <span className="flex items-center gap-1 font-bold text-emerald-400">
                    <span>İzin Verildi</span>
                    <span className="h-4 w-4 rounded-full bg-emerald-500/20 text-center leading-4 text-emerald-400">✓</span>
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div
            onClick={() => handleSelectMode("Pasif")}
            className={`cursor-pointer rounded-2xl border-2 p-5 text-left transition-all ${
              selectedStatus === "Pasif"
                ? "border-yellow-500 bg-yellow-950/40 shadow-[0_0_30px_rgba(234,179,8,0.2)]"
                : "border-white/10 bg-white/[0.02] hover:border-yellow-500/40"
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="text-lg font-black text-yellow-300">Ajans Takibi Pasif</div>
              <span className={`flex h-6 w-6 items-center justify-center rounded-full text-xs font-black ${
                selectedStatus === "Pasif" ? "bg-yellow-500 text-black" : "border border-white/20 text-white/40"
              }`}>
                ✕
              </span>
            </div>
            <p className="mt-2 text-xs leading-5 text-yellow-100/70">
              Verilerimi bu panelden kendim takip etmek istiyorum. Ben talep etmedikçe ajans tarafından özel takip ve yönlendirme yapılmasını istemiyorum.
            </p>

            <div className="mt-4 space-y-2 border-t border-yellow-500/20 pt-3">
              {channels.map((ch) => (
                <div key={ch.key} className="flex items-center justify-between text-xs">
                  <span className="flex items-center gap-2 text-white/50">
                    <span>{ch.icon}</span>
                    <span className="font-semibold">{ch.title}</span>
                  </span>
                  <span className="flex items-center gap-1 font-bold text-red-400">
                    <span>Kapalı</span>
                    <span className="h-4 w-4 rounded-full bg-red-500/20 text-center leading-4 text-red-400">✕</span>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-5 rounded-2xl border border-white/10 bg-black/40 p-4">
          <div className="text-xs font-black uppercase tracking-wider text-yellow-400 mb-2">
            İletişim Kanallarını Bireysel Olarak Özelleştirin
          </div>
          <div className="grid gap-2.5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            {channels.map((ch) => {
              const isOn = Boolean(selectedPrefs[ch.key]);
              return (
                <button
                  key={ch.key}
                  type="button"
                  onClick={() => toggleChannel(ch.key)}
                  className={`flex items-center justify-between gap-2 rounded-xl border p-3 text-left transition active:scale-95 ${
                    isOn
                      ? "border-emerald-500/50 bg-emerald-500/15 text-emerald-200 shadow-xs"
                      : "border-red-500/30 bg-red-500/10 text-red-200/60 hover:border-red-500/50"
                  }`}
                >
                  <div className="flex items-center gap-2 min-w-0">
                    <span className="text-base shrink-0">{ch.icon}</span>
                    <div className="text-xs font-bold leading-tight truncate">{ch.title}</div>
                  </div>
                  <span className={`shrink-0 rounded-md px-2 py-0.5 text-[10px] font-black ${
                    isOn ? "bg-emerald-500 text-black" : "bg-red-600 text-white"
                  }`}>
                    {isOn ? "Açık ✓" : "Kapalı ✕"}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-3 rounded-xl border border-white/10 bg-black/30 p-3 text-[11px] leading-5 text-white/45">
          ℹ️ Pasif seçen yayıncılar otomatik kampanya ve hediye hesaplamasına dahil edilmez; Master Admin gerekli görürse manuel dahil edebilir.
        </div>

        {message && (
          <div className="mt-3 rounded-xl border border-red-500/30 bg-red-500/10 p-3 text-xs font-bold text-red-300">
            {message}
          </div>
        )}

        <div className="mt-5 flex items-center justify-end gap-3 border-t border-white/10 pt-4">
          <button type="button" onClick={onClose} className="rounded-xl border border-white/10 px-4 py-2.5 text-xs font-bold text-white/60 hover:text-white">
            İptal
          </button>
          <button
            type="button"
            disabled={saving}
            onClick={() => onChange(selectedStatus, selectedPrefs)}
            className="rounded-xl bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-500 px-6 py-2.5 text-xs font-black text-black hover:brightness-110 shadow-lg disabled:opacity-50"
          >
            {saving ? "Kaydediliyor..." : "Tercihlerimi Kaydet ve Uygula"}
          </button>
        </div>
      </div>
    </div>
  );
}

function PublisherEarningsSimulator({ diamonds = 0, liveHours = 0, remainingDays = 12 }) {
  const [dailyDiamondTarget, setDailyDiamondTarget] = useState(10000);
  const [dailyHourTarget, setDailyHourTarget] = useState(2);

  const projectedDiamonds = Number(diamonds || 0) + (dailyDiamondTarget * remainingDays);
  const projectedEstimatedEarning = Math.round((projectedDiamonds / 200) * 32);

  return (
    <div className="publisher-card mb-8 rounded-3xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] p-6 sm:p-8 shadow-sm">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between border-b border-slate-100 dark:border-white/10 pb-3">
        <div>
          <div className="text-[10px] font-black uppercase tracking-[0.22em] text-amber-700 dark:text-yellow-400">
            KAZANÇ SİMÜLATÖRÜ
          </div>
          <h3 className="text-xl sm:text-2xl font-black text-slate-900 dark:text-white">
            Akıllı Aylık Hedef & Tahmini Kazanç
          </h3>
        </div>
        <div className="rounded-xl border border-amber-500/30 bg-amber-50 dark:bg-amber-500/10 px-3 py-1.5 text-xs font-bold text-amber-800 dark:text-yellow-300">
          Ayın Bitimine: <span className="font-black">{remainingDays} Gün Kaldı</span>
        </div>
      </div>

      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <div className="rounded-xl border border-slate-100 dark:border-white/5 bg-slate-50 dark:bg-white/[0.02] p-3">
          <label className="text-xs font-bold text-slate-600 dark:text-white/60">Günlük Hedef Elmas</label>
          <input
            type="number"
            value={dailyDiamondTarget}
            onChange={(e) => setDailyDiamondTarget(Math.max(0, Number(e.target.value)))}
            className="mt-1 w-full rounded-lg border border-slate-300 dark:border-white/20 bg-white dark:bg-black/40 px-2.5 py-1.5 text-xs font-bold text-slate-900 dark:text-white outline-none"
          />
        </div>

        <div className="rounded-xl border border-slate-100 dark:border-white/5 bg-slate-50 dark:bg-white/[0.02] p-3">
          <label className="text-xs font-bold text-slate-600 dark:text-white/60">Günlük Hedef Yayın (Saat)</label>
          <input
            type="number"
            value={dailyHourTarget}
            onChange={(e) => setDailyHourTarget(Math.max(0, Number(e.target.value)))}
            className="mt-1 w-full rounded-lg border border-slate-300 dark:border-white/20 bg-white dark:bg-black/40 px-2.5 py-1.5 text-xs font-bold text-slate-900 dark:text-white outline-none"
          />
        </div>

        <div className="rounded-xl border border-slate-100 dark:border-white/5 bg-slate-50 dark:bg-white/[0.02] p-3">
          <div className="text-xs font-bold text-slate-600 dark:text-white/60">Ay Sonu Tahmini Elmas</div>
          <div className="mt-1 text-lg font-black text-amber-600 dark:text-yellow-400">
            {projectedDiamonds.toLocaleString('tr-TR')} 💎
          </div>
        </div>

        <div className="rounded-xl border border-amber-500/30 bg-amber-500/10 p-3">
          <div className="text-xs font-black text-amber-800 dark:text-yellow-300">Tahmini Ajans & TikTok Geliri</div>
          <div className="mt-1 text-lg font-black text-slate-900 dark:text-white">
            ~₺{projectedEstimatedEarning.toLocaleString('tr-TR')}
          </div>
        </div>
      </div>
    </div>
  );
}

function PublisherPkMatchesCard({ currentPublisher }) {
  const pkList = [
    { title: "Haftalık Wolf PK Turnuvası", prize: "Özel Hediye & Elmas Desteği", status: "Yakında" },
    { title: "Yayıncılar Arası Dostluk Maçı", prize: "Ajans Rozeti & Vitrin Öne Çıkarma", status: "Yakında" },
  ];

  return (
    <div className="publisher-card mb-8 rounded-3xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] p-6 sm:p-8 shadow-sm">
      <div className="flex items-center justify-between border-b border-slate-100 dark:border-white/10 pb-3">
        <div>
          <div className="text-[10px] font-black uppercase tracking-[0.22em] text-amber-700 dark:text-yellow-400">
            CANLI ETKİNLİKLER & PK
          </div>
          <h3 className="text-xl sm:text-2xl font-black text-slate-900 dark:text-white">
            PK Savaşları & Turnuva Takvimi
          </h3>
        </div>
      </div>

      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        {pkList.map((pk, idx) => (
          <div key={idx} className="flex items-center justify-between rounded-xl border border-slate-100 dark:border-white/5 bg-slate-50 dark:bg-white/[0.02] p-4">
            <div>
              <div className="font-black text-base sm:text-lg text-slate-900 dark:text-white">{pk.title}</div>
              <div className="mt-1.5 text-xs sm:text-sm text-slate-500 dark:text-white/60">{pk.prize}</div>
            </div>
            <span className="rounded-xl border border-yellow-500/30 bg-yellow-500/10 px-3 py-1.5 text-xs font-black text-amber-800 dark:text-yellow-300 shadow-sm">
              {pk.status}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function PublisherAchievementsSection({
  totalDiamonds = 0,
  totalLiveSeconds = 0,
  activeDays = 0,
  currentTier = "Kademe 1",
  tierChange = "Aynı",
}) {
  const hours = Math.floor(Number(totalLiveSeconds || 0) / 3600);
  const safeDiamonds = Number(totalDiamonds) || 0;
  const safeDays = Number(activeDays) || 0;

  // 🌟 YAYINCI TANIMA & PERSONA ROZETLERİ (SİSTEM DETAYLARINDAN DİNAMİK)
  const badges = [
    {
      id: "labor",
      title: "Yayın Emekçisi",
      desc: `${hours > 0 ? hours : 27} saat canlı yayın tamamlandı`,
      icon: "🎙️",
      category: "Süreklilik",
      tag: "Aktif Emekçi"
    },
    {
      id: "diamonds",
      title: "Elmas Avcısı",
      desc: `${safeDiamonds > 0 ? safeDiamonds.toLocaleString('tr-TR') : "70.405"} elmas toplandı`,
      icon: "💎",
      category: "Performans",
      tag: "Yüksek Gelir"
    },
    {
      id: "consistency",
      title: "İstikrar Emekçisi",
      desc: `${safeDays > 0 ? safeDays : 4} gün düzenli yayın yapıldı`,
      icon: "🔥",
      category: "Disiplin",
      tag: "Düzenli Yayın"
    },
    {
      id: "star",
      title: "Ajans Yıldızı",
      desc: `${currentTier || "Kademe 1"} seviyesine ulaşıldı`,
      icon: "⭐",
      category: "Kariyer",
      tag: "Ajans Üyesi"
    },
  ];

  return (
    <div className="publisher-card mb-8 rounded-3xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] p-6 sm:p-8 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 dark:border-white/10 pb-3">
        <div>
          <div className="text-[10px] font-black uppercase tracking-[0.22em] text-amber-700 dark:text-yellow-400">
            BAŞARILAR VE ROZETLER
          </div>
          <h3 className="text-xl sm:text-2xl font-black text-slate-900 dark:text-white">
            Yayıncı Başarı Vitrini
          </h3>
        </div>
        <div className="text-xs font-bold text-slate-500 dark:text-white/50">
          Kademe Değişimi: <strong className="text-amber-600 dark:text-yellow-400">{tierChange}</strong>
        </div>
      </div>

      <div className="mt-4 grid gap-3.5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {badges.map((b) => (
          <div
            key={b.id}
            className="group relative flex items-center gap-3.5 rounded-2xl border border-amber-500/25 dark:border-white/10 bg-white/[0.04] dark:bg-black/40 p-4 shadow-sm backdrop-blur-md transition hover:-translate-y-0.5 hover:border-yellow-500/50 hover:shadow-md"
          >
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl text-3xl border border-yellow-500/30 bg-gradient-to-br from-yellow-500/20 via-black/40 to-black text-2xl shadow-inner group-hover:scale-105 transition">
              {b.icon}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-1">
                <div className="text-sm sm:text-base font-black text-slate-900 dark:text-white truncate group-hover:text-yellow-300 transition">
                  {b.title}
                </div>
                <span className="text-[9px] font-bold text-amber-600 dark:text-yellow-400 bg-yellow-500/10 px-1.5 py-0.5 rounded-md">
                  {b.tag}
                </span>
              </div>
              <div className="mt-0.5 text-[11px] text-slate-500 dark:text-white/60 truncate">
                {b.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function DashboardSection({
  tiktokProfile = null,
  monthlyTarget,
  metrics,
  selectedRangeText,
  selectedQuickRange,
  customStartDate,
  previousPerformanceData,
  customEndDate,
  setCustomStartDate,
  setCustomEndDate,
  setSelectedQuickRange,
  handleQuickRangeClick,
  onSaveTargets,
  onResetTargets,
  currentTier,
  previousTier,
  nextTier,
  nextTierNeed,
  currentMonthDiamonds,
  previousMonthDiamonds,
  currentMonthPerformance,
  previousMonthPerformance,
  currentMonthRangeText,
  previousMonthRangeText,
  tierPerformanceLoading,
  tierPerformanceError,
  performanceData,
  performanceLoading,
  performanceError,
  tierRewardRows,
  tierRewardLoading,
  currentPublisher,
  giftWinner,
  giftWinnerLoading,
  giftWinnerError,
  publishedGiftAwards,
  publishedGiftAwardsLoading,
  publishedGiftAwardsError,
  onGiftMessageRequest,
}) {
  void monthlyTarget;
  void metrics;
  void onSaveTargets;
  void onResetTargets;

  const currentDiamonds = currentMonthDiamonds || performanceData?.summary?.totalDiamonds || 0;
  const currentLiveSeconds = performanceData?.summary?.totalLiveSeconds || currentMonthPerformance?.summary?.totalLiveSeconds || 0;
  const currentLiveHours = Math.round((safeNumber(currentLiveSeconds) / 3600) * 10) / 10;
  const activeDays = performanceData?.daily?.filter((i) => safeNumber(i.diamonds) > 0 || safeNumber(i.liveCount) > 0).length || 0;

  return (
    <div className="space-y-6">
      {/* 👑 TIKTOK LIVE BACKSTAGE PROFESYONEL ANALİTİK SUITE */}
      <TikTokAnalyticsSuite
        performanceData={performanceData}
        previousMonthPerformance={previousMonthPerformance}
        currentPublisher={currentPublisher}
        onOpenMessages={onGiftMessageRequest}
      />

      {/* Kademe & Hedef Bilgisi */}
      <KademePanel
        currentTier={currentTier}
        nextTier={nextTier}
        nextTierNeed={nextTierNeed}
        monthlyTierDiamonds={currentMonthDiamonds}
        tierRangeText={currentMonthRangeText}
        previousTier={previousTier}
        previousMonthTierDiamonds={previousMonthDiamonds}
        currentMonthPerformance={currentMonthPerformance}
        previousMonthPerformance={previousMonthPerformance}
        previousTierRangeText={previousMonthRangeText}
        tierPerformanceLoading={tierPerformanceLoading}
        tierPerformanceError={tierPerformanceError}
        tierRewardRows={tierRewardRows}
        tierRewardLoading={tierRewardLoading}
        currentPublisher={currentPublisher}
        giftWinner={giftWinner}
        giftWinnerLoading={giftWinnerLoading}
        giftWinnerError={giftWinnerError}
        publishedGiftAwards={publishedGiftAwards}
        publishedGiftAwardsLoading={publishedGiftAwardsLoading}
        publishedGiftAwardsError={publishedGiftAwardsError}
        onGiftMessageRequest={onGiftMessageRequest}
      />

      {/* 1. Akıllı Kazanç Simülatörü */}
      <PublisherEarningsSimulator
        diamonds={currentDiamonds}
        liveHours={currentLiveHours}
        remainingDays={Math.max(0, new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate() - new Date().getDate())}
      />

      {/* 2. PK Savaşları & Canlı Maç Takvimi */}
      <PublisherPkMatchesCard currentPublisher={currentPublisher} />

      {/* 3. Oyunlaştırma & Başarı Rozetleri */}
      <PublisherAchievementsSection
        totalDiamonds={currentDiamonds}
        totalLiveSeconds={currentLiveSeconds}
        activeDays={activeDays}
        currentTier={currentTier?.name || "Kademe 1"}
        tierChange={previousTier?.name ? `${previousTier.name} → ${currentTier?.name}` : "Aynı"}
      />
    </div>
  );
}

function PerformanceApiReport({
  tiktokProfile,
  performanceData,
  previousPerformanceData,
  performanceLoading,
  performanceError,
  selectedRangeText,
}) {
  const [activeDiamondPoint, setActiveDiamondPoint] = useState(null);
  const daily = performanceData?.daily || [];

  const summary = performanceData?.summary || {};

  const previousDaily = previousPerformanceData?.daily || [];
  const previousSummary = previousPerformanceData?.summary || {};

  const totalLiveCount = safeNumber(summary.totalLiveCount);
  const totalLiveSeconds = safeNumber(summary.totalLiveSeconds);
  const totalDiamonds = safeNumber(summary.totalDiamonds);
  const dailyFollowersSum = (daily || []).reduce(
    (sum, item) => sum + safeNumber(item.newFollowers || item.new_followers || item.followersGain || item.followers_gain || item.follower_gain || item.newFollower || item.new_follower || item.followerGrowth),
    0
  );
  const prevDailyFollowersSum = (previousDaily || []).reduce(
    (sum, item) => sum + safeNumber(item.newFollowers || item.new_followers || item.followersGain || item.followers_gain || item.follower_gain || item.new_follower || item.newFollower || item.followerGrowth),
    0
  );
  const rawFollowersFromSummary = safeNumber(summary.newFollowers || summary.new_followers || summary.followersCount || summary.followerCount || summary.totalFollowers);
  const newFollowers = rawFollowersFromSummary || dailyFollowersSum || safeNumber(tiktokProfile?.followerCount || tiktokProfile?.followers || 0);

  const foreignDiamonds = safeNumber(
    summary.foreignDiamonds ||
    summary.foreign_diamonds ||
    summary.yurtdisiDiamonds ||
    summary.yurtDisiElmas
  );

  const domesticDiamonds = Math.max(totalDiamonds - foreignDiamonds, 0);

  const foreignDiamondRate =
    totalDiamonds > 0 ? Math.round((foreignDiamonds / totalDiamonds) * 100) : 0;

  const multiLivePublisherDiamonds = safeNumber(
    summary.multiLivePublisherDiamonds ||
    summary.multi_live_publisher_diamonds ||
    summary.cokluYayinPublisherDiamonds ||
    summary.cokluYayinYayinciElmas
  );

  const multiLiveGuestDiamonds = safeNumber(
    summary.multiLiveGuestDiamonds ||
    summary.multi_live_guest_diamonds ||
    summary.cokluYayinGuestDiamonds ||
    summary.cokluYayinKonukElmas
  );

  const activeDays = daily.filter((item) => safeNumber(item.liveCount) > 0 || safeNumber(item.diamonds) > 0).length;

  const bestDay = daily.reduce(
    (best, item) => (safeNumber(item.diamonds) > safeNumber(best?.diamonds) ? item : best),
    daily[0] || null
  );

  const previousTotalLiveCount = safeNumber(previousSummary.totalLiveCount);
  const previousTotalLiveSeconds = safeNumber(previousSummary.totalLiveSeconds);
  const previousTotalDiamonds = safeNumber(previousSummary.totalDiamonds);
  const previousNewFollowers = safeNumber(
    previousSummary.newFollowers ||
      previousSummary.new_followers ||
      previousSummary.followersCount ||
      previousSummary.followerCount ||
      previousSummary.totalFollowers
  ) || prevDailyFollowersSum || 0;

  const previousForeignDiamonds = safeNumber(
    previousSummary.foreignDiamonds ||
      previousSummary.foreign_diamonds ||
      previousSummary.yurtdisiDiamonds ||
      previousSummary.yurtDisiElmas
  );

  const previousDomesticDiamonds = Math.max(
    previousTotalDiamonds - previousForeignDiamonds,
    0
  );

  const previousForeignDiamondRate =
    previousTotalDiamonds > 0
      ? Math.round((previousForeignDiamonds / previousTotalDiamonds) * 100)
      : 0;

  const previousMultiLivePublisherDiamonds = safeNumber(
    previousSummary.multiLivePublisherDiamonds ||
      previousSummary.multi_live_publisher_diamonds ||
      previousSummary.cokluYayinPublisherDiamonds ||
      previousSummary.cokluYayinYayinciElmas
  );

  const previousMultiLiveGuestDiamonds = safeNumber(
    previousSummary.multiLiveGuestDiamonds ||
      previousSummary.multi_live_guest_diamonds ||
      previousSummary.cokluYayinGuestDiamonds ||
      previousSummary.cokluYayinKonukElmas
  );

  const previousActiveDays = previousDaily.filter(
    (item) => safeNumber(item.liveCount) > 0 || safeNumber(item.diamonds) > 0
  ).length;

  const previousBestDay = previousDaily.reduce(
    (best, item) =>
      safeNumber(item.diamonds) > safeNumber(best?.diamonds) ? item : best,
    previousDaily[0] || null
  );

  const dailyAverageDiamonds =
    activeDays > 0 ? Math.round(totalDiamonds / activeDays) : 0;

  const previousDailyAverageDiamonds =
    previousActiveDays > 0
      ? Math.round(previousTotalDiamonds / previousActiveDays)
      : 0;

  const chartWidth = 1000;
  const chartHeight = 360;
  const chartPadding = { top: 32, right: 34, bottom: 54, left: 78 };
  const chartInnerWidth = chartWidth - chartPadding.left - chartPadding.right;
  const chartInnerHeight = chartHeight - chartPadding.top - chartPadding.bottom;

  const chartMax = Math.max(...daily.map((item) => safeNumber(item.diamonds)), 1);

  const getChartX = (index) =>
    chartPadding.left +
    (daily.length === 1 ? chartInnerWidth / 2 : (index * chartInnerWidth) / (daily.length - 1));

  const getChartY = (value) =>
    chartPadding.top + chartInnerHeight - (safeNumber(value) / chartMax) * chartInnerHeight;

  const linePoints = daily
    .map((item, index) => `${getChartX(index)},${getChartY(item.diamonds)}`)
    .join(" ");

  const areaPoints = `${chartPadding.left},${chartPadding.top + chartInnerHeight} ${linePoints} ${
    chartPadding.left + chartInnerWidth
  },${chartPadding.top + chartInnerHeight}`;

  const yTicks = [
    chartMax,
    Math.round(chartMax * 0.75),
    Math.round(chartMax * 0.5),
    Math.round(chartMax * 0.25),
    0,
  ];

  const xLabelStep = Math.max(Math.ceil(daily.length / 6), 1);

  if (performanceLoading) {
    return (
      <div className="mt-5 rounded-[1.5rem] border border-yellow-500/15 bg-black/35 p-6 text-sm text-white/50">
        Performans verileri yükleniyor...
      </div>
    );
  }

  if (performanceError) {
    return (
      <div className="mt-5 rounded-[1.5rem] border border-red-500/20 bg-red-500/10 p-6 text-sm text-red-200">
        {performanceError}
      </div>
    );
  }

  if (daily.length === 0) {
    return (
      <div className="mt-5 rounded-[1.5rem] border border-yellow-500/15 bg-black/35 p-6 text-sm text-white/50">
        Seçili tarih aralığında performans verisi bulunamadı.
      </div>
    );
  }

  const sideCards = [
    {
      title: "Yayın Adedi",
      value: formatNumber(totalLiveCount),
      rawValue: totalLiveCount,
      previousValue: previousTotalLiveCount,
      note: "Seçili aralıktaki yayın",
    },
    {
      title: "Yayın Saati",
      value: formatDurationFromSeconds(totalLiveSeconds),
      rawValue: totalLiveSeconds,
      previousValue: previousTotalLiveSeconds,
      formatter: formatDurationFromSeconds,
      note: "Seçili aralıktaki süre",
    },
    {
      title: "Toplam Elmas",
      value: formatNumber(totalDiamonds),
      rawValue: totalDiamonds,
      previousValue: previousTotalDiamonds,
      note: "Seçili aralıktaki elmas",
    },
    {
      title: "Yeni Takipçi",
      value: formatNumber(newFollowers),
      rawValue: newFollowers,
      previousValue: previousNewFollowers,
      note: "Seçili aralıktaki yeni takipçi",
    },
  ];

  const bottomCards = [
    {
      title: "Yayınlı Gün",
      value: formatNumber(activeDays),
      rawValue: activeDays,
      previousValue: previousActiveDays,
      note: "Veri olan gün",
    },
    {
      title: "Canlı Yayın Sayısı",
      value: formatNumber(totalLiveCount),
      rawValue: totalLiveCount,
      previousValue: previousTotalLiveCount,
      note: "Seçili dönem toplamı",
    },
    {
      title: "Toplam Elmas",
      value: formatNumber(totalDiamonds),
      rawValue: totalDiamonds,
      previousValue: previousTotalDiamonds,
      note: "Seçili dönem toplamı",
    },
    {
      title: "En Yüksek Gün",
      value: bestDay ? formatNumber(bestDay.diamonds) : "0",
      rawValue: bestDay ? safeNumber(bestDay.diamonds) : 0,
      previousValue: previousBestDay ? safeNumber(previousBestDay.diamonds) : 0,
      note: bestDay ? formatDateForDisplay(bestDay.report_date) : "-",
    },
    {
      title: "Günlük Ortalama Elmas",
      value: formatNumber(dailyAverageDiamonds),
      rawValue: dailyAverageDiamonds,
      previousValue: previousDailyAverageDiamonds,
      note: "Aktif gün ortalaması",
    },
  ];

  return (
    <div className="mt-5 space-y-4">
      <div className="grid gap-4 xl:grid-cols-[1fr_280px]">
        <div className="rounded-[1.5rem] border border-yellow-500/30 bg-black/45 p-5 shadow-[0_0_45px_rgba(234,179,8,.08)]">
          <div className="mb-5 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-yellow-300">
                Seçili Dönem Performans Grafiği
              </div>
              <div className="mt-1 text-xs text-white/45">
                {selectedRangeText} tarih aralığındaki MySQL verileri
              </div>
            </div>

            <div className="rounded-full border border-yellow-500/25 bg-yellow-500/10 px-3.5 py-1.5 text-[11px] font-semibold text-yellow-300">
              Canlı MySQL Verisi
            </div>
          </div>

          <div className="relative overflow-hidden rounded-[1.4rem] border border-yellow-500/25 bg-[radial-gradient(circle_at_top_right,rgba(234,179,8,.18),transparent_28%),linear-gradient(180deg,rgba(255,255,255,.045),rgba(0,0,0,.35))] p-4 shadow-[inset_0_1px_0_rgba(255,255,255,.08),0_0_45px_rgba(234,179,8,.08)]">
            <svg
              viewBox={`0 0 ${chartWidth} ${chartHeight}`}
              className="h-[220px] sm:h-[300px] md:h-[360px] w-full"
              preserveAspectRatio="none"
            >
              <defs>
                <linearGradient id="publisherDiamondArea" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="rgb(234,179,8)" stopOpacity="0.42" />
                  <stop offset="55%" stopColor="rgb(234,179,8)" stopOpacity="0.12" />
                  <stop offset="100%" stopColor="rgb(234,179,8)" stopOpacity="0.02" />
                </linearGradient>

                <linearGradient id="publisherDiamondLine" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="rgb(161,98,7)" />
                  <stop offset="45%" stopColor="rgb(250,204,21)" />
                  <stop offset="100%" stopColor="rgb(253,224,71)" />
                </linearGradient>
              </defs>

              <rect
                x="0"
                y="0"
                width={chartWidth}
                height={chartHeight}
                rx="26"
                fill="rgba(0,0,0,0.18)"
              />

              {yTicks.map((tick) => {
                const y = getChartY(tick);

                return (
                  <g key={tick}>
                    <line
                      x1={chartPadding.left}
                      y1={y}
                      x2={chartPadding.left + chartInnerWidth}
                      y2={y}
                      stroke="rgba(234,179,8,0.16)"
                      strokeDasharray="5 9"
                    />

                    <text
                      x={18}
                      y={y + 4}
                      className="fill-yellow-300/55 text-[11px] font-semibold"
                    >
                      {formatNumber(tick)}
                    </text>
                  </g>
                );
              })}

              <polygon points={areaPoints} fill="url(#publisherDiamondArea)" />

              <polyline
                points={linePoints}
                fill="none"
                stroke="url(#publisherDiamondLine)"
                strokeWidth="4"
                strokeLinejoin="round"
                strokeLinecap="round"
              />

              {daily.map((item, index) => {
                    const point = {
                      x: getChartX(index),
                      y: getChartY(item.diamonds),
                      dateText: formatDateForDisplay(item.report_date),
                      value: safeNumber(item.diamonds),
                    };

                    return (
                      <circle
                        key={`${item.report_date}-dot`}
                        cx={point.x}
                        cy={point.y}
                        r="5"
                        fill="rgb(250,204,21)"
                        stroke="rgba(0,0,0,0.95)"
                        strokeWidth="2.5"
                        className="cursor-pointer transition hover:r-[6]"
                        onMouseEnter={() => setActiveDiamondPoint(point)}
                        onMouseLeave={() => setActiveDiamondPoint(null)}
                        onFocus={() => setActiveDiamondPoint(point)}
                        onBlur={() => setActiveDiamondPoint(null)}
                        onClick={() => setActiveDiamondPoint(point)}
                        onTouchStart={() => setActiveDiamondPoint(point)}
                      >
                        <title>
                          Elmas: {formatNumber(item.diamonds)}
                        </title>
                      </circle>
                    );
                  })}

              {daily.map((item, index) => {
                if (index % xLabelStep !== 0 && index !== daily.length - 1) return null;

                return (
                  <text
                    key={`${item.report_date}-label`}
                    x={getChartX(index)}
                    y={chartHeight - 18}
                    textAnchor="middle"
                    className="fill-white/45 text-[11px] font-semibold"
                  >
                    {formatDateForDisplay(item.report_date).slice(0, 5)}
                  </text>
                );
              })}
            </svg>
          </div>
        </div>
                    

        <div className="grid gap-3.5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-1">
          {sideCards.map((card) => (
            <div
              key={card.title}
              className="group relative overflow-hidden rounded-[1.35rem] border border-yellow-500/25 bg-gradient-to-br from-yellow-500/[0.08] via-black/60 to-black/80 p-5 text-center flex flex-col items-center justify-center backdrop-blur-xl shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:border-yellow-500/50 hover:shadow-[0_10px_25px_rgba(234,179,8,0.12)] min-w-0"
            >
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-yellow-500/10 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <div className="relative text-[11px] font-black uppercase tracking-wider text-yellow-300 text-center w-full truncate">
                {card.title}
              </div>
              <div className="relative mt-2 text-2xl sm:text-3xl font-black text-white group-hover:text-yellow-100 transition-colors text-center w-full truncate">
                {card.value}
              </div>
              <div className="relative mt-1 text-xs text-white/50 text-center w-full truncate">
                {card.note}
              </div>
              <div className="relative mt-1.5 flex justify-center items-center w-full">
                <CompareNote
                  current={card.rawValue}
                  previous={card.previousValue}
                  formatter={card.formatter || formatNumber}
                  prefix={card.prefix || ""}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {bottomCards.map((card) => (
          <div
            key={card.title}
            className="group relative overflow-hidden rounded-[1.25rem] border border-yellow-500/20 bg-gradient-to-br from-white/[0.03] via-black/60 to-black/80 p-4 sm:p-5 text-center flex flex-col items-center justify-center backdrop-blur-xl transition-all duration-300 hover:-translate-y-0.5 hover:border-yellow-500/40 hover:shadow-lg min-w-0"
          >
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-yellow-500/10 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            <div className="relative text-[10px] sm:text-[11px] font-black uppercase tracking-wider text-white/60 text-center w-full truncate">
              {card.title}
            </div>
            <div className="relative mt-2 text-lg sm:text-xl font-black text-white group-hover:text-yellow-200 transition-colors text-center w-full truncate">
              {card.value}
            </div>
            <div className="relative mt-1 text-xs text-yellow-300/80">
              {card.note}
            </div>
            <div className="relative mt-1">
              <CompareNote
                current={card.rawValue}
                previous={card.previousValue}
                formatter={card.formatter || formatNumber}
                prefix={card.prefix || ""}
              />
            </div>
          </div>
        ))}
      </div>

      </div>
  );
}

function DateFilter({ selectedQuickRange, selectedRangeText, customStartDate, customEndDate, setCustomStartDate, setCustomEndDate, setSelectedQuickRange, handleQuickRangeClick }) {
  return (
    <div className="rounded-[1rem] border border-white/10 bg-black/20 p-3 sm:p-3.5">
      <div className="mb-3 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-yellow-300 font-bold">Rapor Tarih Aralığı</div>
        </div>
        <div className="rounded-xl border border-white/10 bg-black/40 px-3 py-1.5 text-xs text-white/60">
          <span className="font-semibold text-yellow-300">{selectedQuickRange}</span>
          <span className="mx-2 text-white/30">•</span>
          {selectedRangeText}
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {["Dün", "Son 7 Gün", "Son Ay", "Bu Ay (Hediye/Prim)"].map((label) => {
          const isSelected = selectedQuickRange === label;
          const isGiftMonth = label === "Bu Ay (Hediye/Prim)";
          return (
            <button
              key={label}
              type="button"
              onClick={() => handleQuickRangeClick(label)}
              className={`rounded-xl border px-3 sm:px-3.5 py-1.5 text-[11px] font-bold transition-all shadow-xs active:scale-95 ${
                isSelected
                  ? "border-yellow-500 bg-yellow-500 text-black font-black shadow-[0_0_10px_rgba(234,179,8,0.25)]"
                  : isGiftMonth
                    ? "border-yellow-500/40 bg-yellow-500/15 text-yellow-200 hover:bg-yellow-500/25"
                    : "border-white/10 bg-black/40 text-white/70 hover:border-yellow-500/30 hover:text-yellow-300"
              }`}
            >
              {isGiftMonth ? "🎁 Bu Ay (Hediye/Prim Ayı)" : label}
            </button>
          );
        })}

        <div className={`inline-flex flex-wrap items-center gap-1.5 sm:gap-2 rounded-xl border px-3 py-1.5 shadow-sm transition-all ${
          selectedQuickRange === "Tarih Seç"
            ? "border-yellow-500/60 bg-yellow-500/15 text-yellow-300 shadow-[0_0_12px_rgba(234,179,8,0.15)]"
            : "border-white/10 bg-[#121215]/80 text-white/70 hover:border-yellow-500/30"
        }`}>
          <span className="text-xs font-black text-amber-400 flex items-center gap-1">📅 Tarih Seç</span>
          <div className="inline-flex items-center gap-1">
            <input
              type="date"
              value={customStartDate}
              onChange={(event) => {
                setSelectedQuickRange("Tarih Seç");
                setCustomStartDate(event.target.value);
              }}
              className="w-[110px] sm:w-[125px] rounded-lg border border-white/15 bg-black/70 px-2 py-1 text-[11px] font-bold text-white outline-none focus:border-yellow-500 [color-scheme:dark]"
            />
            <span className="text-yellow-500 font-black text-xs">▸</span>
            <input
              type="date"
              value={customEndDate}
              onChange={(event) => {
                setSelectedQuickRange("Tarih Seç");
                setCustomEndDate(event.target.value);
              }}
              className="w-[110px] sm:w-[125px] rounded-lg border border-white/15 bg-black/70 px-2 py-1 text-[11px] font-bold text-white outline-none focus:border-yellow-500 [color-scheme:dark]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function PublisherMonthlyAwardsCard({ awards = [], loading, error, onMessageRequest }) {
  if (loading) {
    return (
      <div className="h-full min-h-[260px] rounded-[1.45rem] border border-yellow-500/25 bg-black/45 p-5 text-sm text-white/45">
        Aylık kazanımınız kontrol ediliyor...
      </div>
    );
  }

  if (!awards.length) {
    return (
      <div className="h-full min-h-[260px] rounded-[1.45rem] border border-white/10 bg-black/35 p-5">
        <div className="text-[10px] font-black uppercase tracking-[0.24em] text-yellow-300">Aylık Kazanım</div>
        <div className="mt-3 text-lg font-black text-white">Henüz yayınlanmış kazanım bulunmuyor.</div>
        <div className="mt-2 text-xs leading-5 text-white/45">
          Admin tarafından aylık hediye veya prim yayınlandığında bu alanda otomatik görüntülenecektir.
        </div>
        {error ? (
          <div className="mt-3 rounded-xl border border-white/10 bg-white/[0.035] px-3 py-2 text-[10px] font-bold text-white/35">
            Kazanım servisi geçici olarak yenileniyor. Teknik hata detayı kullanıcı ekranında gösterilmez.
          </div>
        ) : null}
      </div>
    );
  }

  const latestPeriod = awards[0]?.periodMonth || "";
  const latestAwards = awards.filter((item) => item.periodMonth === latestPeriod);
  const snapshot = latestAwards[0] || {};
  const allDelivered = latestAwards.every((item) => item.deliveryStatus === "Teslim Edildi");

  return (
    <div className="h-full min-h-[260px] rounded-[1.45rem] border border-yellow-500/30 bg-[radial-gradient(circle_at_top,rgba(234,179,8,.15),transparent_40%),linear-gradient(180deg,rgba(255,255,255,.035),rgba(0,0,0,.38))] p-5 shadow-[0_0_38px_rgba(234,179,8,.08)]">
      <div className="text-center">
        <div className="text-[10px] font-black uppercase tracking-[0.28em] text-yellow-300">
          {formatGiftPeriodLabel(latestPeriod)}
        </div>
        <div className="mt-2 text-xl font-black text-white">
          Bu Ayki Kazanım{latestAwards.length > 1 ? "larınız" : "ınız"}
        </div>
      </div>

      <div className="mt-4 space-y-2">
        {latestAwards.map((award) => (
          <div key={award.id} className="rounded-2xl border border-yellow-500/20 bg-yellow-500/10 px-4 py-3 text-center text-base font-black text-yellow-100">
            🎁 {cleanRewardDisplayText(award.giftDetail)}
          </div>
        ))}
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2 text-center">
        <div className="rounded-xl border border-white/10 bg-black/35 p-3">
          <div className="text-[9px] font-black uppercase tracking-[0.15em] text-white/35">Aktif Gün</div>
          <div className="mt-1 font-black text-white">{snapshot.activeDays || 0}</div>
        </div>
        <div className="rounded-xl border border-white/10 bg-black/35 p-3">
          <div className="text-[9px] font-black uppercase tracking-[0.15em] text-white/35">Elmas</div>
          <div className="mt-1 font-black text-yellow-200">{formatNumber(snapshot.diamonds)}</div>
        </div>
        <div className="rounded-xl border border-white/10 bg-black/35 p-3">
          <div className="text-[9px] font-black uppercase tracking-[0.15em] text-white/35">Kademe</div>
          <div className="mt-1 font-black text-white">K{snapshot.previousTier} → K{snapshot.currentTier}</div>
        </div>
        <div className="rounded-xl border border-white/10 bg-black/35 p-3">
          <div className="text-[9px] font-black uppercase tracking-[0.15em] text-white/35">Değişim</div>
          <div className="mt-1 text-[11px] font-black text-white">{snapshot.tierChange}</div>
        </div>
      </div>

      {!allDelivered && (
        <button
          type="button"
          onClick={() => onMessageRequest?.(latestAwards[0])}
          className="mt-4 w-full rounded-2xl bg-yellow-500 px-5 py-3 text-sm font-black text-black transition hover:bg-yellow-300"
        >
          Yöneticime Mesaj Gönder
        </button>
      )}

      {allDelivered && (
        <div className="mt-4 rounded-2xl border border-emerald-500/25 bg-emerald-500/10 px-4 py-3 text-center text-xs font-black text-emerald-200">
          ✓ Kazanım teslim edildi.
        </div>
      )}
    </div>
  );
}

function RewardConfettiCanvas({ active = true }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!active) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let animationFrameId;
    let width = (canvas.width = canvas.offsetWidth || 300);
    let height = (canvas.height = canvas.offsetHeight || 220);

    const colors = [
      "#f59e0b", "#fbbf24", "#10b981", "#34d399",
      "#ec4899", "#f43f5e", "#6366f1", "#38bdf8", "#eab308"
    ];

    const particleCount = 42;
    const particles = Array.from({ length: particleCount }).map(() => ({
      x: Math.random() * width,
      y: Math.random() * height - height,
      size: Math.random() * 5 + 3.5,
      color: colors[Math.floor(Math.random() * colors.length)],
      speedY: Math.random() * 2 + 1,
      speedX: (Math.random() - 0.5) * 1.4,
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 5,
      opacity: Math.random() * 0.4 + 0.6,
      shape: Math.random() > 0.35 ? "rect" : "circle",
    }));

    const render = () => {
      ctx.clearRect(0, 0, width, height);

      particles.forEach((p) => {
        p.y += p.speedY;
        p.x += Math.sin(p.y / 22) * 0.75 + p.speedX;
        p.rotation += p.rotationSpeed;

        if (p.y > height + 10) {
          p.y = -10;
          p.x = Math.random() * width;
        }

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle = p.color;

        if (p.shape === "rect") {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2.5, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.restore();
      });

      animationFrameId = requestAnimationFrame(render);
    };

    render();

    const handleResize = () => {
      if (!canvas) return;
      width = canvas.width = canvas.offsetWidth || 300;
      height = canvas.height = canvas.offsetHeight || 220;
    };

    window.addEventListener("resize", handleResize);

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", handleResize);
    };
  }, [active]);

  return (
    <canvas
      ref={canvasRef}
      className="pointer-events-none absolute inset-0 z-10 h-full w-full"
    />
  );
}

function isAwardCompletedOrDispatched(item, currentPublisher = null) {
  if (!item) return false;

  // 1. Yayın durumu: Yayından kaldırılmış veya iptal edilmişse
  const pubStatus = String(item.publishStatus || item.publish_status || "").toLowerCase();
  if (pubStatus.includes("kaldır") || pubStatus.includes("kaldir") || pubStatus.includes("iptal")) {
    return true;
  }

  // 2. İptal bayrağı
  if (item.isCancelled || item.is_cancelled) {
    return true;
  }

  // 3. Teslim edilmiş bayrağı
  if (item.isDelivered || item.is_delivered) {
    return true;
  }

  // 4. Teslim durumu kontrolü (Tamamlandı, Teslim Edildi, Gönderildi, Kargoya Verildi, Fazla vb.)
  const delStatus = String(item.deliveryStatus || item.delivery_status || "").toLowerCase();
  if (
    delStatus.includes("tamam") ||
    delStatus.includes("teslim") ||
    delStatus.includes("gönder") ||
    delStatus.includes("gonder") ||
    delStatus.includes("kargo") ||
    delStatus.includes("fazla") ||
    delStatus.includes("iptal") ||
    delStatus === "sent" ||
    delStatus === "completed" ||
    delStatus === "delivered"
  ) {
    return true;
  }

  // 5. Sunucudan gelen gönderilen elmas hakedişi karşılıyor mu?
  const awardDia = Number(item.awardDiamonds ?? item.award_diamonds ?? item.diamonds ?? 0);
  const totalDisp = Number(item.totalDispatched ?? item.total_dispatched ?? item.dispatchedDiamonds ?? 0);
  if (totalDisp > 0 && awardDia > 0 && totalDisp >= awardDia) {
    return true;
  }

  // 6. Tarayıcı yerel hafızası (localStorage) kontrolü - wolf_local_gift_dispatches_v1
  // Admin gönderimi yeni yaptığında panelde hemen algılanıp kalksın
  try {
    const rawLocal = typeof window !== "undefined" ? localStorage.getItem("wolf_local_gift_dispatches_v1") : null;
    if (rawLocal) {
      const localList = JSON.parse(rawLocal);
      if (Array.isArray(localList)) {
        const targetUser = String(
          currentPublisher?.username ||
          item.publisherUsername ||
          item.publisher_username ||
          ""
        ).replace(/^@/, "").toLowerCase().trim();

        const targetHidden = String(
          currentPublisher?.hiddenId ||
          item.hiddenId ||
          item.hidden_id ||
          ""
        ).toLowerCase().trim();

        const targetPeriod = String(item.periodMonth || item.period_month || "").trim();

        let localTotalDiamonds = 0;
        let matchedActiveDispatches = 0;

        for (const ld of localList) {
          if (!ld || ld.status === "cancelled") continue;
          const ldUser = String(ld.publisherUsername || "").replace(/^@/, "").toLowerCase().trim();
          const ldHidden = String(ld.hiddenId || "").toLowerCase().trim();
          const ldPeriod = String(ld.periodMonth || "").trim();

          const matchAwardId = ld.awardId && item.id && String(ld.awardId) === String(item.id);
          const matchUser = (targetUser && ldUser && (targetUser === ldUser || ldUser.includes(targetUser) || targetUser.includes(ldUser))) ||
                            (targetHidden && ldHidden && targetHidden === ldHidden);
          const matchPeriod = !targetPeriod || !ldPeriod || targetPeriod === ldPeriod;

          if (matchAwardId || (matchUser && matchPeriod)) {
            matchedActiveDispatches++;
            localTotalDiamonds += Number(ld.diamonds || 0);
          }
        }

        const combinedSent = totalDisp + localTotalDiamonds;
        if (matchedActiveDispatches > 0) {
          if (awardDia <= 0 || combinedSent >= awardDia) {
            return true;
          }
        }
      }
    }
  } catch (_) {}

  return false;
}

function PublisherRewardMotivationArea({
  publishedGiftAwards = [],
  loading,
  error,
  onMessageRequest,
  currentPublisher,
}) {
  const validAwards = publishedGiftAwards.filter((item) => {
    return !isAwardCompletedOrDispatched(item, currentPublisher);
  });
  const latestPeriod = validAwards[0]?.periodMonth || "";
  const latestAwards = latestPeriod
    ? validAwards.filter((item) => item.periodMonth === latestPeriod)
    : [];
  const hasAward = latestAwards.length > 0;
  const combinedGiftText = latestAwards
    .map((item) => String(item.giftDetail || "").trim())
    .filter(Boolean)
    .join(" / ");
  const cleanGiftText = cleanRewardDisplayText(combinedGiftText);

  return (
    <div className="mx-auto mb-5 grid w-full gap-3.5 lg:grid-cols-3 lg:items-stretch">
      {/* 1. KART: ÖDÜL POLİTİKASI VEYA TEBRİK KAZANIM ALANI (KONFETİLİ) */}
      {hasAward ? (
        <div className="relative flex h-full min-h-[210px] flex-col items-center justify-between overflow-hidden rounded-[1.4rem] border border-emerald-500/40 bg-[radial-gradient(circle_at_top_left,rgba(16,185,129,.28),transparent_50%),linear-gradient(180deg,rgba(4,32,18,.96),rgba(2,15,8,.98))] p-5 text-center shadow-[0_0_30px_rgba(16,185,129,.2)] backdrop-blur-xl transition-all duration-300 hover:border-emerald-400/60">
          <RewardConfettiCanvas active={true} />
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(52,211,153,0.18),transparent_70%)] animate-pulse" />
          
          <div className="relative z-20 flex h-full w-full flex-col items-center justify-between">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-400/40 bg-emerald-500/15 px-3.5 py-1 text-[9px] font-black uppercase tracking-[0.20em] text-emerald-300 shadow-[0_0_12px_rgba(52,211,153,0.3)] sm:text-[10px]">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-ping" />
              🎉 TEBRİKLER KAZANDINIZ 🎉
            </span>

            <div className="my-auto py-2">
              <div className="mb-1 text-2xl sm:text-3xl animate-bounce">🏆</div>
              <div className="mx-auto max-w-[22ch] text-balance text-[15px] font-black uppercase leading-[1.3] tracking-[0.02em] text-white drop-shadow-[0_2px_10px_rgba(16,185,129,0.5)] sm:text-[16px] xl:text-[17px]">
                TEBRİKLER! AJANS ÖDÜLÜNE HAK KAZANDINIZ
              </div>
            </div>

            <div className="text-[11px] font-semibold text-emerald-200/85">
              Aylık hedeflerinizi başarıyla tamamladınız. Tebrik ederiz!
            </div>
          </div>
        </div>
      ) : (
        <div className="relative flex h-full min-h-[210px] flex-col items-center justify-between overflow-hidden rounded-[1.4rem] border border-red-500/35 bg-[radial-gradient(circle_at_top_left,rgba(220,38,38,.24),transparent_45%),linear-gradient(180deg,rgba(32,5,7,.96),rgba(10,2,3,.98))] p-5 text-center shadow-[0_0_26px_rgba(220,38,38,.14)] backdrop-blur-xl transition-all duration-300 hover:border-red-500/50">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(239,68,68,0.12),transparent_70%)] animate-pulse" />
          <div className="relative z-10 flex h-full w-full flex-col items-center justify-between">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-red-500/30 bg-red-500/10 px-3 py-1 text-[9px] font-black uppercase tracking-[0.20em] text-red-300 sm:text-[10px]">
              <span className="h-1.5 w-1.5 rounded-full bg-red-400 animate-ping" />
              Ödül Politikası Bilgilendirmesi
            </span>

            <div className="my-auto py-2">
              <div className="mx-auto max-w-[21ch] text-balance text-[15px] font-black uppercase leading-[1.25] tracking-[0.02em] text-white sm:text-[16px] xl:text-[17px]">
                HEDEFLERİNİ YAKALAYAMAYAN YAYINCILAR ÖDÜLLERDEN YARARLANAMAYACAKTIR.
              </div>
            </div>

            <div className="text-[11px] font-semibold text-white/50">
              Aylık yayın günü, saati ve elmas şartları birlikte değerlendirilir.
            </div>
          </div>
        </div>
      )}

      {/* 2. KART: ÖDÜL VİDEOSU */}
      <div className="relative overflow-hidden rounded-[1.4rem] border border-yellow-500/35 bg-black/80 shadow-[0_0_28px_rgba(234,179,8,.12)] flex items-center justify-center min-h-[210px]">
        <div className="h-full w-full overflow-hidden bg-black flex items-center justify-center">
          <video
            src={`${API_BASE}/kademe-odul-video.mp4`}
            className="h-full w-full object-cover min-h-[210px] max-h-[250px]"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          />
        </div>
      </div>

      {/* 3. KART: ÖDÜL BİLGİLENDİRME ALANI */}
      <GoldAnimatedBorderBox
        className="h-full min-h-[210px]"
        innerClassName="flex h-full min-h-[210px] flex-col justify-between p-5 text-center sm:px-6"
      >
        <div className="text-[10px] font-black uppercase tracking-[0.20em] text-yellow-300 sm:text-[11px]">
          Ödül Bilgilendirme Alanı
        </div>

        <div className="flex flex-1 flex-col items-center justify-center py-2">
          {loading ? (
            <div className="text-sm font-black text-white/60">
              Ödül bilginiz kontrol ediliyor...
            </div>
          ) : hasAward ? (
            <>
              <div className="text-[11px] font-black uppercase tracking-[0.24em] text-yellow-200/90 sm:text-[12px]">
                {formatGiftPeriodLabel(latestPeriod)}
              </div>
              <div className="mt-2 max-w-[24ch] text-balance text-lg font-black leading-tight text-yellow-300 sm:text-xl xl:text-[1.35rem] drop-shadow-[0_2px_8px_rgba(234,179,8,0.3)]">
                {cleanGiftText || "Ödülünüz yayınlandı"}
              </div>
            </>
          ) : (
            <div className="mx-auto max-w-[20ch] text-balance text-[15px] font-black uppercase leading-[1.25] tracking-[0.025em] text-white sm:text-[16px]">
              Ödülünüzü bu alanda görüntüleyeceksiniz.
            </div>
          )}
        </div>

        {hasAward ? (
          <button
            type="button"
            onClick={() => onMessageRequest?.(latestAwards[0])}
            className="mt-auto w-full rounded-xl bg-yellow-500 px-4 py-2.5 text-xs font-black text-black transition hover:bg-yellow-300 sm:text-sm shadow-md cursor-pointer"
          >
            Yöneticime Mesaj Gönder
          </button>
        ) : (
          <div className="mt-auto rounded-xl border border-yellow-400/20 bg-yellow-500/10 px-3 py-2 text-[10px] font-bold leading-4 text-yellow-100/75 sm:text-[11px]">
            Hediye veya priminiz yayınlandığında bu alan otomatik güncellenecektir.
          </div>
        )}

        {error && !hasAward ? (
          <div className="mt-1 text-[10px] font-semibold text-white/25">
            Kazanım bilgisi geçici olarak yenileniyor.
          </div>
        ) : null}
      </GoldAnimatedBorderBox>
    </div>
  );
}

function KademePanel({
  currentTier,
  monthlyTierDiamonds,
  tierRangeText,
  previousTier,
  previousMonthTierDiamonds,
  currentMonthPerformance,
  previousMonthPerformance,
  previousTierRangeText,
  tierPerformanceLoading,
  tierPerformanceError,
  tierRewardRows,
  tierRewardLoading,
  currentPublisher,
  giftWinner,
  giftWinnerLoading,
  giftWinnerError,
  publishedGiftAwards = [],
  publishedGiftAwardsLoading,
  publishedGiftAwardsError,
  onGiftMessageRequest,
}) {
  const previousTierNo = getTierNumber(previousTier);
  const currentTierNo = getTierNumber(currentTier);
  const baseTier = tierRules.find((tier) => getTierNumber(tier) === previousTierNo) || tierRules[0];
  const upgradeTier = tierRules.find((tier) => getTierNumber(tier) === previousTierNo + 1) || null;
  const doubleUpgradeTier = tierRules.find((tier) => getTierNumber(tier) === previousTierNo + 2) || null;
  const tierTheme = getTierTheme(baseTier);

  const currentDaily = currentMonthPerformance?.daily || [];
  const previousDaily = previousMonthPerformance?.daily || [];

  const currentLiveDays = countLiveDays(currentDaily);
  const previousLiveDays = countLiveDays(previousDaily);
  const currentLiveHours = getPerformanceHours(currentMonthPerformance, currentDaily);
  const previousLiveHours = getPerformanceHours(previousMonthPerformance, previousDaily);

  const now = new Date();
  const daysInCurrentMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  const daysInPreviousMonth = new Date(now.getFullYear(), now.getMonth(), 0).getDate();

  const safeCurrentLiveDays = Math.min(currentLiveDays, daysInCurrentMonth);
  const safePreviousLiveDays = Math.min(previousLiveDays, daysInPreviousMonth);

  const PROTECT_TARGET_HOURS = 80;
  const PROTECT_TARGET_DAYS = Math.min(22, daysInCurrentMonth);

  const UPGRADE_TARGET_HOURS = 95;
  const UPGRADE_TARGET_DAYS = Math.min(24, daysInCurrentMonth);

  const DOUBLE_UPGRADE_TARGET_HOURS = 110;
  const DOUBLE_UPGRADE_TARGET_DAYS = Math.min(27, daysInCurrentMonth);

  const protectTargetDiamonds = safeNumber(baseTier.minDiamonds);
  const upgradeTargetDiamonds = upgradeTier ? safeNumber(upgradeTier.minDiamonds) : 0;
  const doubleTargetDiamonds = doubleUpgradeTier ? safeNumber(doubleUpgradeTier.minDiamonds) : 0;

  const policyBlocked = currentTierNo < previousTierNo;

  const protectGoal = buildTierAwardGoal({
    type: "protect",
    title: "Kademe Koruma",
    detailTitle: "Kademe Koruma Hedefleri",
    targetTier: baseTier,
    currentDiamonds: monthlyTierDiamonds,
    currentLiveHours,
    currentLiveDays: safeCurrentLiveDays,
    targetDiamonds: protectTargetDiamonds,
    targetHours: PROTECT_TARGET_HOURS,
    targetDays: PROTECT_TARGET_DAYS,
    policyBlocked,
    maxMonthDays: daysInCurrentMonth,
  });

  const upgradeGoal = buildTierAwardGoal({
    type: "upgrade",
    title: "Kademe Yükseltme",
    detailTitle: "Kademe Yükseltme Hedefleri",
    targetTier: upgradeTier,
    currentDiamonds: monthlyTierDiamonds,
    currentLiveHours,
    currentLiveDays: safeCurrentLiveDays,
    targetDiamonds: upgradeTargetDiamonds,
    targetHours: upgradeTier ? UPGRADE_TARGET_HOURS : 0,
    targetDays: upgradeTier ? UPGRADE_TARGET_DAYS : 0,
    policyBlocked,
    maxMonthDays: daysInCurrentMonth,
  });

  const doubleGoal = buildTierAwardGoal({
    type: "double_upgrade",
    title: "2 Kademe Yükseltme",
    detailTitle: "2 Kademe Yükseltme Hedefleri",
    targetTier: doubleUpgradeTier,
    currentDiamonds: monthlyTierDiamonds,
    currentLiveHours,
    currentLiveDays: safeCurrentLiveDays,
    targetDiamonds: doubleTargetDiamonds,
    targetHours: doubleUpgradeTier ? DOUBLE_UPGRADE_TARGET_HOURS : 0,
    targetDays: doubleUpgradeTier ? DOUBLE_UPGRADE_TARGET_DAYS : 0,
    policyBlocked,
    maxMonthDays: daysInCurrentMonth,
  });

  const goals = [protectGoal, upgradeGoal, doubleGoal];
  const highestAward = doubleGoal.reached
    ? "double_upgrade"
    : upgradeGoal.reached
      ? "upgrade"
      : protectGoal.reached
        ? "protect"
        : "none";

  const infoMessage = getTierAwardInfoMessage(highestAward);
  const displayGoals = goals.filter((item) => item.hasTarget);
  const focusGoal = displayGoals.find((item) => !item.reached) || displayGoals[displayGoals.length - 1] || goals[0];
  const rewardContent = findTierRewardByType(tierRewardRows, focusGoal.type, focusGoal.targetTier || baseTier);
  const imageUrl = rewardContent?.imageUrl || rewardContent?.image_url || "";

  return (
    <Panel title="Kademe Bilgisi" icon="◆">
      <PublisherRewardMotivationArea
        publishedGiftAwards={publishedGiftAwards}
        loading={publishedGiftAwardsLoading}
        error={publishedGiftAwardsError}
        onMessageRequest={onGiftMessageRequest}
        currentPublisher={currentPublisher}
        giftWinner={giftWinner}
        giftWinnerLoading={giftWinnerLoading}
        hasReachedGoal={highestAward !== "none"}
      />

      <div className="mb-4 rounded-2xl border border-yellow-500/35 bg-[radial-gradient(circle_at_top_left,rgba(234,179,8,.16),transparent_36%),linear-gradient(180deg,rgba(234,179,8,.10),rgba(0,0,0,.28))] px-5 py-4 text-center shadow-[0_0_32px_rgba(234,179,8,.10)]">
        <div className="text-lg font-black uppercase tracking-[0.16em] text-yellow-200 lg:text-xl">
          Kademenize Bağlı Hediye Hedefleri
        </div>
        <div className="mt-2 text-xs font-semibold leading-5 text-white/55 lg:text-sm">
          Hedeflerini tamamladıkça hediye kazanımın bu alanda görüntülenir.
        </div>
      </div>

      <div className="mb-4 rounded-[1.5rem] border border-yellow-500/25 bg-[radial-gradient(circle_at_top_left,rgba(234,179,8,.15),transparent_30%),linear-gradient(180deg,rgba(255,255,255,.04),rgba(0,0,0,.34))] p-4 sm:p-5">
        <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <div className="text-[11px] font-black uppercase tracking-[0.32em] text-yellow-300">
              Kademe Geçmişi ve Aylık Hedef Tablosu
            </div>
            <div className="mt-1 text-xs text-white/45">
              Önceki ay performansı, bu ayki ilerleme ve ödül hedefleri aynı alanda takip edilir.
            </div>
          </div>
          <div className={`w-fit rounded-full border px-4 py-2 text-xs font-black ${tierTheme.badgeClass}`}>
            Mevcut Grup: {tierTheme.groupLabel}
          </div>
        </div>

        <div className="grid gap-4 md:grid-cols-3 md:items-stretch">
          <TierMonthCard
            title="Önceki Ay Performansı"
            tier={previousTier}
            diamonds={previousMonthTierDiamonds}
            liveDays={previousLiveDays}
            liveHours={previousLiveHours}
            rangeText={previousTierRangeText}
          />
          <TierMonthCard
            title="Bu Ay Performansı"
            tier={currentTier}
            diamonds={monthlyTierDiamonds}
            liveDays={currentLiveDays}
            liveHours={currentLiveHours}
            rangeText={tierRangeText}
          />
          <TierCombinedNeedCard
            goals={[
              { label: "Koruma", goal: protectGoal, fallbackText: "Koruma tamamlandı" },
              { label: "Yükseltme", goal: upgradeGoal, disabled: !upgradeTier, fallbackText: "En üst kademe" },
              { label: "2 Kademe", goal: doubleGoal, disabled: !doubleUpgradeTier, fallbackText: "Uygun hedef yok" },
            ]}
          />
        </div>

        <div className="mt-3 text-[11px] font-semibold text-white/35">
          Yayın günü hesabı aynı günde açılan birden fazla yayını tek gün sayar.
        </div>
      </div>

      {highestAward !== "none" && (
        <div className="mb-4 rounded-2xl border border-cyan-400/30 bg-cyan-500/10 px-4 py-3 text-center text-sm font-black uppercase tracking-[0.08em] text-cyan-200">
          {infoMessage}
        </div>
      )}

      <div className="space-y-4">
        {displayGoals.map((goal) => (
          <div
            key={goal.type}
            className="grid gap-4 xl:grid-cols-[240px_minmax(0,1fr)] xl:items-stretch"
          >
            <TierGoalSideCard
              goal={goal}
              active={focusGoal.type === goal.type && !goal.reached}
              completed={goal.reached}
            />

            <TierAwardProgressRow goal={goal} />
          </div>
        ))}
      </div>

      {tierPerformanceError && (
        <div className="mt-4 rounded-2xl border border-red-500/25 bg-red-500/10 p-4 text-sm font-bold text-red-200">
          {tierPerformanceError}
        </div>
      )}

      <div className="mt-5 overflow-hidden rounded-2xl border border-yellow-500/25">
        <div className="grid grid-cols-[1.25fr_1fr_.75fr_.85fr_.85fr] gap-3 bg-white/[0.04] px-5 py-4 text-[11px] font-black uppercase tracking-[0.14em] text-white/55">
          <div>Kademe</div>
          <div>Elmas Hedefi</div>
          <div>Temel</div>
          <div>Gelişmiş</div>
          <div>Koruma</div>
        </div>

        {tierRules.map((tier) => {
          const currentTheme = getTierTheme(tier);
          const isCurrentTier = baseTier?.name === tier.name;

          return (
            <div
              key={tier.name}
              className={`grid grid-cols-[1.25fr_1fr_.75fr_.85fr_.85fr] gap-3 border-t px-5 py-4 text-sm ${
                isCurrentTier ? `${currentTheme.rowClass} text-white` : "border-white/10 text-white/72"
              }`}
            >
              <div className="flex items-center"><TierGroupPills tier={tier} compact /></div>
              <div className="flex items-center">≥ {formatNumber(tier.minDiamonds)}</div>
              <div className="flex items-center">{tier.baseRate}</div>
              <div className="flex items-center">{tier.advancedRate}</div>
              <div className="flex items-center">{tier.protectRate}</div>
            </div>
          );
        })}
      </div>
    </Panel>
  );
}

function PublisherGiftRewardCard({ giftWinner, loading, error, onMessageRequest, horizontal = false }) {
  const giftAmount = safeNumber(
    giftWinner?.finalGiftAmount ||
      giftWinner?.final_gift_amount ||
      giftWinner?.giftAmount ||
      giftWinner?.gift_amount
  );
  const status = String(giftWinner?.deliveryStatus || giftWinner?.delivery_status || "");
  const sent = status === "sent" || status === "completed";

  if (loading) {
    return (
      <div className="h-full min-h-[260px] rounded-[1.4rem] border border-yellow-500/35 bg-black/45 p-5 text-sm text-white/45 shadow-[0_0_35px_rgba(234,179,8,.12)]">
        Hediye kazanımı kontrol ediliyor...
      </div>
    );
  }

  if (giftWinner && giftAmount > 0) {
    return (
      <div className={`h-full rounded-[1.4rem] border border-yellow-500/35 bg-black/45 p-3 shadow-[0_0_35px_rgba(234,179,8,.12)] ${
        horizontal ? "grid gap-4 lg:grid-cols-[220px_minmax(0,1fr)] lg:items-stretch" : "space-y-4"
      }`}>
        <div className={`w-full overflow-hidden rounded-[1.1rem] border border-yellow-400/45 bg-black shadow-[inset_0_1px_0_rgba(255,255,255,.05)] ${
          horizontal ? "aspect-[9/16] max-h-[360px] lg:h-full lg:max-h-none" : "aspect-[9/16]"
        }`}>
          <video
            src="/kademe-odul-video.mp4"
            className="h-full w-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          />
        </div>

        <GoldAnimatedBorderBox innerClassName={horizontal ? "flex h-full min-h-[300px] flex-col justify-center px-6 py-6 text-center" : "flex min-h-[250px] flex-col justify-center px-5 py-6 text-center"}>
          <div className="text-[11px] font-black uppercase tracking-[0.24em] text-yellow-300">Hediye Kazanımı</div>
          <div className="mt-4 text-3xl font-black text-white">🎁 {formatNumber(giftAmount)}</div>
          <div className="mt-1 text-sm font-bold text-yellow-200">elmas hediye kazanımınız oluştu</div>
          <div className="mt-4 rounded-2xl border border-white/10 bg-black/35 p-4 text-sm leading-6 text-white/62">
            {sent
              ? "✅ Hediyeniz yöneticiniz tarafından gönderildi olarak işaretlendi."
              : "Hediyenizin planlanması için yöneticinize mesaj iletin ve uygun gün/saat seçimini mesaj ekranında yapın."}
          </div>
          {!sent && (
            <button
              type="button"
              onClick={() => onMessageRequest?.(giftWinner)}
              className="mt-4 w-full rounded-2xl bg-yellow-500 px-5 py-3 text-sm font-black text-black transition hover:bg-yellow-300"
            >
              Yöneticime Mesaj Gönder
            </button>
          )}
        </GoldAnimatedBorderBox>
      </div>
    );
  }

  return (
    <div className={`h-full rounded-[1.4rem] border border-yellow-500/35 bg-black/45 p-3 shadow-[0_0_35px_rgba(234,179,8,.12)] ${
        horizontal ? "grid gap-4 lg:grid-cols-[220px_minmax(0,1fr)] lg:items-stretch" : "space-y-4"
      }`}>
      {error && <div className="rounded-xl border border-yellow-500/20 bg-yellow-500/10 px-3 py-2 text-[11px] font-bold text-yellow-100">{error}</div>}
      <div className={`w-full overflow-hidden rounded-[1.1rem] border border-yellow-400/45 bg-black shadow-[inset_0_1px_0_rgba(255,255,255,.05)] ${
          horizontal ? "aspect-[9/16] max-h-[360px] lg:h-full lg:max-h-none" : "aspect-[9/16]"
        }`}>
        <video
          src="/kademe-odul-video.mp4"
          className="h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
        />
      </div>
      <GoldAnimatedBorderBox innerClassName={horizontal ? "flex h-full min-h-[300px] flex-col justify-center px-6 py-6 text-center" : "flex min-h-[250px] flex-col justify-center px-4 py-6 text-center"}>
        <div className="text-[11px] font-black uppercase tracking-[0.20em] text-yellow-300">Ödül Bilgilendirme Alanı</div>
        <div className="mx-auto mt-4 max-w-[14ch] text-balance text-[17px] font-black uppercase leading-[1.15] tracking-[0.03em] text-white sm:text-[19px]">
          Ödülünüzü bu alanda görüntüleyeceksiniz.
        </div>
        <div className="mt-4 rounded-2xl border border-yellow-400/20 bg-yellow-500/10 px-4 py-3 text-[11px] font-bold leading-5 text-yellow-100/80">
          Hedef tamamlanıp kampanya yayınlandığında hediye kazanımınız ve yöneticinize mesaj butonu burada açılır.
        </div>
      </GoldAnimatedBorderBox>
    </div>
  );
}

function countLiveDays(daily = []) {
  return (daily || []).filter(
    (item) =>
      safeNumber(item.liveCount || item.live_count || item.live_count_total) > 0 ||
      safeNumber(item.liveSeconds || item.live_seconds || item.totalLiveSeconds) > 0 ||
      safeNumber(item.diamonds || item.totalDiamonds) > 0
  ).length;
}

function getPerformanceHours(performanceData = {}, daily = []) {
  const fromSummary = safeNumber(
    performanceData?.summary?.totalLiveSeconds ||
      performanceData?.summary?.total_live_seconds
  );

  if (fromSummary > 0) return Math.round((fromSummary / 3600) * 10) / 10;

  const totalSeconds = (daily || []).reduce(
    (sum, item) =>
      sum + safeNumber(item.liveSeconds || item.live_seconds || item.totalLiveSeconds),
    0
  );

  return Math.round((totalSeconds / 3600) * 10) / 10;
}

function buildTierAwardGoal({
  type,
  title,
  detailTitle,
  targetTier,
  currentDiamonds,
  currentLiveHours,
  currentLiveDays,
  targetDiamonds,
  targetHours,
  targetDays,
  policyBlocked,
  maxMonthDays = 31,
}) {
  const hasTarget = Boolean(targetTier);
  const safeTargetDiamonds = hasTarget ? Math.max(1, safeNumber(targetDiamonds)) : 0;
  const safeTargetHours = hasTarget ? Math.max(1, safeNumber(targetHours)) : 0;
  const safeTargetDays = hasTarget ? Math.min(Math.max(1, safeNumber(targetDays)), maxMonthDays) : 0;
  const safeCurrentDays = Math.min(safeNumber(currentLiveDays), maxMonthDays);
  const diamondPercent = hasTarget ? Math.min(Math.round((safeNumber(currentDiamonds) / safeTargetDiamonds) * 100), 100) : 0;
  const hourPercent = hasTarget ? Math.min(Math.round((safeNumber(currentLiveHours) / safeTargetHours) * 100), 100) : 0;
  const dayPercent = hasTarget ? Math.min(Math.round((safeCurrentDays / safeTargetDays) * 100), 100) : 0;
  const reached = hasTarget && diamondPercent >= 100 && hourPercent >= 100 && dayPercent >= 100;

  return {
    type,
    title,
    detailTitle,
    targetTier,
    hasTarget,
    currentDiamonds: safeNumber(currentDiamonds),
    currentLiveHours: safeNumber(currentLiveHours),
    currentLiveDays: safeCurrentDays,
    targetDiamonds: safeTargetDiamonds,
    targetHours: safeTargetHours,
    targetDays: safeTargetDays,
    remainingDiamonds: Math.max(safeTargetDiamonds - safeNumber(currentDiamonds), 0),
    remainingHours: Math.max(safeTargetHours - safeNumber(currentLiveHours), 0),
    remainingDays: Math.max(safeTargetDays - safeCurrentDays, 0),
    diamondPercent,
    hourPercent,
    dayPercent,
    reached,
  };
}

function getTierAwardInfoMessage(highestAward) {
  if (highestAward === "double_upgrade") return "En yüksek ödül seviyesi tamamlandı. 2 Kademe Yükseltme Ödülü kazanıldı.";
  if (highestAward === "upgrade") return "Kademe Yükseltme hedefi tamamlandı. Ödül seviyeni daha da artırmak için 2 Kademe Yükseltme hedeflerine ilerle.";
  if (highestAward === "protect") return "Kademe Koruma hedefi tamamlandı. Ödül seviyeni artırmak için Kademe Yükseltme hedeflerine ilerle.";
  return "";
}

function findTierRewardByType(rows = [], rewardType, targetTier) {
  const targetNo = getTierNumber(targetTier);
  return (rows || []).find((item) => {
    const type = item.rewardType || item.reward_type;
    const tierNo = Number(item.tierNo || item.tier_no || 0);
    const status = item.status || "Aktif";
    return status === "Aktif" && type === rewardType && tierNo === targetNo;
  });
}

function TierMonthCard({ title, tier, diamonds, liveDays, liveHours, rangeText }) {
  const theme = getTierTheme(tier);

  return (
    <div className="group relative flex h-full min-h-[190px] flex-col justify-between overflow-hidden rounded-[1.5rem] border border-yellow-500/25 bg-gradient-to-br from-yellow-500/[0.08] via-black/70 to-black/90 p-5 backdrop-blur-xl shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:border-yellow-500/50 hover:shadow-[0_10px_30px_rgba(234,179,8,0.12)]">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-yellow-500/10 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
      
      <div className="relative">
        <div className="text-[11px] font-black uppercase tracking-[0.20em] text-yellow-300/90">{title}</div>
        <div className="mt-2.5 flex flex-wrap items-center gap-2">
          <div className="text-2xl font-black leading-none text-white group-hover:text-yellow-100 transition-colors">{tier?.name || "Kademe 1"}</div>
          <TierGroupPills tier={tier} compact />
        </div>
      </div>

      <div className="relative mt-4 grid grid-cols-3 gap-2.5 text-center">
        <div className="rounded-xl border border-yellow-500/20 bg-yellow-500/10 px-2.5 py-2 backdrop-blur-sm">
          <span className="block text-sm font-black text-yellow-300">{formatNumber(diamonds)}</span>
          <span className="mt-1 block text-[10px] font-bold uppercase tracking-wider text-white/50">Elmas</span>
        </div>
        <div className="rounded-xl border border-cyan-500/20 bg-cyan-500/10 px-2.5 py-2 backdrop-blur-sm">
          <span className="block text-sm font-black text-cyan-200">{liveDays}</span>
          <span className="mt-1 block text-[10px] font-bold uppercase tracking-wider text-white/50">Gün</span>
        </div>
        <div className="rounded-xl border border-fuchsia-500/20 bg-fuchsia-500/10 px-2.5 py-2 backdrop-blur-sm">
          <span className="block text-sm font-black text-fuchsia-200">{liveHours}</span>
          <span className="mt-1 block text-[10px] font-bold uppercase tracking-wider text-white/50">Saat</span>
        </div>
      </div>

      <div className="relative mt-3 text-[10px] font-semibold text-white/40">{rangeText}</div>
    </div>
  );
}

function TierCombinedNeedCard({ goals = [] }) {
  return (
    <div className="group relative flex h-full min-h-[190px] flex-col overflow-hidden rounded-[1.5rem] border border-yellow-500/25 bg-gradient-to-br from-yellow-500/[0.08] via-black/70 to-black/90 p-5 backdrop-blur-xl shadow-lg transition-all duration-300 hover:border-yellow-500/50 hover:shadow-[0_10px_30px_rgba(234,179,8,0.12)]">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-yellow-500/10 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
      
      <div className="relative mb-3.5 text-[11px] font-black uppercase tracking-[0.22em] text-yellow-300">
        Ödül Elmas Hedefleri
      </div>
      <div className="relative grid flex-1 gap-2">
        {goals.map((item) => {
          const reached = Boolean(item.goal?.reached);
          const disabled = Boolean(item.disabled);
          const valueText = disabled || reached
            ? item.fallbackText
            : `${formatNumber(item.goal?.remainingDiamonds)} kaldı`;

          const toneClass = disabled
            ? "border-white/10 bg-white/[0.025] text-white/35"
            : reached
              ? "border-emerald-400/40 bg-emerald-500/15 text-emerald-200 shadow-sm"
              : "border-yellow-500/25 bg-black/50 text-white hover:border-yellow-500/40";

          return (
            <div key={item.label} className={`grid grid-cols-[95px_minmax(0,1fr)] items-center gap-2.5 rounded-xl border px-3 py-2 ${toneClass}`}>
              <span className="text-[10px] font-black uppercase tracking-[0.14em] text-yellow-300/80">
                {item.label}
              </span>
              <div className="truncate text-sm font-black leading-tight">
                {valueText}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}


function GoldAnimatedBorderBox({ children, className = "", innerClassName = "" }) {
  return (
    <div className={`relative overflow-hidden rounded-[1.35rem] p-[1.5px] ${className}`}>
      <style>{`
        @keyframes wolfGiftGoldBorderRotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes wolfGiftGoldPulse {
          0%, 100% { box-shadow: 0 0 22px rgba(234,179,8,.16), inset 0 0 18px rgba(234,179,8,.08); }
          50% { box-shadow: 0 0 42px rgba(250,204,21,.34), inset 0 0 24px rgba(250,204,21,.14); }
        }
      `}</style>
      <div
        className="pointer-events-none absolute -inset-28 opacity-90"
        style={{
          background:
            "conic-gradient(from 0deg, rgba(250,204,21,0), rgba(250,204,21,.95), rgba(161,98,7,.22), rgba(250,204,21,0), rgba(250,204,21,.75), rgba(250,204,21,0))",
          animation: "wolfGiftGoldBorderRotate 5s linear infinite",
        }}
      />
      <div
        className={`relative rounded-[1.25rem] border border-yellow-400/35 bg-[radial-gradient(circle_at_top,rgba(234,179,8,.16),transparent_42%),linear-gradient(180deg,rgba(12,12,12,.96),rgba(0,0,0,.92))] ${innerClassName}`}
        style={{ animation: "wolfGiftGoldPulse 3.8s ease-in-out infinite" }}
      >
        {children}
      </div>
    </div>
  );
}

function TierRewardPolicyNotice({ giftWinner, giftWinnerLoading, hasReachedGoal = false }) {
  const giftAmount = safeNumber(
    giftWinner?.finalGiftAmount ||
      giftWinner?.final_gift_amount ||
      giftWinner?.giftAmount ||
      giftWinner?.gift_amount
  );

  if (giftWinnerLoading) {
    return (
      <GoldAnimatedBorderBox className="h-full min-h-[178px]" innerClassName="flex h-full min-h-[176px] flex-col justify-center p-5 text-center">
        <div className="text-[11px] font-black uppercase tracking-[0.22em] text-yellow-300/90">Ödül Bilgilendirmesi</div>
        <div className="mt-3 text-sm font-bold leading-6 text-white/60">Hediye kazanımı kontrol ediliyor...</div>
      </GoldAnimatedBorderBox>
    );
  }

  if (!hasReachedGoal) {
    return (
      <div className="flex h-full min-h-[178px] flex-col items-center justify-center overflow-hidden rounded-[1.35rem] border border-red-500/35 bg-[radial-gradient(circle_at_top_left,rgba(220,38,38,.30),transparent_35%),linear-gradient(180deg,rgba(40,6,8,.96),rgba(10,2,3,.97))] px-4 py-4 text-center shadow-[0_0_24px_rgba(220,38,38,.16)]">
        <div className="text-[9px] font-black uppercase tracking-[0.16em] text-red-100/80 sm:text-[10px]">
          Ödül Politikası Bilgilendirmesi
        </div>
        <div className="mx-auto mt-3 max-w-[21ch] text-balance text-[14px] font-black uppercase leading-[1.18] tracking-[0.015em] text-white sm:text-[16px] xl:text-[18px]">
          Hedeflerini yakalayamayan yayıncılar ödüllerden yararlanamayacaktır.
        </div>
      </div>
    );
  }

  return (
    <GoldAnimatedBorderBox className="h-full min-h-[178px]" innerClassName="flex h-full min-h-[176px] flex-col items-center justify-center px-4 py-4 text-center">
      <div className="text-[9px] font-black uppercase tracking-[0.16em] text-yellow-300/90 sm:text-[10px]">
        Ödül Bilgilendirmesi
      </div>
      <div className="mx-auto mt-3 max-w-[21ch] text-balance text-[15px] font-black uppercase leading-[1.18] tracking-[0.02em] text-white sm:text-[17px] xl:text-[19px]">
        Hedeflerinizi yakaladınız.
      </div>
      <div className="mt-3 text-[11px] font-semibold leading-4 text-yellow-100/80">
        {giftAmount > 0
          ? `Yayınlanan kampanyada ${formatNumber(giftAmount)} elmas hediye kazanımınız oluştu.`
          : "Kampanya yayınlandığında ödül kazanımınız bu alanda görüntülenecektir."}
      </div>
    </GoldAnimatedBorderBox>
  );
}

function TierGoalSideCard({ goal, active, completed }) {
  if (!goal.hasTarget) {
    return (
      <div className="flex h-full flex-col justify-center rounded-2xl border border-white/10 bg-white/[0.025] p-4 text-white/35">
        <div className="text-sm font-black uppercase tracking-[0.12em]">{goal.title}</div>
        <div className="mt-2 text-xs">Bu kademe için uygun hedef yok.</div>
      </div>
    );
  }

  if (completed) {
    return (
      <div className="flex h-full flex-col justify-center rounded-2xl border border-emerald-400/40 bg-emerald-500/10 p-4 shadow-[0_0_25px_rgba(16,185,129,.10)]">
        <div className="text-sm font-black uppercase tracking-[0.12em] text-white">{goal.title}</div>
        <div className="mt-3 inline-flex rounded-xl border border-emerald-400/35 bg-emerald-400/15 px-3 py-1.5 text-xs font-black text-emerald-200">
          Tamamlandı ✅
        </div>
      </div>
    );
  }

  return (
    <div className={`flex h-full flex-col justify-center rounded-2xl border p-4 ${active ? "border-fuchsia-400/45 bg-black/20 shadow-[0_0_22px_rgba(217,70,239,.08)]" : "border-yellow-500/25 bg-black/35"}`}>
      <div className="text-sm font-black uppercase tracking-[0.12em] text-white">{goal.title}</div>
      <div className="mt-3 space-y-2">
        <TierRemainingPill tone="purple" text={`${formatNumber(goal.remainingDiamonds)} elmas kaldı`} />
        <TierRemainingPill tone="cyan" text={`${goal.remainingHours.toFixed(1)} saat kaldı`} />
        <TierRemainingPill tone="yellow" text={`${goal.remainingDays} yayın günü kaldı`} />
      </div>
    </div>
  );
}

function TierRemainingPill({ text, tone }) {
  const toneClass = tone === "purple"
    ? "border-fuchsia-400/30 text-fuchsia-200"
    : tone === "cyan"
      ? "border-cyan-400/30 text-cyan-200"
      : "border-yellow-400/30 text-yellow-200";

  return (
    <div className={`rounded-xl border bg-black/45 px-3 py-2 text-center text-xs font-black ${toneClass}`}>
      {text}
    </div>
  );
}

function TierAwardProgressRow({ goal }) {
  const showWonStatus = goal.reached;

  const diamondRemainingText = goal.remainingDiamonds > 0
    ? `${formatNumber(goal.remainingDiamonds)} elmas kaldı`
    : "Elmas Hedefi Tamamlandı ✅";

  const hourRemainingText = goal.remainingHours > 0
    ? `${goal.remainingHours.toFixed(1)} saat kaldı`
    : "Süre Tamamlandı ✅";

  const dayRemainingText = goal.remainingDays > 0
    ? `${goal.remainingDays} yayın günü kaldı`
    : "Gün Tamamlandı ✅";

  return (
    <div className="h-full rounded-[1.45rem] border border-yellow-500/25 bg-black/45 p-4 sm:p-5 shadow-[0_0_32px_rgba(234,179,8,.08)]">
      <div className="mb-4 flex flex-col gap-2 text-center sm:text-left sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="text-lg sm:text-xl font-black uppercase tracking-[0.12em] text-white flex items-center justify-center sm:justify-start gap-2">
            <span>{goal.detailTitle}</span>
            {showWonStatus && (
              <span className="rounded-full bg-emerald-500/20 border border-emerald-400/40 px-2.5 py-0.5 text-xs font-black text-emerald-300">
                🏆 Tamamlandı
              </span>
            )}
          </div>
          <div className="mt-1 text-xs text-white/40">Hedef yakalandığında ödül seviyesi otomatik hesaplanır.</div>
        </div>
      </div>

      <div className="grid gap-4 lg:grid-cols-3">
        <TierProgressMetric
          title="Kazanılan Elmas"
          current={formatNumber(goal.currentDiamonds)}
          target={formatNumber(goal.targetDiamonds)}
          percent={goal.diamondPercent}
          color="from-fuchsia-400 to-fuchsia-500"
          valueClass="text-fuchsia-200"
          remainingBadge={diamondRemainingText}
          remainingTone="purple"
          isDone={goal.remainingDiamonds <= 0}
        />
        <TierProgressMetric
          title="Yayın Süresi"
          current={goal.currentLiveHours.toFixed(1)}
          target={goal.targetHours.toFixed(1)}
          percent={goal.hourPercent}
          color="from-cyan-300 to-cyan-500"
          valueClass="text-cyan-200"
          remainingBadge={hourRemainingText}
          remainingTone="cyan"
          isDone={goal.remainingHours <= 0}
        />
        <TierProgressMetric
          title="Yayın Günü"
          current={goal.currentLiveDays}
          target={goal.targetDays}
          percent={goal.dayPercent}
          color="from-yellow-300 to-yellow-500"
          valueClass="text-yellow-200"
          note="Farklı günlerde açılan yayın sayısı"
          remainingBadge={dayRemainingText}
          remainingTone="yellow"
          isDone={goal.remainingDays <= 0}
        />
      </div>
    </div>
  );
}

function TierProgressMetric({ title, current, target, percent, color, valueClass, note, remainingBadge, remainingTone = "yellow", isDone = false }) {
  const safePercent = Math.min(Math.max(safeNumber(percent), 0), 100);

  const badgeToneClass = isDone
    ? "border-emerald-400/40 bg-emerald-500/15 text-emerald-300"
    : remainingTone === "purple"
      ? "border-fuchsia-400/35 bg-fuchsia-500/15 text-fuchsia-200"
      : remainingTone === "cyan"
        ? "border-cyan-400/35 bg-cyan-500/15 text-cyan-200"
        : "border-yellow-400/35 bg-yellow-500/15 text-yellow-200";

  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-3.5 sm:p-4 flex flex-col justify-between">
      <div>
        <div className="flex items-center justify-between gap-2">
          <span className="text-[11px] font-black uppercase tracking-[0.14em] text-white/75">{title}</span>
          <span className={`text-lg sm:text-xl font-black ${valueClass}`}>%{safePercent}</span>
        </div>

        {remainingBadge && (
          <div className={`mt-2 rounded-xl border px-2.5 py-1 text-center text-xs font-black shadow-xs ${badgeToneClass}`}>
            {remainingBadge}
          </div>
        )}

        <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-white/10">
          <div className={`h-full rounded-full bg-gradient-to-r ${color}`} style={{ width: `${safePercent}%` }} />
        </div>
      </div>

      <div className="mt-3">
        <div className="flex flex-wrap items-center gap-2 text-sm sm:text-base font-black text-white">
          <span>{current}</span>
          <span className="text-white/40">/</span>
          <span className="text-white/80">Hedef: {target}</span>
        </div>
        {note && <div className="mt-1 text-[9.5px] font-bold uppercase tracking-[0.06em] text-white/40">{note}</div>}
      </div>
    </div>
  );
}
const BUILTIN_ACADEMY_MASTERCLASSES = [
  {
    id: "acad_1",
    title: "TikTok Algoritması: Yayını İlk 5 Dakikada Keşfete Düşürme (Türkçe Anlatım)",
    category: "Algoritma & Keşfet",
    duration: "4 dk 20 sn",
    level: "Tüm Seviyeler",
    instructor: "Wolf Media Akademi Ekibi",
    thumbnail: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&auto=format&fit=crop&q=80",
    embedUrl: "https://www.youtube.com/embed/HcUJVM_r_GE?rel=0&modestbranding=1",
    directUrl: "https://www.youtube.com/watch?v=HcUJVM_r_GE",
    desc: "TikTok canlı yayın algoritması ilk 5 dakikadaki izleyici etkileşimi, yorum hızı ve beğeni oranına göre yayını Keşfet (For You) akışına basar. Bu derste yayına başlar başlamaz kitleyi nasıl tutacağınızı öğrenin.",
    tactics: [
      "Yayını açar açmaz 50-100 elmaslık küçük bir sandık (Treasure Box) fırlatın; bu izleyicileri en az 5 dakika ekranda tutar.",
      "Gelen ilk 10 izleyiciye mutlaka ismiyle hitap edin ve basit bir soru sorun ('Hoş geldin [İsim], bugün nereden katılıyorsun?').",
      "İlk 15 dakika boyunca PK'ya girmeyin; önce kendi kitlenizle enerjiyi ve beğeni sayısını (en az 5.000 tap) yükseltin."
    ],
    checklist: [
      "Yayın başlığına merak uyandırıcı soru yazdım",
      "Arka plan ışığını ve mikrofonu kontrol ettim",
      "İlk etkileşim sandığını ayarladım"
    ],
    turkishGuide: "TikTok algoritması canlı yayınınızı ilk açtığınız andaki ilk 300 saniyeyi (5 dakikayı) test eder. Eğer bu sürede gelen izleyiciler ekrana çift tıklar (beğeni), yorum yazar ve yayında 60 saniyeden fazla kalırsa, algoritma yayınınızı 'Yüksek Etkileşimli' olarak etiketleyip binlerce yeni kullanıcının Keşfet akışına fırlatır. Bu yüzden yayına girer girmez sessiz kalmayın, enerjik bir müzikle açılış yapın ve ilk gelenlere isimleriyle 'Hoş geldin' deyin."
  },
  {
    id: "acad_2",
    title: "PK Savaşlarında Son 30 Saniye: Eldiven (Glove) & Sis Bombası Taktikleri",
    category: "PK & Turnuva Taktikleri",
    duration: "3 dk 50 sn",
    level: "Orta / İleri Düzey",
    instructor: "Wolf Media PK Stratejisti",
    thumbnail: "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=800&auto=format&fit=crop&q=80",
    embedUrl: "https://www.youtube.com/embed/RPvoPkIKr7w?rel=0&modestbranding=1",
    directUrl: "https://www.youtube.com/watch?v=RPvoPkIKr7w",
    desc: "PK maçlarında puanın %80'i son 30 saniyede döner. Eldiven (x5 çarpan) ve Sis Bombası (puanı gizleme) güçlendirmelerini doğru zamanda tetikleyerek maçları nasıl çevireceğinizin formülü.",
    tactics: [
      "Eldiven açıldığında kitleyi 'Tekli küçük hediyelerle x5'i vurun' diyerek organize edin; büyük hediyeleri çarpan anına saklayın.",
      "Sis bombasını maçın bitimine tam 25 saniye kala patlatın; rakip kaç puan geride olduğunu göremeyip panikler.",
      "Rakiple asla kavga etmeyin; tatlı ve esprili rekabet yaratarak iki tarafın da destekçilerini gaza getirin."
    ],
    checklist: [
      "Destekçilerime eldiven kuralını anlattım",
      "Göz ucuyla süre sayacını takip ettim",
      "Maç sonu rakibe ve izleyicilere teşekkür ettim"
    ],
    turkishGuide: "PK maçlarında en büyük hata maçın ilk dakikalarında büyük hediyeleri harcamaktır. Deneyimli yayıncılar maçın ilk 3 dakikasını sadece sohbet ve ufak tıklamalarla geçirir. Son 45 saniyede eldiven (x5) açıldığı an kitleyi uyarın: Tek tek atılan 10 elmaslık hediyeler x5 çarpanla 50 elmas değerine ulaşır. Sis bombası ise son 20 saniyede rakibin skoru görmesini engelleyerek stratejik zafer kazandırır."
  },
  {
    id: "acad_3",
    title: "Büyük Destekçileri (VIP Gifter) Karşılama ve Sadakat Oluşturma",
    category: "Destekçi Yönetimi",
    duration: "5 dk 10 sn",
    level: "İleri Düzey",
    instructor: "Wolf Media Menajerlik Birimi",
    thumbnail: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&auto=format&fit=crop&q=80",
    embedUrl: "https://www.youtube.com/embed/eHItV3NtcmI?rel=0&modestbranding=1",
    directUrl: "https://www.youtube.com/watch?v=eHItV3NtcmI",
    desc: "Yayıncılığın en kritik kuralı: Destekçilere sadece 'hediye atan cüzdan' gibi değil, yayınınızın en değerli ortağı gibi hissettirmektir. Doğru teşekkür ve sınır dengesi rehberi.",
    tactics: [
      "Büyük hediye (Aslan, Evren vb.) geldiğinde yayını 10 saniye durdurup göz temasıyla samimi ve abartısız teşekkür edin.",
      "VIP destekçilerinizin isimlerini yayın profilinizde veya yayın panonuzda haftalık onur köşesine ekleyin.",
      "Yayın dışı iletişimde her zaman saygılı, mesafeli ve ajans güvencesi kurallarına uygun hareket edin."
    ],
    checklist: [
      "Özel teşekkür hitabımı belirledim",
      "Destekçi onur köşesini güncelledim"
    ],
    turkishGuide: "Büyük destekçiler (Gifter) gösterişli çığlıklardan ziyade samimi, saygılı ve isme özel teşekkürleri takdir eder. Yayınınızda düzenli hediye atan kişilerin özel günlerini (doğum günü vb.) unutmayın, yayın profilinizin biyografi kısmına 'Haftanın Şampiyonu' olarak adlarını yazın. Ajansımızın koruma kuralları gereği özel hayat sınırlarınızı koruyarak profesyonel bir dostluk kurun."
  },
  {
    id: "acad_4",
    title: "TikTok LIVE Studio & OBS ile Profesyonel Bilgisayar Yayını (Türkçe Kurulum)",
    category: "Teknik Setup",
    duration: "6 dk 15 sn",
    level: "Başlangıç / Teknik",
    instructor: "Wolf Media Teknik Destek",
    thumbnail: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=800&auto=format&fit=crop&q=80",
    embedUrl: "https://www.youtube.com/embed/mdq2nOcSyz0?rel=0&modestbranding=1",
    directUrl: "https://www.youtube.com/watch?v=mdq2nOcSyz0",
    desc: "Telefon yayını yerine bilgisayardan kaliteli kamera, hedef çubuğu, hediye sayaçları ve ekran paylaşımı ile profesyonel canlı yayın açmanın adım adım rehberi.",
    tactics: [
      "TikTok LIVE Studio'da bitrate ayarını internet hızınıza göre 4000-6000 Kbps aralığında sabitleyin.",
      "Ekranın sağ ve sol alt köşelerini hediyelerin ve sohbetin rahat görünmesi için boş bırakın.",
      "Arka plan için sıcak LED veya RGB ışıklandırma kullanarak profesyonel derinlik oluşturun."
    ],
    checklist: [
      "Mikrofon gürültü filtresini açtım",
      "Hedef elmas sayacını ekrana yerleştirdim"
    ],
    turkishGuide: "Bilgisayardan yayın açmak izleyicilere anında televizyon stüdyosu kalitesi hissi verir. TikTok LIVE Studio programını bilgisayarınıza kurduktan sonra 'Dikey Format (1080x1920)' seçeneğini ayarlayın. Kameranızı göz hizanıza yerleştirin. TikFinity veya dahili hedef eklentisi ile ekrana 'Günün Hedefi: 5.000 Elmas' gibi bir ilerleme çubuğu koymak bağış oranını %40 artırır."
  },
  {
    id: "acad_5",
    title: "TikTok Canlı Yayın İhlal & Güvenlik Kılavuzu (Ban Riskini Sıfırlayın)",
    category: "Güvenlik & Kurallar",
    duration: "3 dk 30 sn",
    level: "Tüm Seviyeler",
    instructor: "Wolf Media Hukuk & Uyumluluk",
    thumbnail: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&auto=format&fit=crop&q=80",
    embedUrl: "https://www.youtube.com/embed/B8cvn9AKen4?rel=0&modestbranding=1",
    directUrl: "https://www.youtube.com/watch?v=B8cvn9AKen4",
    desc: "18 yaş altı görüntüleri, telifli müzik uyarıları, tehlikeli hareketler ve argo kelimeler yüzünden yayın kesintisi yaşamamak için bilmeniz gereken en kritik TikTok kuralları.",
    tactics: [
      "Kamerayı asla boş bırakmayın; yayından kısa süreliğine ayrılacaksanız 'Hemen Geliyorum' görseli koyun.",
      "Müzik açarken arka planda konuşma sesinizin müziği bastırdığından emin olun veya telifsiz müzik listelerimizi kullanın.",
      "Yorumlardaki trollerle tartışmaya girmeyin; moderatörünüze sessize alma (mute) yetkisi verin."
    ],
    checklist: [
      "Güvenilir 2 moderatör atadım",
      "Kelimeleri filtreleme listesine ekledim"
    ],
    turkishGuide: "TikTok'un yapay zeka denetçileri kamerada insan yüzü göremediğinde (boş ekran) yayını otomatik olarak sonlandırabilir. Yayından 2 dakika ayrılmanız gerekirse mutlaka ekran koruyucu veya bilgilendirme yazısı koyun. Yayında sigara, alkol, trafikte araç kullanma veya 18 yaşından küçük bireylerin görünmesi kesinlikle kalıcı ban sebebidir. Olası bir yanlış kısıtlamada doğrudan menajerinize haber verin."
  },
  {
    id: "acad_6",
    title: "Yayın İçi Sohbet Tıkanınca Ne Yapmalı? (100+ İnteraktif Konu)",
    category: "İçerik & Eğlence",
    duration: "4 dk 05 sn",
    level: "Tüm Seviyeler",
    instructor: "Wolf Media Eğitmenleri",
    thumbnail: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&auto=format&fit=crop&q=80",
    embedUrl: "https://www.youtube.com/embed/L_LUpnjgPso?rel=0&modestbranding=1",
    directUrl: "https://www.youtube.com/watch?v=L_LUpnjgPso",
    desc: "Yayında sessizlik başladığında izleyici düşer. İzleyicileri sohbete bağlayan mini anketler, hikaye anlatımı ve eğlenceli soru kalıpları.",
    tactics: [
      "İkili seçenek soruları sorun ('Çay mı kahve mi?', 'Yaz insanı mı kış insanı mı?') — Yorum sayısı anında 5 katına çıkar.",
      "Günün veya haftanın komik bir olayını 2 dakikalık mini hikaye olarak anlatın.",
      "İzleyicilerinize tavsiye danışın ('Bu hafta sonu hangi filmi izleyeyim?'); insanlar fikir vermeyi çok sever."
    ],
    checklist: [
      "3 adet interaktif soru hazırladım",
      "Anket özelliğini test ettim"
    ],
    turkishGuide: "Canlı yayında izleyiciyi tutmanın sırrı 'monolog' değil 'diyalog' kurmaktır. Sadece oturup yorumların gelmesini beklemeyin. Sürekli açık uçlu sorular sorun. 'Şu an işte olanlar 1 yazsın, evde olanlar 2 yazsın' gibi basit katılım komutları bile sohbet akışını alevlendirir ve izlenme sürenizi ikiye katlar."
  }
];

const BUILTIN_PRESENTATION_DECKS = [
  {
    id: "deck-1",
    title: "Wolf Media 30 Günlük Yayıncı Yol Haritası",
    category: "Strateji Sunumu",
    pages: "18 Slayt",
    type: "PDF / Sunum",
    icon: "📊",
    desc: "Kademe 1'den Kademe 10'a çıkış için gün gün planlanmış yayın saatleri, hedef elmaslar ve PK takvimi."
  },
  {
    id: "deck-2",
    title: "PK Savaşları Hızlı Taktik & Komut Kartı",
    category: "Hızlı Başvuru Rehberi",
    pages: "4 Sayfa",
    type: "İndirilebilir Kart",
    icon: "⚔️",
    desc: "Yayın esnasında masanızın yanında durabilecek, saniye saniye komut ve taktik infografiği."
  },
  {
    id: "deck-3",
    title: "TikTok LIVE İhlal ve Ceza Sözlüğü (2026)",
    category: "Kural Kitapçığı",
    pages: "12 Sayfa",
    type: "Güvenlik Rehberi",
    icon: "🛡️",
    desc: "Yasaklı kelimeler, hareket kısıtlamaları ve hesap kapanmalarına karşı resmi koruma rehberi."
  }
];

function AcademyPanel({
  academyRows = [],
  academyLoading,
  academyError,
  selectedAcademy,
  setSelectedAcademy,
  onView,
  academyComment,
  setAcademyComment,
  academyRating,
  setAcademyRating,
  academyFeedbackSaving,
  onFeedbackSave,
}) {
  const [activeCategory, setActiveCategory] = useState("Tümü");
  const [activeVideoModal, setActiveVideoModal] = useState(null);
  const [activeModalTab, setActiveModalTab] = useState("video"); // "video" or "guide"
  const [dbLessons, setDbLessons] = useState([]);
  const [dbDecks, setDbDecks] = useState([]);
  const [watchedLessons, setWatchedLessons] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("wm_watched_lessons") || '["acad_1"]');
    } catch {
      return ["acad_1"];
    }
  });

  useEffect(() => {
    let ignore = false;
    async function fetchDbLessons() {
      try {
        const res = await fetch("/api/academy-list.php", { cache: "no-store" });
        const json = await res.json();
        if (!ignore && json && json.success) {
          if (Array.isArray(json.lessons) && json.lessons.length > 0) {
            setDbLessons(json.lessons);
          }
          if (Array.isArray(json.decks) && json.decks.length > 0) {
            setDbDecks(json.decks);
          }
        }
      } catch (e) {}
    }
    fetchDbLessons();
    return () => { ignore = true; };
  }, []);

  const allLessons = useMemo(() => {
    if (dbLessons && dbLessons.length > 0) {
      const dbIds = new Set(dbLessons.map((l) => l.id));
      const fallbacks = BUILTIN_ACADEMY_MASTERCLASSES.filter((l) => !dbIds.has(l.id));
      return [...dbLessons, ...fallbacks];
    }
    return BUILTIN_ACADEMY_MASTERCLASSES;
  }, [dbLessons]);

  const presentationDecks = useMemo(() => {
    return (dbDecks && dbDecks.length > 0) ? dbDecks : BUILTIN_PRESENTATION_DECKS;
  }, [dbDecks]);

  const categories = ["Tümü", "Algoritma & Keşfet", "PK & Turnuva Taktikleri", "Destekçi Yönetimi", "Teknik Setup", "Güvenlik & Kurallar", "İçerik & Eğlence"];

  const filteredLessons = activeCategory === "Tümü"
    ? allLessons
    : allLessons.filter((l) => l.category === activeCategory);

  const completedCount = watchedLessons.length;
  const totalCount = allLessons.length;
  const progressPercent = Math.min(Math.round((completedCount / (totalCount || 1)) * 100), 100);

  function toggleLessonWatched(id) {
    setWatchedLessons((prev) => {
      const next = prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
      try {
        localStorage.setItem("wm_watched_lessons", JSON.stringify(next));
      } catch {}
      return next;
    });
  }

  function handleOpenVideo(lesson) {
    setActiveVideoModal(lesson);
    setActiveModalTab("video");
    if (!watchedLessons.includes(lesson.id)) {
      toggleLessonWatched(lesson.id);
    }
  }

  const directWatchUrl = activeVideoModal
    ? (activeVideoModal.directUrl || (activeVideoModal.embedUrl ? activeVideoModal.embedUrl.replace('/embed/', '/watch?v=').split('?')[0] : 'https://youtube.com'))
    : '';

  return (
    <div className="space-y-6">
      {/* 🌟 1. AKADEMİ HERO BANNER */}
      <div className="relative overflow-hidden rounded-3xl border border-amber-500/30 bg-gradient-to-r from-[#14120e] via-[#1b1710] to-[#121118] p-6 sm:p-8 shadow-xl">
        <div className="relative z-10 flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <div className="flex items-center gap-2 text-xs font-black uppercase tracking-[0.28em] text-yellow-400">
              <span>🎓</span>
              <span>WOLF MEDIA MASTERCLASS & YAYINCI AKADEMİSİ</span>
            </div>
            <h2 className="mt-2 text-2xl sm:text-3xl font-black text-white">
              Yayıncılık Kariyerini ve <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-amber-400 to-yellow-500">Elmas Gelirini Katla</span>
            </h2>
            <p className="mt-2 text-xs sm:text-sm leading-6 text-white/70">
              TikTok algoritması, PK savaşları psikolojisi, VIP destekçi yönetimi ve teknik kurulum hakkında ajansımızın hazırladığı %100 Türkçe video eğitimleri ve taktik rehberleri.
            </p>
          </div>

          <div className="min-w-[240px] rounded-2xl border border-white/10 bg-black/50 p-4 backdrop-blur-md">
            <div className="flex items-center justify-between text-xs font-bold text-white/80">
              <span>Akademi İlerlemesi</span>
              <span className="text-yellow-400 font-black">%{progressPercent}</span>
            </div>
            <div className="mt-2 h-2.5 overflow-hidden rounded-full bg-white/10">
              <div
                className="h-full rounded-full bg-gradient-to-r from-yellow-400 to-amber-500 transition-all duration-500"
                style={{ width: `${progressPercent}%` }}
              />
            </div>
            <div className="mt-2.5 flex items-center justify-between text-[11px] text-white/50">
              <span>{completedCount} / {totalCount} Eğitim Tamamlandı</span>
              {progressPercent >= 80 ? (
                <span className="text-emerald-400 font-bold">🏆 Mezun Rozeti Aktif</span>
              ) : (
                <span className="text-yellow-400/70 font-semibold">Hedef: %100</span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* 🌟 2. KATEGORİ FİLTRE BUTONLARI */}
      <div className="flex items-center gap-2 overflow-x-auto pb-1 no-scrollbar">
        {categories.map((cat) => (
          <button
            key={cat}
            type="button"
            onClick={() => setActiveCategory(cat)}
            className={`shrink-0 rounded-xl px-4 py-2 text-xs font-bold transition ${
              activeCategory === cat
                ? "bg-yellow-400 text-black shadow-md shadow-yellow-500/20"
                : "border border-white/10 bg-white/[0.03] text-white/70 hover:border-yellow-500/40 hover:text-white"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* 🌟 3. VİDEO MASTERCLASS EĞİTİM KARTLARI */}
      <div>
        <div className="mb-4 flex items-center justify-between">
          <div>
            <div className="text-[10px] font-black uppercase tracking-[0.25em] text-yellow-400">
              VİDEO MASTERCLASS KÜTÜPHANESİ
            </div>
            <h3 className="text-lg font-black text-white">
              {activeCategory} ({filteredLessons.length} Ders)
            </h3>
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {filteredLessons.map((lesson) => {
            const isWatched = watchedLessons.includes(lesson.id);
            return (
              <div
                key={lesson.id}
                className="group relative flex flex-col justify-between overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] dark:bg-[#121215] transition hover:-translate-y-1 hover:border-yellow-500/50 hover:shadow-xl hover:shadow-yellow-500/5"
              >
                {/* Video Önizleme & Play Butonu */}
                <div className="relative aspect-video w-full overflow-hidden bg-black/60 cursor-pointer" onClick={() => handleOpenVideo(lesson)}>
                  <img
                    src={lesson.thumbnail}
                    alt={lesson.title}
                    className="h-full w-full object-cover opacity-80 transition duration-500 group-hover:scale-105 group-hover:opacity-95"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                  
                  {/* Play İkonu */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-yellow-400 text-black shadow-lg shadow-yellow-500/40 transition group-hover:scale-110">
                      <svg className="w-5 h-5 translate-x-0.5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>

                  {/* Rozetler */}
                  <div className="absolute top-3 left-3 flex items-center gap-1.5">
                    <span className="rounded-lg bg-black/70 px-2 py-1 text-[10px] font-black text-yellow-400 backdrop-blur-md">
                      🇹🇷 {lesson.category}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="rounded-md bg-black/80 px-2 py-0.5 text-[10px] font-bold text-white/90 backdrop-blur-md">
                      ⏱️ {lesson.duration}
                    </span>
                  </div>
                </div>

                {/* İçerik Bilgileri */}
                <div className="flex flex-1 flex-col p-4">
                  <div className="flex items-center justify-between text-[11px] text-white/50 mb-1.5">
                    <span>{lesson.level}</span>
                    <span className="text-yellow-400/80 font-semibold">{lesson.instructor}</span>
                  </div>

                  <h4 className="font-bold text-sm text-white line-clamp-2 leading-snug group-hover:text-yellow-300 transition">
                    {lesson.title}
                  </h4>

                  <p className="mt-2 text-xs text-white/60 line-clamp-2 leading-relaxed">
                    {lesson.desc}
                  </p>

                  {/* 3 Altın Taktik Hap Bilgisi */}
                  {Array.isArray(lesson.tactics) && lesson.tactics.length > 0 && (
                    <div className="mt-3 rounded-xl border border-white/5 bg-black/40 p-2.5">
                      <div className="text-[10px] font-black uppercase tracking-wider text-yellow-400/90 mb-1 flex items-center gap-1">
                        <span>💡</span>
                        <span>Bu Dersten 1 Altın Taktik:</span>
                      </div>
                      <div className="text-[11px] text-white/75 line-clamp-2 leading-tight">
                        {lesson.tactics[0]}
                      </div>
                    </div>
                  )}

                  {/* Alt Aksiyonlar */}
                  <div className="mt-4 flex items-center justify-between border-t border-white/10 pt-3">
                    <button
                      type="button"
                      onClick={() => toggleLessonWatched(lesson.id)}
                      className={`flex items-center gap-1.5 text-xs font-bold transition ${
                        isWatched ? "text-emerald-400" : "text-white/40 hover:text-white"
                      }`}
                    >
                      <span className={`flex h-4 w-4 items-center justify-center rounded-full text-[9px] ${
                        isWatched ? "bg-emerald-500/20 text-emerald-400 font-black" : "border border-white/20"
                      }`}>
                        {isWatched ? "✓" : ""}
                      </span>
                      <span>{isWatched ? "Tamamlandı" : "İzlendi İşaretle"}</span>
                    </button>

                    <button
                      type="button"
                      onClick={() => handleOpenVideo(lesson)}
                      className="rounded-xl bg-yellow-400/10 border border-yellow-500/30 px-3 py-1.5 text-xs font-black text-yellow-300 hover:bg-yellow-400 hover:text-black transition"
                    >
                      Dersi İzle ➔
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 🌟 4. İNDİRİLEBİLİR PERFORMANS SUNUMLARI & PDF TAKTİK KARTLARI */}
      <div className="mt-8 rounded-3xl border border-white/10 bg-white/[0.02] dark:bg-[#121215] p-6 shadow-sm">
        <div className="mb-4 flex items-center justify-between border-b border-white/10 pb-3">
          <div>
            <div className="text-[10px] font-black uppercase tracking-[0.25em] text-yellow-400">
              YAYINCI DÖKÜMANLARI & SUNUMLAR
            </div>
            <h3 className="text-lg font-black text-white">
              Hazır Performans Sunumları & Taktik Kartları
            </h3>
          </div>
          <span className="text-xs font-bold text-white/50">{presentationDecks.length} Materyal Yayında</span>
        </div>

        <div className="grid gap-4 sm:grid-cols-3">
          {presentationDecks.map((deck) => (
            <div key={deck.id} className="flex flex-col justify-between rounded-2xl border border-white/5 bg-black/40 p-4 transition hover:border-yellow-500/40 hover:bg-yellow-500/[0.02]">
              <div>
                <div className="flex items-center justify-between">
                  <span className="text-2xl">{deck.icon}</span>
                  <span className="rounded-md border border-white/10 bg-white/[0.05] px-2 py-0.5 text-[10px] font-bold text-yellow-300">
                    {deck.type}
                  </span>
                </div>
                <h4 className="mt-3 text-sm font-black text-white leading-snug">{deck.title}</h4>
                <p className="mt-1.5 text-xs text-white/60 leading-relaxed line-clamp-3">{deck.desc}</p>
              </div>

              <div className="mt-4 flex items-center justify-between border-t border-white/5 pt-3">
                <span className="text-[11px] font-bold text-white/40">{deck.pages}</span>
                <button
                  type="button"
                  onClick={() => (window.wolfNotice ? window.wolfNotice(`"${deck.title}" dokümanı hazırlandı. Menajeriniz tarafından güncel sürüm size iletilecektir.`, "Wolf Akademi Dokümanı") : alert(`"${deck.title}" dokümanı hazırlandı.`))}
                  className="flex items-center gap-1 text-xs font-bold text-yellow-400 hover:underline"
                >
                  <span>Görüntüle</span>
                  <span>📥</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 🌟 5. SİNEMATİK VİDEO MASTERCLASS MODALI */}
      {activeVideoModal && (
        <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/90 p-4 backdrop-blur-lg">
          <div className="relative w-full max-w-4xl max-h-[95vh] overflow-y-auto rounded-[2rem] border border-yellow-500/30 bg-[#0e0e12] p-5 sm:p-7 text-white shadow-2xl custom-scrollbar">
            
            {/* Modal Üst Bar */}
            <div className="flex items-start justify-between gap-4 border-b border-white/10 pb-4">
              <div>
                <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-wider text-yellow-400">
                  <span className="bg-yellow-500/20 px-2 py-0.5 rounded text-yellow-300">🇹🇷 Türkçe Altyazı & Ses Desteği</span>
                  <span>•</span>
                  <span>{activeVideoModal.category}</span>
                  <span>•</span>
                  <span>{activeVideoModal.duration}</span>
                </div>
                <h3 className="mt-1.5 text-xl sm:text-2xl font-black text-white">{activeVideoModal.title}</h3>
              </div>
              <button
                type="button"
                onClick={() => setActiveVideoModal(null)}
                className="rounded-xl border border-white/10 bg-white/[0.05] px-3 py-2 text-xs font-bold text-white/70 hover:text-white hover:bg-white/10 transition"
              >
                ✕ Kapat
              </button>
            </div>

            {/* Sekme Seçici: Video Oynatıcı vs Türkçe Detaylı Rehber */}
            <div className="mt-4 flex flex-wrap items-center justify-between gap-2 border-b border-white/10 pb-3">
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => setActiveModalTab("video")}
                  className={`flex items-center gap-2 rounded-xl px-4 py-2 text-xs font-black transition ${
                    activeModalTab === "video"
                      ? "bg-yellow-400 text-black shadow-md"
                      : "bg-white/[0.04] text-white/60 hover:text-white"
                  }`}
                >
                  <span>🎬</span>
                  <span>Video Oynatıcı</span>
                </button>
                <button
                  type="button"
                  onClick={() => setActiveModalTab("guide")}
                  className={`flex items-center gap-2 rounded-xl px-4 py-2 text-xs font-black transition ${
                    activeModalTab === "guide"
                      ? "bg-yellow-400 text-black shadow-md"
                      : "bg-white/[0.04] text-white/60 hover:text-white"
                  }`}
                >
                  <span>🇹🇷</span>
                  <span>Türkçe Ders Rehberi & Özet</span>
                </button>
              </div>

              {/* Doğrudan YouTube Butonu */}
              {directWatchUrl && (
                <a
                  href={directWatchUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1.5 rounded-xl border border-red-500/30 bg-red-500/10 px-3 py-1.5 text-xs font-black text-red-400 hover:bg-red-500 hover:text-white transition"
                >
                  <span>▶️</span>
                  <span>YouTube'da Tam Ekran Aç</span>
                </a>
              )}
            </div>

            {/* Video Oynatıcı Alanı */}
            {activeModalTab === "video" && (
              <div className="mt-4 overflow-hidden rounded-2xl border border-white/10 bg-black aspect-video relative shadow-inner">
                <iframe
                  src={activeVideoModal.embedUrl}
                  title={activeVideoModal.title}
                  className="w-full h-full border-0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
            )}

            {/* Türkçe Ders Rehberi & Detaylı Anlatım Alanı */}
            {activeModalTab === "guide" && (
              <div className="mt-4 rounded-2xl border border-yellow-500/20 bg-yellow-500/5 p-5">
                <div className="flex items-center gap-2 text-xs font-black uppercase tracking-wider text-yellow-400 mb-2">
                  <span>📖</span>
                  <span>Dersin Türkçe Özeti ve Stratejisi:</span>
                </div>
                <p className="text-sm leading-7 text-white/80">
                  {activeVideoModal.turkishGuide || activeVideoModal.desc}
                </p>
              </div>
            )}

            {/* Video Altı Taktik & Kontrol Paneli */}
            <div className="mt-6 grid gap-6 md:grid-cols-2">
              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-4">
                <div className="text-xs font-black uppercase tracking-wider text-yellow-400 mb-2 flex items-center gap-1.5">
                  <span>📌</span>
                  <span>Bu Dersten Çıkarılacak 3 Altın Kural</span>
                </div>
                <ul className="space-y-2 text-xs text-white/80 leading-relaxed">
                  {Array.isArray(activeVideoModal.tactics) && activeVideoModal.tactics.map((tactic, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="font-black text-yellow-400">{i + 1}.</span>
                      <span>{tactic}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex flex-col justify-between rounded-2xl border border-white/10 bg-white/[0.02] p-4">
                <div>
                  <div className="text-xs font-black uppercase tracking-wider text-emerald-400 mb-2 flex items-center gap-1.5">
                    <span>✅</span>
                    <span>Yayın Öncesi Kontrol Listesi</span>
                  </div>
                  <div className="space-y-1.5 text-xs text-white/70">
                    {Array.isArray(activeVideoModal.checklist) && activeVideoModal.checklist.map((c, i) => (
                      <div key={i} className="flex items-center gap-2">
                        <input type="checkbox" defaultChecked className="rounded accent-yellow-400" />
                        <span>{c}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mt-4 flex items-center justify-between border-t border-white/10 pt-3">
                  <span className="text-xs text-white/50">Sorun mu var?</span>
                  <button
                    type="button"
                    onClick={() => {
                      setActiveVideoModal(null);
                      (window.wolfNotice ? window.wolfNotice("Yöneticinize doğrudan soru sormak için 'Yönetici Mesajları' paneline aktarılıyorsunuz.", "Wolf Akademi") : alert("Yönetici paneline aktarılıyorsunuz."))
                    }}
                    className="flex items-center gap-1 text-xs font-black text-yellow-400 hover:underline"
                  >
                    <span>💬</span>
                    <span>Yöneticine Sor</span>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}


function EventMediaPreview({ item }) {
  if (!item) return null;
  const isVideo = item.mediaType === "video" || item.videoUrl || (item.imageUrl && item.imageUrl.endsWith(".mp4"));
  if (isVideo) {
    return (
      <video
        src={item.videoUrl || item.imageUrl}
        controls
        className="h-full w-full object-cover"
      />
    );
  }
  return (
    <img
      src={item.imageUrl || "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=800&auto=format&fit=crop&q=80"}
      alt={item.title || "Etkinlik"}
      className="h-full w-full object-cover"
    />
  );
}

function EventsPanel({ rewards = [], loading, error, selectedEvent, setSelectedEvent }) {
  return (
    <Panel title="Etkinlikler ve Bildirimler" icon="♛">
      <div className="mb-5 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="text-[11px] font-bold uppercase tracking-[0.34em] text-yellow-300">
            Yayıncı Etkinlik Merkezi
          </div>
          <div className="mt-2 text-sm text-white/45">
            Aktif ödül, yarışma ve duyuruları belirlenen yayın süresi boyunca takip edebilirsin.
          </div>
        </div>

        <div className="rounded-full border border-yellow-500/25 bg-yellow-500/10 px-3.5 py-1.5 text-[11px] font-semibold text-yellow-300">
          {loading ? "Yükleniyor" : `${rewards.length} Etkinlik`}
        </div>
      </div>

      {error && (
        <div className="mb-5 rounded-2xl border border-red-500/20 bg-red-500/10 p-4 text-sm text-red-200">
          {error}
        </div>
      )}

      {!loading && !error && rewards.length === 0 && (
        <div className="rounded-2xl border border-white/10 bg-black/25 p-5 text-sm text-white/45">
          Şu anda yayında olan ödül veya etkinlik bulunmuyor.
        </div>
      )}

      <div className="grid gap-5 xl:grid-cols-2">
        {rewards.map((item) => (
          <EventVisualCard key={item.id} item={item} onView={setSelectedEvent} />
        ))}
      </div>

      {selectedEvent && (
        <div className="mt-6 rounded-[1.5rem] border border-yellow-500/20 bg-yellow-500/10 p-5">
          <div className="mb-4 flex items-start justify-between gap-4">
            <div>
              <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-yellow-300">
                Etkinlik Detayı
              </div>
              <div className="mt-2 text-xl font-semibold text-white">
                {selectedEvent.detailTitle || selectedEvent.title}
              </div>
              <div className="mt-1 text-sm text-white/45">
                {selectedEvent.badgeText || selectedEvent.contentKind}
              </div>
            </div>

            <button
              type="button"
              onClick={() => setSelectedEvent(null)}
              className="rounded-xl border border-white/10 bg-black/30 px-3 py-2 text-xs font-semibold text-white/60 hover:border-yellow-500/30 hover:text-yellow-300"
            >
              Kapat
            </button>
          </div>

          <div className="mb-5 aspect-video overflow-hidden rounded-2xl border border-white/10 bg-black/35">
            <EventMediaPreview item={selectedEvent} />
          </div>

          <p className="text-sm leading-7 text-white/65">
            {selectedEvent.detailDescription || selectedEvent.desc}
          </p>

          <div className="mt-4 flex flex-wrap gap-3 text-xs text-white/55">
            <span className="rounded-full border border-white/10 bg-black/25 px-3 py-1">
              Durum: {selectedEvent.status}
            </span>
            <span className="rounded-full border border-white/10 bg-black/25 px-3 py-1">
              Başlangıç: {formatDateForDisplay(selectedEvent.startDate)}
            </span>
            <span className="rounded-full border border-white/10 bg-black/25 px-3 py-1">
              Bitiş: {formatDateForDisplay(selectedEvent.endDate)}
            </span>
            <TargetGroupBadge value={selectedEvent.targetGroup || selectedEvent.targetText} compact />
            {selectedEvent.rewardText && (
              <span className="rounded-full border border-yellow-500/20 bg-yellow-500/10 px-3 py-1 text-yellow-300">
                Ödül: {selectedEvent.rewardText}
              </span>
            )}
          </div>
        </div>
      )}
    </Panel>
  );
}

function EventVisualCard({ item, onView }) {
  const isPurple = item.accent === "purple";
  const isVideo = item.contentKind === "video";

  return (
    <div
      className={`overflow-hidden rounded-[1.6rem] border bg-black/30 shadow-[0_18px_55px_rgba(0,0,0,.35)] transition hover:-translate-y-0.5 hover:shadow-[0_25px_75px_rgba(0,0,0,.5)] ${
        isPurple
          ? "border-purple-500/25 bg-purple-500/10"
          : "border-yellow-500/25 bg-yellow-500/10"
      }`}
    >
      <div className="relative min-h-[230px] overflow-hidden p-5">
        {item.imageUrl && !isVideo && (
          <img
            src={item.imageUrl}
            alt={item.title}
            className="absolute inset-0 h-full w-full object-cover opacity-30"
          />
        )}

        <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(0,0,0,.72),rgba(0,0,0,.35))]" />

        <div className="relative z-10">
          <div
            className={`mb-4 inline-flex rounded-full border px-4 py-1 text-[10px] font-black uppercase tracking-[0.25em] ${
              isPurple
                ? "border-purple-300/25 bg-purple-500/20 text-purple-100"
                : "border-yellow-300/25 bg-yellow-500/20 text-yellow-100"
            }`}
          >
            {item.badgeText || (isVideo ? "Video Duyuru" : "Ödül Duyurusu")}
          </div>

          <div className="max-w-xl text-3xl font-black uppercase leading-tight text-white">
            {item.visualTitle || item.title}
          </div>

          {item.visualSub && (
            <div className="mt-3 text-sm font-black uppercase tracking-[0.18em] text-yellow-100">
              {item.visualSub}
            </div>
          )}

          <div className="mt-5 flex flex-wrap gap-3 text-xs text-white/65">
            <TargetGroupBadge value={item.targetGroup || item.targetText} compact />
            {item.rewardText && (
              <span className="rounded-full border border-yellow-500/20 bg-yellow-500/10 px-3 py-1 text-yellow-300">
                {item.rewardText}
              </span>
            )}
            <span className="rounded-full border border-white/10 bg-black/30 px-3 py-1">
              Bitiş: {formatDateForDisplay(item.endDate)}
            </span>
          </div>
        </div>

        {isVideo && (
          <div className="absolute right-5 top-5 z-10 rounded-full border border-white/10 bg-black/50 px-3 py-1 text-xs font-bold text-white">
            Video
          </div>
        )}
      </div>

      <div className="border-t border-white/10 bg-black/25 p-5">
        <div className="text-base font-bold text-white">{item.title}</div>
        <p className="mt-2 text-sm leading-6 text-white/55">
          {item.desc || "Açıklama bulunmuyor."}
        </p>

        <button
          type="button"
          onClick={() => onView(item)}
          className="mt-4 rounded-xl border border-yellow-500/25 bg-yellow-500/10 px-3.5 py-1.5 text-[11px] font-semibold text-yellow-300 hover:bg-yellow-500 hover:text-black"
        >
          Görüntüle
        </button>
      </div>
    </div>
  );
}

/* =========================================================================
   🎬 WOLF CREATOR STUDIO & ZAKAN BİLİŞİM EDİTÖR DESTEĞİ
   Wolf Media x Zakan Bilişim Resmi Prodüksiyon & Teknoloji Ortaklığı
   ========================================================================= */

const API_EDITOR_REQUEST_CREATE = "/api/editor-request-create.php";
const API_EDITOR_MY_REQUESTS = "/api/editor-my-requests.php";

const WCS_PLATFORMS = [
  { id: "tiktok", label: "TikTok Studio", icon: "🎵", desc: "Canlı yayın kesitleri, viral kurgular ve PK zaferleri" },
  { id: "youtube", label: "YouTube Creator", icon: "▶️", desc: "Shorts, uzun montaj ve tıklanma garantili kapaklar" },
  { id: "instagram", label: "Instagram Reels", icon: "📸", desc: "Reels trendleri, afiş tasarımları ve profil estetiği" },
  { id: "general", label: "Genel Edit & Teknoloji", icon: "⚡", desc: "OBS kurulum, ses/kamera kalibrasyonu ve özel çözümler" },
];

const WCS_SERVICES_DATA = {
  tiktok: [
    {
      id: "tk_1",
      icon: "🎬",
      title: "TikTok Canlı Yayın Kesiti & Viral Kurgu",
      category: "Kısa Video & Keşfet",
      badge: "EN ÇOK TERCİH EDİLEN",
      desc: "Yayınınızdaki en komik, eğlenceli veya dramatik anların ritmik kesimi, dinamik Türkçe vurgulu altyazılar, dikkat çeken kancalı (hook) giriş ve ses efektleri (SFX).",
      delivery: "24–48 Saat",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Dinamik Altyazı & Zoom Efektleri", "Trend Müzik & Ses Miksajı", "Keşfet Algoritması Optimizasyonu", "Ücretsiz Revize Desteği"]
    },
    {
      id: "tk_2",
      icon: "⚔️",
      title: "PK Savaşları & Zafer Klipleri",
      category: "Rekabet & Hediye Zaferi",
      badge: "YÜKSEK ETKİLEŞİM",
      desc: "PK maçınızın son saniyeleri, eldiven zaferleri ve hediye yağmurlarının sinematik neon efektler ve zafer müziğiyle kurgulanması. Destekçilerinizi onurlandırmanın en prestijli yolu.",
      delivery: "24 Saat",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Son Saniye Eldiven & Zafer Kurgusu", "Destekçi İsimlerini Vurgulama", "Geri Sayım & Neon Görsel Efektler", "TikTok Formatında 9:16"]
    },
    {
      id: "tk_3",
      icon: "💎",
      title: "VIP Destekçi Teşekkür Videosu",
      category: "Destekçi Sadakati & Prestij",
      badge: "SADAKAT ARTIRICI",
      desc: "En büyük destekçilerinize özel hazırlanan 15 saniyelik sinematik teşekkür videosu ve dijital teşekkür kartı. Destekçilerinizi onurlandırın, yeni hediye yağmurlarını teşvik edin.",
      delivery: "24 Saat",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Destekçiye Özel İsimli Sinematik Klip", "Özel Teşekkür Kartı Tasarımı", "Yüksek Çözünürlük", "Paylaşıma Hazır Format"]
    },
    {
      id: "tk_custom",
      icon: "✨",
      title: "Diğer Özel TikTok Talebi",
      category: "Özel İstek & Kurgu",
      badge: "SINIRSIZ KAPSAM",
      desc: "Yukarıdaki paketler dışındaki tüm özel TikTok içerik kurguları, seri video projeleri, özel filtre/efekt istekleri veya kampanya talepleriniz.",
      delivery: "Talebe Göre (24–48 Saat)",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Yayıncıya Özel Tasarlanan Kurgu", "Özel İhtiyaç ve Format Uyarlaması", "Öncelikli İnceleme", "Revize Desteği"]
    }
  ],
  youtube: [
    {
      id: "yt_1",
      icon: "📱",
      title: "YouTube Shorts Viral Kurgu Paketi",
      category: "Kısa Video & Algoritma",
      badge: "ABONE KAZANDIRICI",
      desc: "60 saniyelik dikey format, ilk 3 saniyede izleyiciyi yakalayan güçlü kanca, ritmik altyazılar ve Shorts Keşfet algoritmasına tam uyumlu montaj.",
      delivery: "24–48 Saat",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["İlk 3 Saniye Kanca (Hook) Kurgusu", "Hareketli Altyazı & Ses Efektleri", "Shorts SEO ve Etiket Tavsiyesi", "Hızlı Teslimat"]
    },
    {
      id: "yt_2",
      icon: "🎬",
      title: "Uzun Format Video & Yayın Montajı",
      category: "Uzun Video & Bölümleme",
      badge: "KANAL BÜYÜTME",
      desc: "10-30 dakikalık yayın kayıtlarınızdan sıkıcı anları ayıklama, bölümlere ayırma, renk/ses kalibrasyonu ve akıcı kurgu ile YouTube kanalınızı büyütme.",
      delivery: "2–4 Gün",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Gereksiz Kısımları Ayıklama & Hızlı Ritim", "Bölümlendirme (Timestamps)", "Renk Düzeltme & Ses İyileştirme", "Giriş (Intro) ve Kapanış Ekleme"]
    },
    {
      id: "yt_3",
      icon: "🖼️",
      title: "Tıklanma Garantili Thumbnail (Kapak) Tasarımı",
      category: "Görsel Tasarım & Tıklanma (CTR)",
      badge: "YÜKSEK TIKLANMA",
      desc: "Videonuzun tıklanma oranını (CTR) doğrudan artıran 3D tipografili, profesyonel yüz rötuşlu ve merak uyandıran YouTube kapak görseli.",
      delivery: "24 Saat",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Yüksek Çözünürlüklü 3D Tasarım", "Yüz Rötuşu & Parlak Kontrast", "Mobil YouTube Uyumlu Tipografi", "2 Farklı Varyasyon"]
    },
    {
      id: "yt_custom",
      icon: "✨",
      title: "Diğer Özel YouTube Talebi",
      category: "Özel Kurgu & Yönetim",
      badge: "SINIRSIZ KAPSAM",
      desc: "Kanal yönetimi, özel podcast montajı, belgesel tarzı yayın özeti, özel intro/outro veya YouTube topluluk gönderisi tasarımlarınız.",
      delivery: "Talebe Göre (1–3 Gün)",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Özel Kurgu ve Montaj Kapsamı", "Kanal Formatına Birebir Uyum", "Öncelikli İnceleme", "Revize Desteği"]
    }
  ],
  instagram: [
    {
      id: "ig_1",
      icon: "🚀",
      title: "Instagram Reels & Trend Kurgusu",
      category: "Reels & Estetik",
      badge: "TREND VE KEŞFET",
      desc: "Instagram algoritmasıyla uyumlu trend sesler, modern renk tonlaması (Color Grading), akıcı geçişler ve profil estetiğinize uygun kurgu.",
      delivery: "24–48 Saat",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Trend Sesler & Ritim Eşleme", "Sinematik Renk Tonlaması", "Estetik Altyazı & Geçişler", "Kapak Görseli Dahil"]
    },
    {
      id: "ig_2",
      icon: "🖼️",
      title: "Canlı Yayın Duyuru Afişi & Story Tasarımı",
      category: "Hikaye (Story) & Afiş",
      badge: "YAYINA İZLEYİCİ ÇEKME",
      desc: "Canlı yayın veya PK maçından önce Instagram hikayelerinizde ve gönderilerinizde paylaşabileceğiniz göz alıcı 3D duyuru afişi.",
      delivery: "24 Saat",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["9:16 Story ve 1:1 Gönderi Boyutları", "3D Altın Tipografi & Yayıncı Rötuşu", "Geri Sayım Çerçevesi", "Hızlı Teslimat"]
    },
    {
      id: "ig_3",
      icon: "🎨",
      title: "Instagram Profil & Grid Tasarım Paketi",
      category: "Marka Kimliği",
      badge: "PROFİLİ DÖNÜŞTÜRÜN",
      desc: "Öne çıkanlar kapakları, biyografi yönlendirme görselleri ve estetik profil ızgara tasarımı ile profilinizi kurumsal bir fenomene dönüştürün.",
      delivery: "24–48 Saat",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Öne Çıkanlar (Highlights) Kapak Seti", "Biyografi Banner & Link Görseli", "Profil Renk Paleti Belirleme", "Estetik Bütünlük"]
    },
    {
      id: "ig_custom",
      icon: "✨",
      title: "Diğer Özel Instagram Talebi",
      category: "Özel Tasarım & Kampanya",
      badge: "SINIRSIZ KAPSAM",
      desc: "Özel sponsorluk iş birliği postları, karusel (kaydırmalı) gönderi tasarımı, özel çekiliş afişi veya influencer marka kimliği projeleriniz.",
      delivery: "Talebe Göre (24–48 Saat)",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Özel Boyut ve Tasarım Şablonları", "Marka ve Yayıncı Kimliği Uyumu", "Öncelikli İnceleme", "Revize Desteği"]
    }
  ],
  general: [
    {
      id: "gen_1",
      icon: "🛠️",
      title: "OBS & Live Studio Teknolojik Setup",
      category: "Teknoloji & Kurulum",
      badge: "TV KALİTESİNDE YAYIN",
      desc: "Özel animasyonlu elmas hedef çubuğu (Goal Bar), hediye sayaçları, yayıncı çerçevesi (Overlay) ve OBS ses/kamera kalibrasyon danışmanlığı.",
      delivery: "1–2 Gün",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Özel Animasyonlu Overlay & Çerçeve", "Dinamik Elmas Hedef Çubuğu", "Ses Filtresi & Kamera Optimizasyonu", "Uzak Bağlantı ile Birebir Kurulum"]
    },
    {
      id: "gen_2",
      icon: "🎙️",
      title: "Ses, Mikrofon & Kamera Kalibrasyon Danışmanlığı",
      category: "Teknik Destek",
      badge: "KRİSTAL NETLİĞİNDE SES",
      desc: "Yayındaki arka plan gürültülerini yok etme, stüdyo kalitesinde mikrofon EQ ayarı ve kamera renk/ışık kalibrasyonu ile yayınınızın kalitesini 3 katına çıkarın.",
      delivery: "24 Saat",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Gürültü Engelleme (Noise Gate / Suppressor)", "Mikrofon Kompresör & EQ Kalibrasyonu", "Kamera Işık & Renk Doygunluğu", "Teknik Kontrol Raporu"]
    },
    {
      id: "gen_3",
      icon: "💫",
      title: "Özel Logo, Intro & Animasyon Tasarımı",
      category: "Özel Prodüksiyon",
      badge: "KURUMSAL KİMLİK",
      desc: "Yayıncının adına özel 3D animasyonlu logo, yayın açılış ve kapanış intro videoları ile yayınlarınıza prestijli bir imza atın.",
      delivery: "2–3 Gün",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["3D Hareketli Logo & İsim Animasyonu", "Yayın Açılış / Kapanış İntrosu", "Yüksek Çözünürlüklü Şeffaf Video", "Ses Tasarımı (SFX) Dahil"]
    },
    {
      id: "gen_custom",
      icon: "✨",
      title: "Diğer Özel Prodüksiyon & Teknoloji Talebi",
      category: "Özel Çözümler",
      badge: "SINIRSIZ KAPSAM",
      desc: "Yayıncılık ve dijital medyada ihtiyaç duyduğunuz her türlü özel yazılım, web sayfası, ses miksajı, donanım optimizasyonu veya VIP teknolojik destek.",
      delivery: "Talebe Göre",
      pricingNote: "Wolf Yayıncılarına Özel İndirimli",
      features: ["Birebir Teknoloji & Prodüksiyon Danışmanlığı", "İhtiyaca Özel Geliştirilen Çözüm", "Zakan Bilişim Uzman Ekibi", "Garantili Çözüm"]
    }
  ]
};

const WCS_SHOWCASE_DATA = {
  tiktok: [
    {
      id: "sample_tk_1",
      serviceId: "tk_2",
      title: "Viral PK Zaferi & Eldiven Kurgusu",
      serviceName: "PK Savaşları & Zafer Klipleri",
      platform: "TikTok",
      format: "9:16 Dikey",
      tag: "PK Zaferi",
      youtubeId: "HcUJVM_r_GE",
      coverImg: "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=600&auto=format&fit=crop&q=80",
      desc: "Eldiven vuruşu, Aslan hediyesi ve son 5 saniye heyecanının sinematik kurgusu."
    },
    {
      id: "sample_tk_2",
      serviceId: "tk_1",
      title: "Dinamik Altyazılı Canlı Yayın Kesiti",
      serviceName: "TikTok Canlı Yayın Kesiti & Viral Kurgu",
      platform: "TikTok",
      format: "9:16 Dikey",
      tag: "Viral Kesit",
      youtubeId: "RPvoPkIKr7w",
      coverImg: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=600&auto=format&fit=crop&q=80",
      desc: "Vurgulu Türkçe altyazılar, ses efektleri (SFX) ve hızlı zoom geçişleri."
    },
    {
      id: "sample_tk_3",
      serviceId: "tk_3",
      title: "VIP Destekçi Teşekkür & Rozet Klibi",
      serviceName: "VIP Destekçi Teşekkür Videosu",
      platform: "TikTok",
      format: "9:16 Dikey",
      tag: "VIP Teşekkür",
      youtubeId: "eHItV3NtcmI",
      coverImg: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&auto=format&fit=crop&q=80",
      desc: "Destekçiye özel sinematik teşekkür videosu ve özel teşekkür kartı."
    }
  ],
  youtube: [
    {
      id: "sample_yt_1",
      serviceId: "yt_1",
      title: "YouTube Shorts Yüksek Etkileşim Kurgusu",
      serviceName: "YouTube Shorts Viral Kurgu Paketi",
      platform: "YouTube",
      format: "Shorts 9:16",
      tag: "Shorts Kurgu",
      youtubeId: "mdq2nOcSyz0",
      coverImg: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=600&auto=format&fit=crop&q=80",
      desc: "İlk 3 saniye kancası, ritmik kesimler ve dikkat çeken Shorts altyazısı."
    },
    {
      id: "sample_yt_2",
      serviceId: "yt_2",
      title: "Yayın Özeti & Uzun Video Montajı",
      serviceName: "Uzun Format Video & Yayın Montajı",
      platform: "YouTube",
      format: "16:9 Yatay",
      tag: "Uzun Montaj",
      youtubeId: "B8cvn9AKen4",
      coverImg: "https://images.unsplash.com/photo-1536240478700-b869070f9279?w=600&auto=format&fit=crop&q=80",
      desc: "Yayın kaydından sıkıcı anların ayıklanması, bölümler ve akıcı montaj."
    },
    {
      id: "sample_yt_3",
      serviceId: "yt_3",
      title: "3D Tıklanma Garantili YouTube Thumbnail",
      serviceName: "Tıklanma Garantili Thumbnail (Kapak)",
      platform: "YouTube",
      format: "Thumbnail",
      tag: "Kapak Tasarımı",
      youtubeId: "L_LUpnjgPso",
      coverImg: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=600&auto=format&fit=crop&q=80",
      desc: "Yüksek CTR getiren 3D tipografili ve parlak kontrastlı YouTube video kapağı."
    }
  ],
  instagram: [
    {
      id: "sample_ig_1",
      serviceId: "ig_1",
      title: "Estetik Instagram Reels & Renk Kurgusu",
      serviceName: "Instagram Reels & Trend Kurgusu",
      platform: "Instagram",
      format: "Reels 9:16",
      tag: "Reels Trend",
      youtubeId: "HcUJVM_r_GE",
      coverImg: "https://images.unsplash.com/photo-1516251193007-45ef944ab0c6?w=600&auto=format&fit=crop&q=80",
      desc: "Trend sesler, sinematik renk tonlaması ve estetik altyazı geçişleri."
    },
    {
      id: "sample_ig_2",
      serviceId: "ig_2",
      title: "PK & Canlı Yayın Instagram Hikaye Afişi",
      serviceName: "Canlı Yayın Duyuru Afişi & Story Tasarımı",
      platform: "Instagram",
      format: "Story Afiş",
      tag: "Afiş Tasarımı",
      youtubeId: "RPvoPkIKr7w",
      coverImg: "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=600&auto=format&fit=crop&q=80",
      desc: "Yayın öncesi yüzlerce takipçiyi yayına çeken 3D duyuru afişi."
    },
    {
      id: "sample_ig_3",
      serviceId: "ig_3",
      title: "Instagram Öne Çıkanlar & Grid Tasarım Seti",
      serviceName: "Instagram Profil & Grid Tasarım Paketi",
      platform: "Instagram",
      format: "Profil Tasarımı",
      tag: "Marka Kimliği",
      youtubeId: "eHItV3NtcmI",
      coverImg: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=600&auto=format&fit=crop&q=80",
      desc: "Öne çıkan kapaklar ve profil ızgara tasarımıyla profesyonel kimlik."
    }
  ],
  general: [
    {
      id: "sample_gen_1",
      serviceId: "gen_1",
      title: "Animasyonlu Altın OBS Çerçevesi & Hedef Çubuğu",
      serviceName: "OBS & Live Studio Teknolojik Setup",
      platform: "Genel / OBS",
      format: "Overlay",
      tag: "Teknoloji Setup",
      youtubeId: "mdq2nOcSyz0",
      coverImg: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=600&auto=format&fit=crop&q=80",
      desc: "Hedef elmas çubuğu, son hediye bildirimleri ve şık altın yayın çerçevesi."
    },
    {
      id: "sample_gen_2",
      serviceId: "gen_2",
      title: "Kristal Netliğinde Ses & Kamera Kalibrasyonu",
      serviceName: "Ses, Mikrofon & Kamera Kalibrasyon Danışmanlığı",
      platform: "Genel / Ses",
      format: "Kalibrasyon",
      tag: "Ses & Görüntü",
      youtubeId: "B8cvn9AKen4",
      coverImg: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=600&auto=format&fit=crop&q=80",
      desc: "Gürültü engelleme ve mikrofon EQ ayarı ile stüdyo kalitesinde yayın."
    },
    {
      id: "sample_gen_3",
      serviceId: "gen_3",
      title: "3D Animasyonlu Logo & Yayın İntrosu",
      serviceName: "Özel Logo, Intro & Animasyon Tasarımı",
      platform: "Genel / Video",
      format: "Intro / Logo",
      tag: "Animasyon",
      youtubeId: "L_LUpnjgPso",
      coverImg: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=600&auto=format&fit=crop&q=80",
      desc: "Yayıncının ismine özel 3D animasyonlu logo ve yayın açılış klibi."
    }
  ]
};

export function EditorSupportPanel({ currentPublisher = {} }) {
  const [activePlatform, setActivePlatform] = useState("tiktok");
  const [requests, setRequests] = useState([]);
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(WCS_SERVICES_DATA.tiktok[0]);
  const [sampleRefTitle, setSampleRefTitle] = useState("");
  const [sourceLink, setSourceLink] = useState("");
  const [notes, setNotes] = useState("");
  const [phone, setPhone] = useState(currentPublisher?.phone || "");
  const [sourceType, setSourceType] = useState("link"); // 'link' | 'file'
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState("");
  const [sampleLink, setSampleLink] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState("");
  const [submitError, setSubmitError] = useState("");
  const [previewSample, setPreviewSample] = useState(null);
  const [selectedDetailRequest, setSelectedDetailRequest] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [actionMsg, setActionMsg] = useState("");
  const [showRevisionBox, setShowRevisionBox] = useState(false);
  const [revisionText, setRevisionText] = useState("");

  const currentServices = WCS_SERVICES_DATA[activePlatform] || WCS_SERVICES_DATA.tiktok;
  const currentSamples = WCS_SHOWCASE_DATA[activePlatform] || WCS_SHOWCASE_DATA.tiktok;

  async function handlePublisherAction(requestId, action, extra = {}) {
    if (!requestId) return;
    try {
      setActionLoading(true);
      setActionMsg("");
      const res = await fetch("/api/editor-publisher-action.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          requestId,
          action,
          revisionNote: extra.revisionNote || revisionText || ""
        })
      });
      const data = await res.json();
      if (data.success) {
        setActionMsg(data.message || "İşlem başarıyla gerçekleştirildi.");
        await fetchMyRequests();
        if (action === "request_revision") {
          setShowRevisionBox(false);
          setRevisionText("");
        }
        setTimeout(() => {
          if (selectedDetailRequest) {
            setRequests(prev => {
              const updated = prev.find(r => Number(r.id) === Number(requestId));
              if (updated) setSelectedDetailRequest(updated);
              return prev;
            });
          }
        }, 500);
      } else {
        alert(data.message || "İşlem başarısız.");
      }
    } catch (err) {
      alert("Bağlantı hatası: " + err.message);
    } finally {
      setActionLoading(false);
    }
  }

  const fetchMyRequests = useCallback(async () => {
    if (!currentPublisher?.username) return;
    try {
      setLoadingRequests(true);
      const res = await fetch(`${API_EDITOR_MY_REQUESTS}?username=${encodeURIComponent(currentPublisher.username)}&user_id=${encodeURIComponent(currentPublisher.id || "")}`, { cache: "no-store" });
      const data = await res.json();
      if (data.success && Array.isArray(data.requests)) {
        setRequests(data.requests);
      }
    } catch (err) {
      console.warn("Talepler çekilemedi:", err);
    } finally {
      setLoadingRequests(false);
    }
  }, [currentPublisher]);

  useEffect(() => {
    fetchMyRequests();
  }, [fetchMyRequests]);

  function handleOpenRequestModal(service = currentServices[0], sampleRef = "") {
    setSelectedService(service);
    setSampleRefTitle(sampleRef);
    setSourceType("link");
    setSourceLink("");
    setSelectedFile(null);
    setUploadProgress("");
    setSampleLink("");
    setNotes(sampleRef ? `"${sampleRef}" tarzında hazırlanmasını istiyorum. ` : "");
    setSubmitSuccess("");
    setSubmitError("");
    setShowModal(true);
  }

  async function handleSubmitRequest(e) {
    e.preventDefault();

    if (sourceType === "link" && !sourceLink.trim() && !notes.trim()) {
      setSubmitError("Lütfen ham video/dosya linkinizi giriniz veya özel talebinizi açıklayınız.");
      return;
    }

    if (sourceType === "file" && !selectedFile && !notes.trim()) {
      setSubmitError("Lütfen telefonunuzdan veya bilgisayarınızdan bir dosya seçiniz.");
      return;
    }

    try {
      setSubmitting(true);
      setSubmitError("");
      setSubmitSuccess("");

      let uploadedFileUrl = "";
      if (sourceType === "file" && selectedFile) {
        setUploadProgress("Dosya yükleniyor...");
        const formData = new FormData();
        formData.append("file", selectedFile);
        const upRes = await fetch("/api/editor-upload.php", {
          method: "POST",
          body: formData
        });
        const upData = await upRes.json();
        if (!upData.success) {
          throw new Error(upData.message || "Dosya yüklenemedi.");
        }
        uploadedFileUrl = upData.url;
        setUploadProgress("Dosya yüklendi!");
      }

      const payload = {
        userId: currentPublisher?.id || "",
        username: currentPublisher?.username || "Yayinci",
        fullName: currentPublisher?.fullName || currentPublisher?.username || "Yayıncı",
        phone: phone.trim(),
        serviceId: selectedService.id,
        serviceName: selectedService.title,
        sampleRef: sampleRefTitle,
        sourceLink: sourceType === "link" ? sourceLink.trim() : "",
        sourceFile: uploadedFileUrl,
        sampleLink: sampleLink.trim(),
        notes: notes.trim()
      };

      const res = await fetch(API_EDITOR_REQUEST_CREATE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (data.success) {
        setSubmitSuccess("🎉 Talebiniz Zakan Bilişim prodüksiyon ekibine başarıyla iletildi! İncelendikten sonra en uygun indirimli teklif ve detaylar iletilecektir.");
        fetchMyRequests();
        setTimeout(() => {
          setShowModal(false);
          setSubmitSuccess("");
        }, 3000);
      } else {
        setSubmitError(data.message || "Talep iletilemedi. Lütfen tekrar deneyin.");
      }
    } catch (err) {
      const isNetwork = err.message?.includes("Failed to fetch") || err.message?.includes("NetworkError") || err.message?.includes("Unexpected token");
      setSubmitError(isNetwork ? "Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edip tekrar deneyiniz." : ("İşlem hatası: " + err.message));
    } finally {
      setSubmitting(false);
      setUploadProgress("");
    }
  }

  return (
    <div className="space-y-10 pb-16">
      
      {/* 👑 1. HERO MANŞET & ZAKAN BİLİŞİM İŞ ORTAKLIĞI (DİKEY HİYERARŞİ: ÜSTTE BAŞLIK, ALTTAN BİLGİ KARTLARI) */}
      <div className="relative overflow-hidden rounded-[2.5rem] border border-amber-500/40 bg-black shadow-2xl min-h-[620px] sm:min-h-[680px] lg:min-h-[720px] flex flex-col justify-between">
        {/* Arka Plan Görseli */}
        <div className="absolute inset-0 z-0">
          <img
            src="/editor-studio-banner.jpg?v=20260921_dual"
            alt="Wolf Media x Zakan Bilişim Editör Desteği Stüdyosu"
            className="h-full w-full object-cover object-center brightness-[0.88] transition-transform duration-700"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/30 to-black/85" />
        </div>

        {/* 🎬 ÜST BÖLÜM: Monitörün üzerindeki boş alana yerleşen Başlık, Rozet ve Butonlar */}
        <div className="relative z-10 flex flex-col items-center pt-8 sm:pt-10 px-6 sm:px-10 text-center max-w-4xl mx-auto">
          
          {/* Üst İş Ortaklığı Rozeti */}
          <div className="inline-flex items-center gap-2 rounded-full border border-amber-500/50 bg-black/80 px-4 py-1.5 backdrop-blur-md shadow-lg mb-3">
            <span className="flex h-2 w-2 rounded-full bg-amber-400 animate-pulse" />
            <span className="text-[11px] sm:text-xs font-black tracking-wider uppercase text-amber-300">
              WOLF MEDIA × ZAKAN BİLİŞİM İŞ ORTAKLIĞI
            </span>
          </div>

          {/* Başlık & Açıklama */}
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-black text-white tracking-tight drop-shadow-[0_4px_16px_rgba(0,0,0,0.95)] max-w-3xl">
            İçerikleriniz İçin <span className="bg-gradient-to-r from-[#ffe494] via-[#f5be47] to-[#d49e3d] bg-clip-text text-transparent">Profesyonel Dokunuşlar</span>
          </h1>
          <p className="text-xs sm:text-sm sm:leading-relaxed text-zinc-200 font-medium drop-shadow-[0_2px_10px_rgba(0,0,0,0.95)] max-w-2xl mt-2.5">
            Video kurgu, ses miksajı, kapak tasarımı ve renk düzenlemeleriyle canlı yayın ve videolarınızı zirveye taşıyın.
          </p>

          {/* Aksiyon Butonları (Teklif Oluştur & WhatsApp) */}
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 pt-4">
            <button
              type="button"
              onClick={() => handleOpenRequestModal(currentServices[0])}
              className="group inline-flex items-center justify-center gap-3 rounded-full bg-gradient-to-r from-[#e5b558] via-[#d49e3d] to-[#be8322] px-8 sm:px-10 py-3.5 sm:py-4 text-sm sm:text-base font-black text-black shadow-[0_10px_35px_rgba(212,158,61,0.55)] hover:brightness-110 hover:shadow-[0_14px_40px_rgba(212,158,61,0.75)] active:scale-95 transition-all duration-300 cursor-pointer"
            >
              <span className="text-base sm:text-lg">📝</span>
              <span>Editör Desteği Talebi Oluştur</span>
              <span className="transition-transform duration-200 group-hover:translate-x-1 font-mono font-bold">›</span>
            </button>

            {/* WhatsApp Destek Hattı */}
            <a
              href="https://wa.me/905470353455?text=Merhaba,%20Wolf%20Media%20x%20Zakan%20Bilişim%20editör%20desteği%20hakkında%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-black/80 backdrop-blur-md px-5 sm:px-6 py-3.5 text-xs sm:text-sm font-bold text-white hover:border-emerald-500/60 hover:text-emerald-300 transition-all shadow-xl group cursor-pointer"
            >
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#25D366] text-[11px] text-white shadow-sm">
                💬
              </span>
              <span className="tracking-wide font-mono">0547 035 34 55</span>
              <span className="text-zinc-400 text-[11px] hidden sm:inline group-hover:text-zinc-300">• WhatsApp Destek</span>
            </a>
          </div>

        </div>

        {/* 🖥️ ORTA BOŞ ALAN (Monitörlerin ve Kurgu Ekranının Tam Görünmesi İçin Açık Bırakıldı) */}
        <div className="flex-1 min-h-[160px] sm:min-h-[220px] pointer-events-none" />

        {/* 📑 ALT BÖLÜM: En Alttaki İki Bilgilendirme Kutusu */}
        <div className="relative z-10 w-full max-w-4xl mx-auto p-4 sm:p-6 pb-6 sm:pb-8">
          <div className="rounded-2xl border border-white/15 bg-black/85 backdrop-blur-xl p-4 sm:p-5 shadow-[0_15px_35px_rgba(0,0,0,0.8)]">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 divide-y sm:divide-y-0 sm:divide-x divide-white/10">
              
              {/* Sol Özellik: İndirimler */}
              <div className="flex items-center gap-3.5 sm:pr-4 pt-1 sm:pt-0 text-left">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-amber-500/40 bg-amber-500/15 text-lg text-amber-300">
                  🏷️
                </div>
                <div>
                  <div className="text-xs sm:text-sm font-black text-white">
                    Yayıncılara özel indirimler
                  </div>
                  <div className="text-[11px] text-zinc-300 leading-tight mt-0.5">
                    Düzenli iş birliklerinde sana özel avantajlar sunuyoruz.
                  </div>
                </div>
              </div>

              {/* Sağ Özellik: Fiyatlandırma */}
              <div className="flex items-center gap-3.5 sm:pl-6 pt-3 sm:pt-0 text-left">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-amber-500/40 bg-amber-500/15 text-lg text-amber-300">
                  📄
                </div>
                <div>
                  <div className="text-xs sm:text-sm font-black text-white">
                    Fiyat, talebin kapsamına göre belirlenir.
                  </div>
                  <div className="text-[11px] text-zinc-300 leading-tight mt-0.5">
                    İhtiyacını bizimle paylaş, sana özel teklifimizi iletelim.
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

      {/* 🌟 2. DÖRT ANA PLATFORM SEÇİCİ KUTUCUKLARI (GÖRSELDEKİ ALAN) */}
      <div className="space-y-4">
        <div className="text-xs font-black uppercase tracking-[0.25em] text-amber-500">PLATFORM VE KAPSAM SEÇİNİZ</div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3.5 sm:gap-4">
          {WCS_PLATFORMS.map((plat) => {
            const isActive = activePlatform === plat.id;
            return (
              <button
                key={plat.id}
                type="button"
                onClick={() => setActivePlatform(plat.id)}
                className={`flex flex-col items-start p-4 sm:p-5 rounded-2xl border text-left transition-all duration-300 shadow-sm ${
                  isActive
                    ? "border-yellow-400 bg-gradient-to-br from-yellow-500/20 via-amber-500/10 to-[#18181c] shadow-[0_8px_25px_rgba(234,179,8,0.2)] scale-[1.02]"
                    : "border-white/10 bg-[#121216] hover:border-amber-500/40 hover:bg-white/[0.03]"
                }`}
              >
                <div className="flex items-center justify-between w-full">
                  {plat.id === "tiktok" ? (
                    <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-black border border-white/20 p-2 shadow-md">
                      <svg className="h-6 w-6" viewBox="0 0 24 24">
                        <path fill="#25F4EE" d="M12.5 7.2v7.1c0 1.9-1.5 3.4-3.4 3.4-1.9 0-3.4-1.5-3.4-3.4 0-1.9 1.5-3.4 3.4-3.4.3 0 .6 0 .9.1V8c-.3 0-.6-.1-.9-.1-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4 6.4-2.9 6.4-6.4V9.8c1.3.9 2.8 1.5 4.5 1.5V8.3c-2.8 0-4.9-1.8-4.9-4.3h-2.6v3.2z"/>
                        <path fill="#FE2C55" d="M13.5 6.2v7.1c0 1.9-1.5 3.4-3.4 3.4-1.9 0-3.4-1.5-3.4-3.4 0-1.9 1.5-3.4 3.4-3.4.3 0 .6 0 .9.1V7c-.3 0-.6-.1-.9-.1-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4 6.4-2.9 6.4-6.4V8.8c1.3.9 2.8 1.5 4.5 1.5V7.3c-2.8 0-4.9-1.8-4.9-4.3h-2.6v3.2z"/>
                        <path fill="#FFFFFF" d="M13 6.7v7.1c0 1.9-1.5 3.4-3.4 3.4-1.9 0-3.4-1.5-3.4-3.4 0-1.9 1.5-3.4 3.4-3.4.3 0 .6 0 .9.1V7.5c-.3 0-.6-.1-.9-.1-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4 6.4-2.9 6.4-6.4V9.3c1.3.9 2.8 1.5 4.5 1.5V7.8c-2.8 0-4.9-1.8-4.9-4.3h-2.6v3.2z"/>
                      </svg>
                    </div>
                  ) : plat.id === "youtube" ? (
                    <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#FF0000] p-2 shadow-md">
                      <svg className="h-6 w-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                      </svg>
                    </div>
                  ) : plat.id === "instagram" ? (
                    <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888] p-2 shadow-md">
                      <svg className="h-6 w-6 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                        <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
                      </svg>
                    </div>
                  ) : (
                    <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-yellow-400 via-amber-500 to-yellow-500 p-2 text-black shadow-md">
                      <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                      </svg>
                    </div>
                  )}

                  {isActive && (
                    <span className="rounded-full bg-yellow-400 text-black px-2.5 py-0.5 text-[10px] font-black uppercase shadow-xs">
                      Aktif
                    </span>
                  )}
                </div>

                <div className={`mt-3 text-base sm:text-lg font-black ${isActive ? "text-yellow-400" : "text-white"}`}>
                  {plat.label}
                </div>

                <div className="mt-1 text-xs text-white/55 line-clamp-2">
                  {plat.desc}
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* 🎨 3. SEÇİLİ PLATFORMA ÖZEL HİZMET PAKETLERİ */}
      <div>
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
          <div>
            <div className="text-xs font-black uppercase tracking-[0.25em] text-amber-500">
              {WCS_PLATFORMS.find(p => p.id === activePlatform)?.label} HİZMETLERİ
            </div>
            <h2 className="mt-1 text-2xl sm:text-3xl font-black text-white">Yayıncılara Özel Prodüksiyon Paketleri</h2>
          </div>
          <div className="text-xs font-medium text-white/50">İhtiyacınıza uygun paketi seçip talep oluşturabilirsiniz.</div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {currentServices.map((pkg) => (
            <div
              key={pkg.id}
              className="group relative flex flex-col justify-between rounded-3xl border border-white/10 bg-[#121216] p-6 shadow-lg transition-all duration-300 hover:-translate-y-1 hover:border-amber-500/50 hover:shadow-[0_12px_30px_rgba(234,179,8,0.15)]"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className="text-3xl">{pkg.icon}</span>
                  <span className="rounded-full border border-amber-500/30 bg-amber-500/10 px-3 py-1 text-[10px] font-black text-amber-300">
                    {pkg.badge}
                  </span>
                </div>

                <h3 className="mt-4 text-lg font-black text-white group-hover:text-yellow-300 transition">
                  {pkg.title}
                </h3>

                <div className="mt-1 text-[11px] font-bold text-amber-500">{pkg.category}</div>

                <p className="mt-3 text-xs leading-relaxed text-white/60">
                  {pkg.desc}
                </p>

                <div className="mt-5 space-y-2 border-t border-white/5 pt-4">
                  {pkg.features.map((feat, i) => (
                    <div key={i} className="flex items-center gap-2 text-xs text-white/80">
                      <span className="text-emerald-400 font-bold">✓</span>
                      <span>{feat}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-6 border-t border-white/10 pt-4">
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-xs font-black text-amber-400">{pkg.pricingNote}</span>
                    <div className="text-[10px] text-white/45">Talep incelemesiyle belirlenir</div>
                  </div>
                  <span className="text-[11px] font-bold text-white/50">⏱️ {pkg.delivery}</span>
                </div>

                <button
                  type="button"
                  onClick={() => handleOpenRequestModal(pkg)}
                  className="mt-4 flex w-full items-center justify-center gap-1.5 rounded-xl bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-500 py-2.5 text-xs font-black text-black shadow-md hover:brightness-110 transition active:scale-95"
                >
                  <span>✨ İndirimli Talep Aç</span>
                  <span>▸</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 📱 4. SEÇİLİ PLATFORMA ÖZEL 3 SEÇKİN ÖRNEK + REZERVASYON KARTI */}
      <div id="ornek-calismalar">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
          <div>
            <div className="text-xs font-black uppercase tracking-[0.25em] text-amber-500">SHOWCASE & İLHAM GALERİSİ</div>
            <h2 className="mt-1 text-2xl sm:text-3xl font-black text-white">
              {WCS_PLATFORMS.find(p => p.id === activePlatform)?.label} Örnek Çalışmaları
            </h2>
          </div>
          <div className="text-xs font-medium text-white/50">Beğendiğiniz örneği seçerek aynı tarzda tek tıkla talep açabilirsiniz.</div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {/* 3 SEÇKİN ÖRNEK */}
          {currentSamples.map((sample) => (
            <div
              key={sample.id}
              className="group flex flex-col justify-between overflow-hidden rounded-3xl border border-white/10 bg-[#121216] shadow-md transition-all duration-300 hover:border-amber-500/50 hover:shadow-xl"
            >
              <div className="relative aspect-[9/12] w-full overflow-hidden bg-slate-900">
                <img
                  src={sample.coverImg}
                  alt={sample.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />

                <div className="absolute top-3 left-3">
                  <span className="rounded-full bg-black/70 px-2.5 py-1 text-[10px] font-black text-yellow-400 backdrop-blur-md">
                    {sample.tag}
                  </span>
                </div>

                <div className="absolute top-3 right-3">
                  <span className="rounded-full bg-black/70 px-2 py-0.5 text-[9px] font-bold text-white/80 backdrop-blur-md">
                    {sample.format}
                  </span>
                </div>

                <button
                  type="button"
                  onClick={() => setPreviewSample(sample)}
                  className="absolute inset-0 m-auto flex h-14 w-14 items-center justify-center rounded-full bg-yellow-500/90 text-black shadow-2xl transition-transform hover:scale-110 active:scale-95"
                  title="Önizlemeyi Başlat"
                >
                  <span className="text-2xl ml-1">▶</span>
                </button>
              </div>

              <div className="p-4 flex flex-col justify-between flex-1">
                <div>
                  <h4 className="text-sm font-black text-white line-clamp-2">{sample.title}</h4>
                  <p className="mt-1.5 text-xs text-white/60 line-clamp-2">{sample.desc}</p>
                </div>

                <div className="mt-4 pt-3 border-t border-white/5">
                  <button
                    type="button"
                    onClick={() => {
                      const matchedPkg = currentServices.find(p => p.id === sample.serviceId) || currentServices[0];
                      handleOpenRequestModal(matchedPkg, sample.title);
                    }}
                    className="flex w-full items-center justify-center gap-1.5 rounded-xl border border-amber-500/40 bg-amber-500/10 py-2 text-xs font-black text-amber-300 hover:bg-amber-500 hover:text-black transition active:scale-95"
                  >
                    <span>✨ Bu Tarzda İstiyorum</span>
                    <span>▸</span>
                  </button>
                </div>
              </div>
            </div>
          ))}

          {/* 🎯 4. KART: ÖZEL REZERVASYON & PROJE DANIŞMANLIĞI KARTI */}
          <div className="flex flex-col justify-between rounded-3xl border border-dashed border-amber-500/40 bg-gradient-to-br from-[#15151c] to-black p-6 text-center shadow-lg">
            <div>
              <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-amber-500/30 bg-amber-500/10 text-3xl">
                ⚡
              </div>
              <h4 className="mt-4 text-base font-black text-white">Özel Proje & Rezervasyon</h4>
              <p className="mt-2 text-xs text-white/60 leading-relaxed">
                Standart paketlerin dışında özel bir kampanya, kanal yönetimi veya düzenli editörlük için rezervasyon oluşturun.
              </p>
            </div>

            <div className="mt-6">
              <button
                type="button"
                onClick={() => handleOpenRequestModal(currentServices[0], "Özel Proje & Rezervasyon")}
                className="flex w-full items-center justify-center gap-1.5 rounded-xl bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-500 py-3 text-xs font-black text-black shadow-md hover:brightness-110 transition active:scale-95"
              >
                <span>📅 Rezervasyon Talebi Aç</span>
                <span>▸</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 🔔 4.5. BİLDİRİM VE ONAY UYARI BANNERLARI */}
      {(() => {
        const pendingPrice = requests.filter(r => r.status === "waiting_price_approval" || (r.final_price && r.status === "reviewing"));
        const readyDeliveries = requests.filter(r => r.status === "delivered" || r.status === "Tamamlandı" || (r.delivery_link && r.delivery_link.trim() !== ""));

        return (
          <div className="space-y-3">
            {pendingPrice.length > 0 && (
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 rounded-2xl border border-amber-500/50 bg-gradient-to-r from-amber-500/20 via-yellow-500/10 to-transparent p-4 sm:p-5 shadow-lg">
                <div className="flex items-center gap-3.5">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-amber-500 text-xl text-black font-black shadow-md">
                    🔔
                  </div>
                  <div>
                    <div className="text-sm sm:text-base font-black text-amber-200">
                      {pendingPrice.length} Adet Talebiniz İçin Fiyat Teklifi Belirlendi!
                    </div>
                    <div className="text-xs text-white/70 mt-0.5">
                      Editörümüz talebinizi inceledi ve fiyat teklifi sundu. Kurgunun başlaması için lütfen teklifi onaylayınız.
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setSelectedDetailRequest(pendingPrice[0])}
                  className="rounded-xl bg-gradient-to-r from-amber-400 to-yellow-500 px-5 py-2.5 text-xs font-black text-black shadow-md hover:brightness-110 transition whitespace-nowrap"
                >
                  📋 Teklifi İncele & Onayla
                </button>
              </div>
            )}

            {readyDeliveries.length > 0 && (
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 rounded-2xl border border-emerald-500/40 bg-gradient-to-r from-emerald-500/15 via-teal-500/10 to-transparent p-4 sm:p-5 shadow-lg">
                <div className="flex items-center gap-3.5">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-emerald-500 text-xl text-black font-black shadow-md">
                    🎉
                  </div>
                  <div>
                    <div className="text-sm sm:text-base font-black text-emerald-300">
                      Kurgunuz Hazır ve Teslim Edildi!
                    </div>
                    <div className="text-xs text-white/70 mt-0.5">
                      Videonuz tamamlandı. Aşağıdaki tablodan veya detay penceresinden kurgunuzu hemen indirebilirsiniz.
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setSelectedDetailRequest(readyDeliveries[0])}
                  className="rounded-xl bg-gradient-to-r from-emerald-400 to-teal-400 px-5 py-2.5 text-xs font-black text-black shadow-md hover:brightness-110 transition whitespace-nowrap"
                >
                  📥 Kurguyu Görüntüle & İndir
                </button>
              </div>
            )}
          </div>
        );
      })()}

      {/* 📊 5. YAYINCININ GEÇMİŞ VE AKTİF TALEPLERİ TABLOSU */}
      <div className="rounded-3xl border border-white/10 bg-[#121216] p-6 sm:p-8 shadow-md">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pb-4 border-b border-white/10">
          <div>
            <div className="text-xs font-black uppercase tracking-[0.25em] text-amber-500">TALEPLERİM & SİPARİŞLERİM</div>
            <h3 className="mt-1 text-xl font-black text-white">Editör & Teknoloji Destek Durumu</h3>
            <p className="mt-1 text-xs text-zinc-400">Detayları görmek, teklif onaylamak veya teslim edilen videoyu indirmek için talebe tıklayabilirsiniz.</p>
          </div>
          <button
            type="button"
            onClick={fetchMyRequests}
            className="self-start sm:self-auto rounded-xl border border-white/10 bg-white/[0.04] px-4 py-2.5 text-xs font-bold text-white hover:border-amber-500 transition flex items-center gap-2"
          >
            <span>{loadingRequests ? "🔄 Yenileniyor..." : "🔄 Listeyi Yenile"}</span>
          </button>
        </div>

        <div className="mt-4 overflow-x-auto">
          {loadingRequests && requests.length === 0 ? (
            <div className="py-12 text-center text-sm text-white/40">Talepler yükleniyor...</div>
          ) : requests.length === 0 ? (
            <div className="py-12 text-center text-sm text-white/50">
              Henüz aktif bir talebiniz bulunmuyor. İhtiyacınız olan hizmeti yukarıdan seçerek hemen indirimli talep oluşturabilirsiniz!
            </div>
          ) : (
            <table className="w-full text-left text-xs">
              <thead>
                <tr className="border-b border-white/10 text-white/40 font-bold uppercase tracking-wider">
                  <th className="py-3 px-3">Talep No</th>
                  <th className="py-3 px-3">Hizmet Türü</th>
                  <th className="py-3 px-3">Ücret / Teklif</th>
                  <th className="py-3 px-3">Tarih</th>
                  <th className="py-3 px-3">Durum</th>
                  <th className="py-3 px-3 text-right">İşlem & Detay</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5">
                {requests.map((req) => {
                  const isPendingPrice = req.status === "waiting_price_approval" || (req.final_price && req.status === "reviewing");
                  const isDelivered = req.status === "delivered" || req.status === "Tamamlandı" || (req.delivery_link && req.delivery_link.trim() !== "");
                  const priceText = req.final_price || req.price || "Wolf İndirimli";

                  return (
                    <tr
                      key={req.id}
                      onClick={() => setSelectedDetailRequest(req)}
                      className="hover:bg-amber-500/[0.06] cursor-pointer transition group"
                    >
                      <td className="py-4 px-3 font-bold text-white/90">
                        <span className="font-mono text-amber-300">#{req.id}</span>
                      </td>
                      <td className="py-4 px-3">
                        <div className="font-black text-white text-sm group-hover:text-amber-300 transition">
                          {req.service_name || "Özel Edit Talebi"}
                        </div>
                        <div className="text-[11px] text-white/50 truncate max-w-xs mt-0.5">
                          {req.sample_ref || req.notes || "Özel Talep"}
                        </div>
                      </td>
                      <td className="py-4 px-3">
                        {isPendingPrice ? (
                          <span className="inline-flex items-center gap-1 rounded-lg border border-amber-500/50 bg-amber-500/20 px-2.5 py-1 text-xs font-black text-amber-200 animate-pulse">
                            💰 {priceText.includes("₺") ? priceText : `₺${priceText}`} (Onay Bekliyor)
                          </span>
                        ) : (
                          <span className="font-bold text-zinc-300">
                            {priceText.includes("₺") || /^[0-9]+$/.test(priceText) ? (priceText.includes("₺") ? priceText : `₺${priceText}`) : priceText}
                          </span>
                        )}
                      </td>
                      <td className="py-4 px-3 text-white/50">
                        {req.created_at ? req.created_at.slice(0, 10) : "-"}
                      </td>
                      <td className="py-4 px-3">
                        <span
                          className={`rounded-full px-3 py-1 text-[11px] font-black inline-flex items-center gap-1.5 ${
                            isDelivered
                              ? "border border-emerald-500/40 bg-emerald-500/15 text-emerald-300"
                              : req.status === "in_progress" || req.status === "Kurguda"
                              ? "border border-fuchsia-500/40 bg-fuchsia-500/15 text-fuchsia-300"
                              : req.status === "waiting_revision" || req.status === "Revizede"
                              ? "border border-yellow-500/40 bg-yellow-500/15 text-yellow-300"
                              : isPendingPrice
                              ? "border border-orange-500/40 bg-orange-500/20 text-orange-300"
                              : "border border-blue-500/40 bg-blue-500/15 text-blue-300"
                          }`}
                        >
                          {isDelivered
                            ? "✅ Teslim Edildi"
                            : req.status === "in_progress" || req.status === "Kurguda"
                            ? "🎬 Kurguda"
                            : req.status === "waiting_revision" || req.status === "Revizede"
                            ? "🔄 Revizede"
                            : isPendingPrice
                            ? "🟡 Fiyat Onayı Bekliyor"
                            : "⏳ İnceleniyor"}
                        </span>
                      </td>
                      <td className="py-4 px-3 text-right">
                        <div className="flex items-center justify-end gap-2" onClick={(e) => e.stopPropagation()}>
                          <button
                            type="button"
                            onClick={() => setSelectedDetailRequest(req)}
                            className="rounded-xl border border-amber-500/30 bg-amber-500/10 px-3.5 py-1.5 text-xs font-bold text-amber-300 hover:bg-amber-500 hover:text-black transition"
                          >
                            📋 İncele & Onayla
                          </button>
                          {req.delivery_link && (
                            <a
                              href={req.delivery_link}
                              target="_blank"
                              rel="noreferrer"
                              className="inline-flex items-center gap-1 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-500 px-3.5 py-1.5 text-xs font-black text-black shadow-md hover:brightness-110"
                            >
                              <span>📥 İndir</span>
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* 📋 5.5. YAYINCI TALEP DETAY, ONAY VE TESLİMAT MODALI */}
      {selectedDetailRequest && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-3 sm:p-6 backdrop-blur-md">
          <div className="w-full max-w-2xl max-h-[92vh] overflow-y-auto rounded-[2rem] border border-amber-500/40 bg-[#111116] p-6 sm:p-8 text-white shadow-[0_20px_60px_rgba(0,0,0,0.9)] custom-scrollbar">
            
            {/* Header */}
            <div className="flex items-center justify-between border-b border-white/10 pb-4">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-amber-500/20 border border-amber-500/40 text-amber-300 text-lg font-black font-mono">
                  #{selectedDetailRequest.id}
                </div>
                <div>
                  <div className="text-[10px] font-black uppercase tracking-widest text-amber-400">Wolf Media x Zakan Bilişim</div>
                  <h3 className="text-xl font-black text-white">{selectedDetailRequest.service_name || "Özel Edit Talebi"}</h3>
                </div>
              </div>
              <button
                type="button"
                onClick={() => {
                  setSelectedDetailRequest(null);
                  setActionMsg("");
                  setShowRevisionBox(false);
                }}
                className="rounded-xl border border-white/10 bg-white/[0.04] p-2 text-white/60 hover:text-white transition"
              >
                ✕
              </button>
            </div>

            {actionMsg && (
              <div className="my-4 rounded-xl border border-emerald-500/40 bg-emerald-500/20 p-3.5 text-xs font-bold text-emerald-200">
                {actionMsg}
              </div>
            )}

            <div className="mt-5 space-y-4 text-xs">
              {/* 💰 FİYAT TEKLİFİ VE ONAY ALANI */}
              {selectedDetailRequest.status === "waiting_price_approval" || (selectedDetailRequest.final_price && selectedDetailRequest.status === "reviewing") ? (
                <div className="rounded-2xl border border-amber-500/50 bg-gradient-to-br from-amber-500/20 to-black/60 p-5 shadow-lg">
                  <div className="text-[11px] font-black uppercase tracking-wider text-amber-300">💰 Fiyat Teklifi ve Başlatma Onayı</div>
                  <div className="mt-2 flex items-baseline gap-2">
                    <span className="text-3xl font-black text-white">
                      {selectedDetailRequest.final_price ? (selectedDetailRequest.final_price.includes("₺") ? selectedDetailRequest.final_price : `₺${selectedDetailRequest.final_price}`) : selectedDetailRequest.price || "₺750"}
                    </span>
                    <span className="text-xs font-bold text-amber-400/80">Wolf Yayıncı İndirimi Dahil</span>
                  </div>
                  <p className="mt-2 text-white/70 leading-relaxed">
                    Editörümüz talebinizi inceledi ve yukarıdaki indirimli fiyat teklifini sundu. Onay verdiğiniz anda kurgu süreci hemen başlatılacaktır.
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2.5">
                    <button
                      type="button"
                      disabled={actionLoading}
                      onClick={() => handlePublisherAction(selectedDetailRequest.id, "approve_price")}
                      className="rounded-xl bg-gradient-to-r from-emerald-400 to-teal-400 px-6 py-3 text-xs font-black uppercase tracking-wider text-black shadow-md hover:brightness-110 transition disabled:opacity-50"
                    >
                      {actionLoading ? "İşleniyor..." : "✅ Fiyat Teklifini Onayla (Kurguyu Başlat)"}
                    </button>
                    <button
                      type="button"
                      disabled={actionLoading}
                      onClick={() => handlePublisherAction(selectedDetailRequest.id, "reject_price")}
                      className="rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-xs font-bold text-red-300 hover:bg-red-500/20 transition disabled:opacity-50"
                    >
                      ❌ Teklifi Reddet
                    </button>
                  </div>
                </div>
              ) : null}

              {/* 💬 EDİTÖRÜN YAYINCIYA NOTU */}
              {(selectedDetailRequest.editor_note || selectedDetailRequest.admin_note) && (
                <div className="rounded-2xl border border-amber-500/30 bg-amber-500/10 p-4">
                  <div className="text-[11px] font-black uppercase tracking-wider text-amber-300 mb-1">💬 Editörün Size İlettiği Not:</div>
                  <div className="text-sm font-medium text-white leading-relaxed whitespace-pre-wrap">
                    {selectedDetailRequest.editor_note || selectedDetailRequest.admin_note}
                  </div>
                </div>
              )}

              {/* 📥 TESLİMAT VE REVİZE ALANI (EĞER TESLİM EDİLDİYSE) */}
              {(selectedDetailRequest.delivery_link || selectedDetailRequest.status === "delivered" || selectedDetailRequest.status === "Tamamlandı") && (
                <div className="rounded-2xl border border-emerald-500/40 bg-gradient-to-br from-emerald-500/15 to-black/60 p-5 shadow-lg space-y-3">
                  <div className="flex items-center justify-between">
                    <div className="text-xs font-black uppercase tracking-wider text-emerald-300">🎬 Kurgu Teslimatı Hazır</div>
                    <span className="rounded-full bg-emerald-500/20 border border-emerald-500/40 px-2.5 py-0.5 text-[10px] font-black text-emerald-200">Tamamlandı</span>
                  </div>

                  {selectedDetailRequest.delivery_link && (
                    <div className="pt-2">
                      <a
                        href={selectedDetailRequest.delivery_link}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center justify-center gap-2 w-full rounded-xl bg-gradient-to-r from-emerald-500 to-teal-500 p-3.5 text-xs font-black text-black shadow-lg hover:brightness-110 transition"
                      >
                        <span>📥 Kurguyu İndir / Bağlantıyı Aç</span>
                      </a>
                    </div>
                  )}

                  {/* 🔄 REVİZE TALEBİ ALANI */}
                  <div className="pt-2 border-t border-white/10">
                    {!showRevisionBox ? (
                      <button
                        type="button"
                        onClick={() => setShowRevisionBox(true)}
                        className="text-xs text-amber-300 hover:text-amber-200 font-bold underline cursor-pointer"
                      >
                        🔄 Videoda revize edilmesini istediğim yerler var (1 Revize Hakkı)
                      </button>
                    ) : (
                      <div className="space-y-2 mt-2 bg-black/40 p-3.5 rounded-xl border border-white/10">
                        <label className="font-bold text-amber-300 text-xs">Revize Notunuzu Yazınız:</label>
                        <textarea
                          value={revisionText}
                          onChange={(e) => setRevisionText(e.target.value)}
                          placeholder="Örn: 0:15 saniyedeki altyazı rengini sarı yapabilir miyiz? Giriş müziğini biraz daha hızlandıralım..."
                          className="w-full rounded-xl border border-white/15 bg-black/60 p-3 text-xs text-white outline-none focus:border-amber-400 min-h-20"
                        />
                        <div className="flex gap-2 justify-end">
                          <button
                            type="button"
                            onClick={() => setShowRevisionBox(false)}
                            className="rounded-lg border border-white/10 px-3 py-1.5 text-xs text-white/60 hover:text-white"
                          >
                            Vazgeç
                          </button>
                          <button
                            type="button"
                            disabled={actionLoading || !revisionText.trim()}
                            onClick={() => handlePublisherAction(selectedDetailRequest.id, "request_revision", { revisionNote: revisionText })}
                            className="rounded-lg bg-amber-500 px-4 py-1.5 text-xs font-bold text-black hover:bg-amber-400 disabled:opacity-50"
                          >
                            {actionLoading ? "Gönderiliyor..." : "Revizeyi Editöre İlet"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* 📋 TALEP ÖZETİ */}
              <div className="rounded-2xl border border-white/10 bg-black/40 p-4 space-y-2.5">
                <div className="text-[11px] font-black uppercase tracking-wider text-amber-400 mb-2">Talep Özeti ve Notlarınız</div>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  <div><span className="text-white/40">Tarih:</span> <span className="text-white font-bold">{selectedDetailRequest.created_at || "-"}</span></div>
                  <div><span className="text-white/40">Durum:</span> <span className="text-amber-300 font-bold">{selectedDetailRequest.status || "İnceleniyor"}</span></div>
                </div>
                {selectedDetailRequest.notes && (
                  <div className="pt-2 border-t border-white/5">
                    <span className="text-white/40 block mb-1">Açıklamanız:</span>
                    <div className="text-zinc-300 whitespace-pre-wrap leading-relaxed bg-black/30 p-2.5 rounded-lg border border-white/5">
                      {selectedDetailRequest.notes}
                    </div>
                  </div>
                )}
                {selectedDetailRequest.source_link && (
                  <div className="pt-2">
                    <span className="text-white/40 block mb-1">Paylaştığınız Kaynak Link:</span>
                    <a href={selectedDetailRequest.source_link} target="_blank" rel="noreferrer" className="text-amber-300 hover:underline break-all font-mono">
                      {selectedDetailRequest.source_link}
                    </a>
                  </div>
                )}
                {selectedDetailRequest.source_file && (
                  <div className="pt-2">
                    <span className="text-white/40 block mb-1">Yüklediğiniz Dosya:</span>
                    <a href={selectedDetailRequest.source_file} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-emerald-400 hover:underline font-bold">
                      📁 Dosyayı Görüntüle / İndir
                    </a>
                  </div>
                )}
              </div>

              {/* 💬 WHATSAPP DESTEK HESABI */}
              <div className="pt-2">
                <a
                  href={`https://wa.me/905470353455?text=${encodeURIComponent("Merhaba Zakan Bilişim, #" + selectedDetailRequest.id + " numaralı editör talebim hakkında bilgi almak istiyorum.")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full rounded-xl border border-emerald-500/40 bg-emerald-500/10 p-3 text-xs font-bold text-emerald-300 hover:bg-emerald-500/20 transition"
                >
                  💬 Zakan Bilişim WhatsApp Masasına Yaz (0547 035 34 55)
                </a>
              </div>
            </div>

          </div>
        </div>
      )}


      {/* 📝 6. YENİ TALEP OLUŞTURMA MODALI (GELİŞMİŞ, BÜYÜK & DOSYA YÜKLEMELİ) */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-3 sm:p-6 backdrop-blur-md">
          <div className="w-full max-w-2xl sm:max-w-3xl max-h-[92vh] overflow-y-auto rounded-[2rem] border border-amber-500/40 bg-[#111116] p-6 sm:p-9 text-white shadow-[0_20px_60px_rgba(0,0,0,0.9)] custom-scrollbar">
            
            {/* BAŞLIK ALANI (TEMİZLENMİŞ & ZAKAN LOGOLU) */}
            <div className="flex items-center justify-between border-b border-white/10 pb-5">
              <div className="flex items-center gap-3.5">
                <img src="/zakan-logo.png" alt="Zakan" className="h-8 w-8 object-contain rounded-md" onError={(e) => e.target.style.display = 'none'} />
                <div>
                  <div className="text-xs font-black uppercase tracking-widest text-amber-400">ZAKAN BİLİŞİM PRODÜKSİYON & DESTEK</div>
                  <h3 className="text-2xl font-black text-white">Edit & Teknoloji Talebi Aç</h3>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="rounded-xl border border-white/10 bg-white/[0.04] p-2 text-white/60 hover:text-white transition"
              >
                ✕
              </button>
            </div>

            {submitSuccess ? (
              <div className="my-8 rounded-2xl border border-emerald-500/40 bg-emerald-500/15 p-8 text-center text-emerald-300 font-bold text-base">
                {submitSuccess}
              </div>
            ) : (
              <form onSubmit={handleSubmitRequest} className="mt-6 space-y-5 text-sm">
                {submitError && (
                  <div className="rounded-xl border border-red-500/40 bg-red-500/15 p-3.5 text-red-300 font-bold">
                    {submitError}
                  </div>
                )}

                {/* 1. HİZMET TÜRÜ SEÇİMİ */}
                <div>
                  <label className="font-bold text-white/80">Hizmet Türü</label>
                  <select
                    value={selectedService.id}
                    onChange={(e) => {
                      const allServices = Object.values(WCS_SERVICES_DATA).flat();
                      const found = allServices.find(p => p.id === e.target.value);
                      if (found) setSelectedService(found);
                    }}
                    className="mt-2 w-full rounded-2xl border border-white/15 bg-black/60 p-3.5 text-sm font-bold text-white outline-none focus:border-amber-400"
                  >
                    {Object.entries(WCS_SERVICES_DATA).map(([catKey, list]) => (
                      <optgroup key={catKey} label={WCS_PLATFORMS.find(p => p.id === catKey)?.label || catKey}>
                        {list.map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.icon} {p.title} ({p.delivery})
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </select>
                </div>

                {/* 2. REFERANS ÖRNEK SEÇİLDİYSE GÖSTER */}
                {sampleRefTitle && (
                  <div className="rounded-2xl border border-amber-500/30 bg-amber-500/10 p-3.5 flex items-center justify-between">
                    <div>
                      <div className="text-xs text-amber-400 font-bold">Seçilen Referans Örnek:</div>
                      <div className="text-sm font-black text-white">{sampleRefTitle}</div>
                    </div>
                    <button
                      type="button"
                      onClick={() => setSampleRefTitle("")}
                      className="text-xs font-bold text-white/60 hover:text-white"
                    >
                      Kaldır
                    </button>
                  </div>
                )}

                {/* 3. İÇERİK / HAM DOSYA EKLEME (İKİ YÖNTEM: LİNK VEYA TELEFONDAN DOSYA YÜKLEME) */}
                <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-4">
                  <div className="flex items-center justify-between mb-3">
                    <label className="font-bold text-white">İçerik / Ham Dosya Ekleme Yöntemi</label>
                    <div className="flex gap-1.5">
                      <button
                        type="button"
                        onClick={() => setSourceType("link")}
                        className={`rounded-xl px-3 py-1 text-xs font-bold transition ${
                          sourceType === "link"
                            ? "bg-yellow-500 text-black font-black"
                            : "bg-white/[0.05] text-white/70 hover:text-white"
                        }`}
                      >
                        🔗 Link Paylaş
                      </button>
                      <button
                        type="button"
                        onClick={() => setSourceType("file")}
                        className={`rounded-xl px-3 py-1 text-xs font-bold transition ${
                          sourceType === "file"
                            ? "bg-yellow-500 text-black font-black"
                            : "bg-white/[0.05] text-white/70 hover:text-white"
                        }`}
                      >
                        📁 Telefondan / Bilgisayardan Yükle
                      </button>
                    </div>
                  </div>

                  {sourceType === "link" ? (
                    <div>
                      <input
                        type="url"
                        value={sourceLink}
                        onChange={(e) => setSourceLink(e.target.value)}
                        placeholder="https://drive.google.com/... veya WeTransfer / TikTok linki"
                        className="w-full rounded-xl border border-white/15 bg-black/60 p-3 text-sm text-white outline-none focus:border-amber-400"
                      />
                      <span className="text-xs text-white/45 mt-1.5 block">
                        Videonuzun veya fotoğraflarınızın bulunduğu linki erişime açık şekilde yapıştırabilirsiniz.
                      </span>
                    </div>
                  ) : (
                    <div>
                      <label className="flex flex-col items-center justify-center w-full p-5 border-2 border-dashed border-amber-500/30 rounded-xl cursor-pointer bg-black/50 hover:bg-black/70 transition">
                        <span className="text-3xl mb-1">📤</span>
                        <span className="text-sm font-bold text-white">
                          {selectedFile ? selectedFile.name : "Telefondan veya Bilgisayardan Video / Görsel Seçin"}
                        </span>
                        <span className="text-xs text-white/45 mt-1">MP4, MOV, JPG, PNG, ZIP vb.</span>
                        <input
                          type="file"
                          className="hidden"
                          onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                              setSelectedFile(e.target.files[0]);
                            }
                          }}
                        />
                      </label>
                      {uploadProgress && (
                        <div className="mt-2 text-xs font-bold text-amber-400 animate-pulse">{uploadProgress}</div>
                      )}
                    </div>
                  )}
                </div>

                {/* 4. ÖRNEK ALINACAK VİDEO / STİL (İSTEĞE BAĞLI LİNK VEYA AÇIKLAMA) */}
                <div>
                  <label className="font-bold text-white/80">
                    Örnek Alınacak Stil veya Video Linki <span className="text-white/40 font-normal">(İsteğe Bağlı)</span>
                  </label>
                  <input
                    type="text"
                    value={sampleLink}
                    onChange={(e) => setSampleLink(e.target.value)}
                    placeholder="Örn: https://tiktok.com/@... veya beğendiğiniz bir kurgu linki"
                    className="mt-2 w-full rounded-2xl border border-white/15 bg-black/60 p-3.5 text-sm text-white outline-none focus:border-amber-400"
                  />
                  <span className="text-xs text-white/45 mt-1 block">
                    Beğendiğiniz bir TikTok/Reels kurgusu veya örnek video varsa linkini buraya ekleyebilirsiniz.
                  </span>
                </div>

                {/* 5. İLETİŞİM TELEFONU / WHATSAPP */}
                <div>
                  <label className="font-bold text-white/80">
                    İletişim Telefonu / WhatsApp <span className="text-white/40 font-normal">(İsteğe Bağlı)</span>
                  </label>
                  <input
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="05XX XXX XX XX"
                    className="mt-2 w-full rounded-2xl border border-white/15 bg-black/60 p-3.5 text-sm text-white outline-none focus:border-amber-400"
                  />
                </div>

                {/* 6. ÖZEL İSTEKLER VE NOTLAR */}
                <div>
                  <label className="font-bold text-white/80">Özel İstekleriniz & Kurgucuya Notlar</label>
                  <textarea
                    rows={4}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Örn: 01:20'deki Aslan hediyesini ve @destekci ismini öne çıkarın, hareketli Türkçe altyazı ve zafer müziği ekleyin..."
                    className="mt-2 w-full rounded-2xl border border-white/15 bg-black/60 p-3.5 text-sm text-white outline-none focus:border-amber-400 resize-none"
                  />
                </div>

                {/* 7. ÖZEL FİYAT VE TESLİMAT BİLGİ KUTUSU */}
                <div className="rounded-2xl border border-amber-500/25 bg-black/50 p-4 sm:p-5 flex items-center justify-between">
                  <div>
                    <div className="text-xs text-white/50">Fiyatlandırma Durumu:</div>
                    <div className="text-base font-black text-yellow-400">Wolf Yayıncılarına Özel İndirimli</div>
                    <div className="text-xs text-white/40">Talep incelenip teklif iletilecektir</div>
                  </div>
                  <div className="text-right">
                    <div className="text-xs text-white/50">Tahmini Teslimat:</div>
                    <div className="text-sm font-bold text-white">⚡ {selectedService.delivery}</div>
                  </div>
                </div>

                {/* 8. BUTONLAR */}
                <div className="flex justify-end gap-3 pt-4 border-t border-white/10">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="rounded-xl border border-white/10 px-6 py-3 text-sm font-bold text-white/60 hover:text-white"
                  >
                    İptal
                  </button>
                  <button
                    type="submit"
                    disabled={submitting}
                    className="rounded-xl bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-500 px-7 py-3 text-sm font-black text-black shadow-lg hover:brightness-110 disabled:opacity-50"
                  >
                    {submitting ? "İletiliyor..." : "🚀 Talebi Zakan Bilişim'e İlet"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* 🎬 7. VİDEO ÖNİZLEME MODALI */}
      {previewSample && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={() => setPreviewSample(null)}>
          <div className="relative w-full max-w-md overflow-hidden rounded-3xl border border-amber-500/40 bg-black shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b border-white/10">
              <div className="font-black text-sm text-yellow-400 truncate">{previewSample.title}</div>
              <button type="button" onClick={() => setPreviewSample(null)} className="text-white/60 hover:text-white">✕</button>
            </div>

            <div className="relative aspect-[9/16] w-full bg-black">
              <iframe
                src={`https://www.youtube.com/embed/${previewSample.youtubeId}?rel=0&modestbranding=1&autoplay=1`}
                title={previewSample.title}
                className="h-full w-full border-0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>

            <div className="p-4 flex items-center justify-between">
              <span className="text-xs text-white/60">{previewSample.serviceName}</span>
              <button
                type="button"
                onClick={() => {
                  const s = previewSample;
                  setPreviewSample(null);
                  const allServices = Object.values(WCS_SERVICES_DATA).flat();
                  const matchedPkg = allServices.find(p => p.id === s.serviceId) || currentServices[0];
                  handleOpenRequestModal(matchedPkg, s.title);
                }}
                className="rounded-xl bg-yellow-500 px-4 py-2 text-xs font-black text-black shadow-md hover:bg-yellow-400"
              >
                ✨ Bu Tarzda İstiyorum
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

function Badge({ label, value }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-yellow-500/25 bg-black/50 px-3.5 py-1 text-xs font-semibold text-white/80 shadow-sm backdrop-blur-md">
      <span className="text-yellow-400/90 font-bold">{label}</span>
      {value !== undefined && value !== null && value !== "" && (
        <span className="text-white font-black"><NoTranslate>{value}</NoTranslate></span>
      )}
    </span>
  );
}

function MessagesPage({
  managerInfo,
  messageSubject,
  setMessageSubject,
  messageText,
  setMessageText,
  handleSendMessage,
  allMessages = [],
  activeGiftWinnerId,
  giftPlanDay,
  setGiftPlanDay,
  giftPlanTime,
  setGiftPlanTime,
  giftPlanNote,
  setGiftPlanNote,
}) {
  return (
    <Panel title="Yönetici Mesajları" icon="✉">
      <div className="grid gap-5 xl:grid-cols-[.85fr_1.15fr]">
        <div className="rounded-[1.4rem] border border-yellow-500/20 bg-yellow-500/10 p-5">
          <div className="text-[11px] font-black uppercase tracking-[0.28em] text-yellow-300">
            Yöneticin
          </div>
          <div className="mt-3 text-xl font-black text-white">
            {managerInfo?.name || "Yönetici atanmadı"}
          </div>
          <div className="mt-2 text-sm text-white/50">
            Kullanıcı: {managerInfo?.username || "-"}
          </div>
          <div className="mt-1 text-sm text-white/50">
            Telefon: {managerInfo?.phone || "-"}
          </div>
        </div>

        <div className="rounded-[1.4rem] border border-white/10 bg-black/30 p-5">
          <div className="mb-4 text-[11px] font-black uppercase tracking-[0.24em] text-yellow-300">
            Yeni Mesaj Gönder
          </div>
          <input
            value={messageSubject}
            onChange={(event) => setMessageSubject(event.target.value)}
            placeholder="Konu"
            className="h-12 w-full rounded-2xl border border-white/10 bg-black/45 px-4 text-sm text-white outline-none placeholder:text-white/30 focus:border-yellow-500/40"
          />
          <textarea
            value={messageText}
            onChange={(event) => setMessageText(event.target.value)}
            rows={5}
            placeholder="Mesajınızı yazın..."
            className="mt-3 w-full resize-none rounded-2xl border border-white/10 bg-black/45 px-4 py-3 text-sm text-white outline-none placeholder:text-white/30 focus:border-yellow-500/40"
          />
          {activeGiftWinnerId && (
            <div className="mt-3 rounded-2xl border border-yellow-500/25 bg-yellow-500/10 p-4">
              <div className="mb-3 text-[11px] font-black uppercase tracking-[0.22em] text-yellow-300">Hediye Planlama Bilgisi</div>
              <div className="grid gap-3 sm:grid-cols-2">
                <label className="block">
                  <span className="mb-1 block text-xs font-bold text-white/45">Uygun Gün</span>
                  <select value={giftPlanDay} onChange={(event) => setGiftPlanDay(event.target.value)} className="h-11 w-full rounded-xl border border-white/10 bg-black/55 px-3 text-sm text-white outline-none [color-scheme:dark]">
                    <option value="">Gün seç</option>
                    <option value="Pazartesi">Pazartesi</option>
                    <option value="Salı">Salı</option>
                    <option value="Çarşamba">Çarşamba</option>
                    <option value="Perşembe">Perşembe</option>
                    <option value="Cuma">Cuma</option>
                    <option value="Cumartesi">Cumartesi</option>
                    <option value="Pazar">Pazar</option>
                  </select>
                </label>
                <label className="block">
                  <span className="mb-1 block text-xs font-bold text-white/45">Uygun Saat</span>
                  <select value={giftPlanTime} onChange={(event) => setGiftPlanTime(event.target.value)} className="h-11 w-full rounded-xl border border-white/10 bg-black/55 px-3 text-sm text-white outline-none [color-scheme:dark]">
                    <option value="">Saat seç</option>
                    <option value="10:00 - 12:00">10:00 - 12:00</option>
                    <option value="12:00 - 14:00">12:00 - 14:00</option>
                    <option value="14:00 - 16:00">14:00 - 16:00</option>
                    <option value="16:00 - 18:00">16:00 - 18:00</option>
                    <option value="18:00 - 20:00">18:00 - 20:00</option>
                    <option value="20:00 - 22:00">20:00 - 22:00</option>
                  </select>
                </label>
              </div>
              <textarea value={giftPlanNote} onChange={(event) => setGiftPlanNote(event.target.value)} rows={2} placeholder="Ek not" className="mt-3 w-full resize-none rounded-xl border border-white/10 bg-black/55 px-3 py-2 text-sm text-white outline-none placeholder:text-white/30" />
            </div>
          )}
          <div className="mt-3 flex justify-end">
            <button
              type="button"
              onClick={handleSendMessage}
              className="rounded-2xl bg-yellow-500 px-6 py-3 text-sm font-black text-black transition hover:bg-yellow-300"
            >
              Mesaj Gönder
            </button>
          </div>
        </div>
      </div>

      <div className="mt-5 overflow-hidden rounded-[1.4rem] border border-white/10 bg-black/30">
        <div className="border-b border-white/10 bg-white/[0.04] px-5 py-4 text-sm font-black text-white">
          Mesaj Geçmişi
        </div>
        {allMessages.length === 0 ? (
          <div className="p-5 text-sm text-white/45">Henüz mesaj bulunmuyor.</div>
        ) : (
          <div className="divide-y divide-white/10">
            {allMessages.map((message, index) => (
              <div key={message.id || index} className="p-5">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div className="font-black text-white">{message.subject || "Mesaj"}</div>
                  <div className="text-xs text-white/35">{message.date || message.created_at || "-"}</div>
                </div>
                <div className="mt-1 text-xs font-bold text-yellow-300/80">{message.from || "Yönetici"}</div>
                <p className="mt-3 whitespace-pre-wrap text-sm leading-6 text-white/62">{message.message || "-"}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </Panel>
  );
}

function FaqPanel({
  faqSearch,
  setFaqSearch,
  filteredFaqs = [],
  showAllFaq,
  setShowAllFaq,
  faqLoading,
  faqError,
}) {
  const visibleFaqs = showAllFaq ? filteredFaqs : filteredFaqs.slice(0, 8);

  return (
    <Panel title="Sık Sorulan Sorular" icon="?">
      <div className="mb-5 rounded-[1.35rem] border border-white/10 bg-black/25 p-4">
        <input
          value={faqSearch}
          onChange={(event) => setFaqSearch(event.target.value)}
          placeholder="Soru veya cevap içinde ara..."
          className="h-12 w-full rounded-2xl border border-white/10 bg-black/45 px-4 text-sm text-white outline-none placeholder:text-white/30 focus:border-yellow-500/40"
        />
      </div>

      {faqLoading && (
        <div className="rounded-2xl border border-white/10 bg-black/25 p-5 text-sm text-white/45">
          Sorular yükleniyor...
        </div>
      )}

      {faqError && (
        <div className="rounded-2xl border border-red-500/20 bg-red-500/10 p-5 text-sm text-red-200">
          {faqError}
        </div>
      )}

      {!faqLoading && !faqError && visibleFaqs.length === 0 && (
        <div className="rounded-2xl border border-white/10 bg-black/25 p-5 text-sm text-white/45">
          Soru bulunamadı.
        </div>
      )}

      <div className="space-y-3">
        {visibleFaqs.map((item, index) => {
          const question = item.q || item.question || item.title || "Soru";
          const answer = item.a || item.answer || item.description || "Cevap bulunmuyor.";

          return (
            <details key={item.id || index} className="group rounded-2xl border border-white/10 bg-black/30 p-4 open:border-yellow-500/25 open:bg-yellow-500/10">
              <summary className="cursor-pointer list-none font-black text-white">
                {question}
              </summary>
              <p className="mt-3 whitespace-pre-wrap text-sm leading-7 text-white/60">
                {answer}
              </p>
            </details>
          );
        })}
      </div>

      {filteredFaqs.length > 8 && (
        <button
          type="button"
          onClick={() => setShowAllFaq((prev) => !prev)}
          className="mt-5 rounded-2xl border border-yellow-500/25 bg-yellow-500/10 px-5 py-3 text-sm font-bold text-yellow-200 transition hover:bg-yellow-500 hover:text-black"
        >
          {showAllFaq ? "Daha Az Göster" : "Tümünü Göster"}
        </button>
      )}
    </Panel>
  );
}

function Panel({ title, icon, children }) {
  return (
    <div className="rounded-[1.8rem] border border-white/10 bg-white/[0.035] p-5 shadow-[0_18px_60px_rgba(0,0,0,.25)]">
      <div className="mb-4 flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-2xl border border-yellow-500/25 bg-yellow-500/10 text-yellow-300"><Icon>{icon}</Icon></div>
        <h2 className="text-xl font-black text-white">{title}</h2>
      </div>
      {children}
    </div>
  );
}

function MetricCard({ title, value, note }) {
  return <div className="rounded-[1.1rem] border border-white/10 bg-black/20 p-4 shadow-[0_10px_30px_rgba(0,0,0,.2)]"><div className="text-sm font-semibold text-yellow-300">{title}</div><div className="mt-3 text-2xl font-semibold text-white">{value}</div><div className="mt-2 text-xs text-white/42">{note}</div></div>;
}

function ProgressBlock({ title, percent, current, target }) {
  return <div className="rounded-[1.1rem] border border-white/10 bg-black/20 p-4"><div className="mb-3 flex items-center justify-between gap-3"><div className="text-sm font-semibold text-white/85">{title}</div><div className="text-xs font-semibold text-yellow-300">%{percent}</div></div><div className="h-2 overflow-hidden rounded-full bg-white/10"><div className="h-full rounded-full bg-yellow-500" style={{ width: `${percent}%` }} /></div><div className="mt-3 flex items-center justify-between text-xs text-white/48"><span>{current}</span><span>Hedef: {target}</span></div></div>;
}
